const messages = {
  pt: {
    translations: {
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English"
      },
      common: {
        all: "Todos",
        actions: "Ações",
        edit: "Editar",
        delete: "Excluir",
        cancel: "Cancelar",
        save: "Salvar",
        close: "Fechar",
        refresh: "Atualizar",
        refreshing: "Atualizando...",
        loading: "Carregando...",
        search: "Buscar",
        filter: "Filtrar",
        export: "Exportar",
        import: "Importar",
        add: "Adicionar",
        create: "Criar",
        update: "Atualizar",
        view: "Visualizar",
        details: "Detalhes",
        settings: "Configurações",
        test: "Testar",
        duplicate: "Duplicar",
        more: "Mais",
        yes: "Sim",
        no: "Não",
        confirm: "Confirmar",
        understood: "Entendi",
        rowsPerPage: "Linhas por página",
        displayedRows: "{{from}}-{{to}} de {{count}}"
      },
      backDrop: {
        loading: "Carregando..."
      },
      pwa: {
        install: "Instalar App (PWA)",
        installIOS: "Instalar no iOS",
        alreadyInstalled: "App já instalado",
        installSuccess: "App instalado com sucesso!",
        installCanceled: "Instalação cancelada",
        installError: "Erro ao instalar o app",
        notSupported: "Seu navegador não suporta instalação de PWA",
        ios: {
          title: "Instalar App no iOS",
          subtitle: "Siga os passos abaixo para adicionar este app à sua tela inicial",
          step1: {
            title: "Abra o menu de compartilhamento",
            description: "Toque no ícone de compartilhamento na barra inferior do Safari"
          },
          step2: {
            title: "Adicionar à Tela Inicial",
            description: "Role para baixo e toque em 'Adicionar à Tela Inicial'"
          },
          step3: {
            title: "Pronto!",
            description: "O app aparecerá na sua tela inicial como um app nativo"
          },
          note: "Este recurso está disponível apenas no navegador Safari do iOS"
        }
      },
      plans: {
        title: "Gerenciar Planos",
        subtitle: "Configure e gerencie os planos disponíveis para sua empresa",
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "$",
          public: "Público",
          trial: "Trial",
          trialDays: "Dias Trial",
          whatsappCatalog: "Catálogo WhatsApp"
        },
        cards: {
          edit: "Editar Plano",
          featured: "Destaque",
          popular: "Popular",
          trial: "Trial Grátis",
          perMonth: "/mês",
          features: "Recursos Incluídos",
          limits: "Limites do Plano",
          channels: "Canais de Comunicação",
          integrations: "Integrações",
          advanced: "Recursos Avançados",
          userLimit: "usuários",
          connectionLimit: "conexões",
          queueLimit: "filas",
          trialDaysLabel: "dias de teste",
          publicPlan: "Plano Público",
          privatePlan: "Plano Privado",
          whatsapp: "WhatsApp",
          whatsappOfficial: "WhatsApp Oficial",
          facebook: "Facebook",
          instagram: "Instagram",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          kanban: "Kanban",
          openai: "Talk.Ai",
          groups: "Grupos",
          landingPages: "Landing Pages",
          webChat: "WebChat",
          assistants: "Assistentes",
          noPlans: "Nenhum plano encontrado",
          createFirst: "Crie seu primeiro plano usando o formulário acima"
        },
        modal: {
          createTitle: "Criar Novo Plano",
          editTitle: "Editar Plano",
          createSubtitle: "Configure os recursos e limites do novo plano",
          editSubtitle: "Modifique os recursos e configurações do plano",
          close: "Fechar",
          cancel: "Cancelar",
          save: "Salvar",
          delete: "Excluir",
          saving: "Salvando...",
          confirmDelete: "Tem certeza que deseja excluir este plano? Esta ação não pode ser desfeita."
        },
        table: {
          name: "Nome",
          users: "Usuários", 
          connections: "Conexões",
          queues: "Filas",
          amount: "Valor",
          features: "Recursos",
          actions: "Ações"
        },
        buttons: {
          add: "Adicionar Plano"
        }
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          ia: "IA",
          options: "Opções",
          plans: "Planos",
          helps: "Ajuda",
          companies: "Empresas",
          webchat: "WebChat",
          fiscal: "Configuração Fiscal",
          schedules: "Horários",
          interface: "Interface"
        },
        apollo: {
          sectionTitle: "Configuração Apollo.io para IA SDR",
          sectionDescription: "Configure o Apollo.io para descoberta automática de leads e enriquecimento. Necessário para recursos de IA SDR.",
          apiKey: "Chave API Apollo.io",
          apiKeyDescription: "Sua chave API do Apollo.io para descoberta e enriquecimento de leads",
          enableIntegration: "Habilitar Integração Apollo.io",
          enableDescription: "Habilitar Apollo.io para recursos de descoberta e enriquecimento de leads",
          monthlySearchLimit: "Limite Mensal de Buscas",
          monthlySearchDescription: "Número máximo de buscas permitidas por mês",
          monthlyEnrichmentLimit: "Limite Mensal de Enriquecimentos",
          monthlyEnrichmentDescription: "Número máximo de enriquecimentos permitidos por mês",
          defaultLocation: "Localização Padrão",
          defaultLocationDescription: "Localização padrão para busca de leads (ex: Brazil, United States)"
        },
        settings: {
          ia: {
            globalAiConfigTitle: "Configuração Global de IA",
            globalAiConfigDesc: "Configure as definições globais de inteligência artificial para toda a empresa. Estas configurações serão aplicadas a todos os assistentes que não possuam configuração específica.",
            openAiApiKey: "Chave da API OpenAI",
            openAiApiKeyDesc: "Insira sua chave de API da OpenAI para habilitar recursos de IA",
            apiKeyRequired: "Chave da API é obrigatória",
            invalidApiKeyFormat: "Formato inválido da chave API. Deve começar com 'sk-'",
            apiKeyValidatedSuccess: "Chave da API validada com sucesso! {models} modelos disponíveis.",
            apiKeyValidationError: "Erro ao validar a chave da API",
            invalidApiKey: "Chave da API inválida",
            rateLimitExceeded: "Limite de taxa excedido. Tente novamente mais tarde.",
            accessDenied: "Acesso negado. Verifique suas permissões.",
            networkError: "Erro de rede. Verifique sua conexão.",
            internalError: "Erro interno do servidor",
            networkConnectionError: "Erro de conexão de rede",
            validatingApiKey: "Validando chave da API",
            validKeySuccess: "Chave válida",
            modelsAvailable: "modelos disponíveis",
            validating: "Validando",
            validateKey: "Validar Chave",
            getApiKey: "Obter chave da API",
            defaultOpenAiModel: "Modelo OpenAI Padrão",
            defaultOpenAiModelDesc: "Modelo que será usado por padrão para gerar respostas",
            aiProvider: "Provedor de IA",
            aiProviderDesc: "Provedor de inteligência artificial a ser utilizado",
            autoShowSuggestions: "Sugestões Automáticas",
            autoShowSuggestionsDesc: "Exibir sugestões de resposta automaticamente durante as conversações",
            enableAudioTranscription: "Transcrição de Áudio",
            enableAudioTranscriptionDesc: "Habilitar transcrição automática de mensagens de voz",
            transcriptionModel: "Modelo de Transcrição",
            transcriptionModelDesc: "Modelo usado para transcrição de áudio",
            defaultTranscriptionLanguage: "Idioma Padrão",
            defaultTranscriptionLanguageDesc: "Idioma usado por padrão para transcrição",
            portuguese: "Português",
            english: "Inglês",
            spanish: "Espanhol",
            french: "Francês",
            german: "Alemão",
            italian: "Italiano",
            japanese: "Japonês",
            korean: "Coreano",
            chinese: "Chinês",
            autoDetect: "Detecção Automática",
            enableVoiceResponses: "Respostas por Voz",
            enableVoiceResponsesDesc: "Gerar respostas em áudio usando síntese de voz",
            defaultVoice: "Voz Padrão",
            defaultVoiceDesc: "Voz utilizada para gerar respostas em áudio",
            speechSpeed: "Velocidade da Fala",
            speechSpeedDesc: "Velocidade de reprodução das respostas em voz",
            enableGroupResume: "Resumo de Grupos",
            enableGroupResumeDesc: "Habilitar geração de resumos de conversas em grupos",
            summaryDefaultLanguage: "Idioma do Resumo",
            summaryDefaultLanguageDesc: "Idioma padrão para gerar resumos",
            summaryDefaultLength: "Tamanho do Resumo",
            summaryDefaultLengthDesc: "Tamanho padrão dos resumos gerados",
            includeParticipantStatsDefault: "Estatísticas de Participantes",
            includeParticipantStatsDefaultDesc: "Incluir estatísticas de participação nos resumos por padrão",
            defaultCreativity: "Criatividade Padrão",
            defaultCreativityDesc: "Nível de criatividade das respostas (temperatura)",
            conservative: "Conservador",
            balanced: "Equilibrado",
            creative: "Criativo",
            defaultMaxTokens: "Máximo de Tokens",
            defaultMaxTokensDesc: "Número máximo de tokens para respostas",
            configurationTipsTitle: "Dicas de Configuração",
            centralizedConfiguration: "Configuração Centralizada",
            centralizedConfigurationDesc: "Essas configurações são aplicadas globalmente em toda a empresa",
            openAiKey: "Chave OpenAI",
            openAiKeyDesc: "Obtenha sua chave em platform.openai.com/api-keys",
            recommendedModels: "Modelos Recomendados",
            recommendedModelsDesc: "GPT-4o para melhor qualidade, GPT-4o Mini para economia",
            voice: "Voz",
            voiceDesc: "Nova e Alloy são as vozes mais naturais",
            performance: "Performance",
            performanceDesc: "Menor temperatura = respostas mais consistentes",
            aiConfigurationActive: "Configuração de IA Ativa",
            currentAiSettings: "Configurações atuais: Modelo {model}, Transcrição {transcription}, Voz {voice}, Sugestões {suggestions}",
            enabled: "Habilitado",
            disabled: "Desabilitado",
            aiNotConfiguredTitle: "IA Não Configurada",
            aiNotConfiguredDesc: "Configure uma chave da API OpenAI para habilitar recursos de inteligência artificial",
            copied: "Copiado",
            copyCode: "Copiar código QR PIX",
            short: "Curto",
            medium: "Médio",
            long: "Longo",
            portugueseBrazil: "Português (Brasil)",
            englishUS: "English (US)",
            spanishES: "Español"
          },
          options: {
            title: "Configurações do Sistema",
            description: "Configure as opções gerais de funcionamento do sistema",
            enabled: "Habilitado",
            disabled: "Desabilitado",
            updating: "Atualizando...",
            secure: "Seguro",
            generalSettings: "Configurações Gerais",
            paymentSettings: "Configurações de Pagamento",
            lgpdSettings: "Configurações LGPD",
            formattingSettings: "Configurações de Formatação",
            customMessages: "Mensagens Personalizadas",
            creationCompanyUser: "Criação de usuário da empresa",
            creationCompanyUserDesc: "Permitir que usuários da empresa criem outros usuários",
            evaluations: "Avaliações",
            evaluationsDesc: "Sistema de avaliação de atendimento pelos clientes",
            officeScheduling: "Agendamento por horários de funcionamento",
            officeSchedulingDesc: "Controlar agendamentos baseado no horário de funcionamento",
            sendGreetingAccepted: "Envio de saudação de aceite",
            sendGreetingAcceptedDesc: "Enviar mensagem automática quando aceitar um atendimento",
            userRandom: "Usuário aleatório",
            userRandomDesc: "Distribuir atendimentos aleatoriamente entre usuários disponíveis",
            acceptCallWhatsapp: "Aceitar chamadas no WhatsApp",
            acceptCallWhatsappDesc: "Permitir recebimento de chamadas telefônicas pelo WhatsApp",
            sendSignMessage: "Envio de mensagem de assinatura",
            sendSignMessageDesc: "Enviar mensagem de assinatura no final do atendimento",
            sendGreetingMessageOneQueues: "Envio de saudação em filas únicas",
            sendGreetingMessageOneQueuesDesc: "Enviar mensagem de saudação quando há apenas uma fila",
            sendQueuePosition: "Envio de posição na fila",
            sendQueuePositionDesc: "Informar posição do cliente na fila de atendimento",
            sendFarewellWaitingTicket: "Envio de despedida em espera",
            sendFarewellWaitingTicketDesc: "Enviar mensagem de despedida quando ticket fica em espera",
            acceptAudioMessageContact: "Aceitar mensagens de áudio de contatos",
            acceptAudioMessageContactDesc: "Permitir recebimento de mensagens de áudio de contatos",
            settingsTransfTicket: "Configurações de transferência de ticket",
            settingsTransfTicketDesc: "Habilitar configurações avançadas para transferência de tickets",
            chatBotType: "Tipo de chatbot",
            chatBotTypeDesc: "Configurar tipo de resposta do chatbot (texto ou voz)",
            informarValorVenda: "Finalização com valor de venda",
            informarValorVendaDesc: "Habilitar informação de valor de venda ao finalizar atendimento",
            queueManagement: "Gerenciamento por filas",
            companyManagement: "Gerenciamento por empresa",
            connectionManagement: "Gerenciamento por conexão",
            textOnly: "Apenas texto",
            voiceAndText: "Voz e texto",
            efiClientId: "EFI Client ID",
            efiClientIdDesc: "ID do cliente para integração com EFI Pay",
            efiClientSecret: "EFI Client Secret",
            efiClientSecretDesc: "Chave secreta para integração com EFI Pay",
            mpAccessToken: "Mercado Pago Access Token",
            mpAccessTokenDesc: "Token de acesso para integração com Mercado Pago",
            asaasToken: "Asaas Token",
            asaasTokenDesc: "Token de acesso para integração com Asaas",
            enableLGPD: "Habilitar LGPD",
            enableLGPDDesc: "Ativar conformidade com a Lei Geral de Proteção de Dados",
            lgpdMessage: "Mensagem LGPD",
            lgpdMessageDesc: "Mensagem de consentimento LGPD enviada aos usuários",
            lgpdLink: "Link da Política de Privacidade",
            lgpdLinkDesc: "URL da política de privacidade da empresa",
            systemCurrency: "Moeda do Sistema",
            systemCurrencyDesc: "Moeda padrão utilizada no sistema",
            systemDateFormat: "Formato de Data",
            systemDateFormatDesc: "Formato de exibição de datas no sistema",
            systemSettings: "Configurações do Sistema",
            requiredTag: "Tag obrigatória",
            requiredTagDesc: "Exigir seleção de tag para finalizar atendimentos",
            closeTicketOnTransfer: "Fechar ticket ao transferir",
            closeTicketOnTransferDesc: "Encerrar automaticamente o ticket ao transferir para outro setor",
            directTicketsToWallets: "Direcionar tickets para carteiras",
            directTicketsToWalletsDesc: "Usar sistema de carteiras de clientes para distribuição de tickets",
            copyContactPrefix: "Prefixo para cópia de contatos",
            copyContactPrefixDesc: "Sigla adicionada ao copiar informações de contatos",
            showNotificationPending: "Notificação de tickets pendentes",
            showNotificationPendingDesc: "Exibir notificações para tickets em status pendente",
            alwaysSelectQueueOnAccept: "Sempre selecionar fila ao aceitar ticket",
            alwaysSelectQueueOnAcceptDesc: "Quando habilitado, sempre exigirá seleção de fila ao aceitar tickets, mesmo que já tenha uma fila atribuída",
            openAiToken: "Token OpenAI",
            openAiTokenDesc: "Token de acesso para integração com OpenAI para transcrição de áudio",
            transferMessage: "Mensagem de Transferência",
            transferMessageDesc: "Mensagem enviada quando um atendimento é transferido",
            greetingAcceptedMessage: "Mensagem de Aceite",
            greetingAcceptedMessageDesc: "Mensagem enviada quando um atendimento é aceito",
            greetingMessageOneQueuesMessage: "Mensagem de Saudação (Fila Única)",
            greetingMessageOneQueuesMessageDesc: "Mensagem enviada automaticamente quando há apenas uma fila disponível",
            acceptCallWhatsappMessage: "Mensagem de Aviso sobre Chamadas",
            acceptCallWhatsappMessageDesc: "Mensagem informativa sobre chamadas telefônicas no WhatsApp",
            sendQueuePositionMessage: "Mensagem de Posição na Fila",
            sendQueuePositionMessageDesc: "Mensagem informando a posição do cliente na fila de atendimento",
            success: "Sucesso",
            error: "Erro",
            updateSuccess: "Configuração atualizada com sucesso!",
            updateError: "Erro ao atualizar configuração. Tente novamente.",
            currencyUpdateSuccess: "Moeda atualizada com sucesso!",
            dateFormatUpdateSuccess: "Formato de data atualizado com sucesso!",
            efiChavePix: "Chave PIX EFI",
            efiChavePixDesc: "Chave PIX cadastrada na conta EFI Pay",
            stripePrivateKey: "Chave Privada Stripe",
            stripePrivateKeyDesc: "Chave privada para integração com Stripe",
            lgpdDeleteMessage: "Deletar mensagem após consentimento",
            lgpdDeleteMessageDesc: "Apagar mensagem do cliente após aceitar LGPD",
            lgpdConsent: "Exigir consentimento LGPD",
            lgpdConsentDesc: "Solicitar consentimento explícito do cliente para LGPD",
            lgpdHideNumber: "Ocultar número do contato",
            lgpdHideNumberDesc: "Ocultar números de telefone para conformidade com LGPD"
          },
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado"
            }
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage:
              "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            greetingMessageOneQueuesMessage: "Mensagem de Saudação (Fila Única)",
            transferMessage:
              `Mensagem de transferência - \${queue.name} = fila destino`,
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que não aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket:
              "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer:
              "Fechar ticket ao transferir para outra fila",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para carteira",
            showNotificationPending:
              "Mostrar notificação para tickets pendentes",
            copyContactPrefix: "Sigla para Cópia de Contatos",
            copyContactPrefixPlaceholder: "Ex: COPIA_"
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado"
          },
          formatting: {
            systemCurrency: "Moeda do Sistema",
            systemCurrencyHelp: "Define a moeda utilizada em todo o sistema",
            systemDateFormat: "Formato de Data",
            systemDateFormatHelp: "Define como as datas são exibidas no sistema",
            updating: "Atualizando...",
            currencyUpdatedSuccess: "Moeda atualizada com sucesso!",
            currencyUpdateError: "Erro ao atualizar moeda",
            dateFormatUpdatedSuccess: "Formato de data atualizado com sucesso!",
            dateFormatUpdateError: "Erro ao atualizar formato de data"
          }
        },
        webchat: {
          title: "Configuração do WebChat",
          tabs: {
            appearance: "Aparência",
            behavior: "Comportamento",
            files: "Arquivos",
            code: "Código",
            customization: "Personalização"
          },
          form: {
            enabled: "WebChat Habilitado",
            widgetColor: "Cor do Widget",
            widgetPosition: "Posição",
            widgetTitle: "Título do Widget",
            widgetDescription: "Descrição",
            welcomeMessage: "Mensagem de Boas-vindas",
            messagePlaceholder: "Placeholder da Mensagem",
            customCSS: "CSS Personalizado",
            autoAssign: "Atribuição Automática de Atendentes",
            queueId: "Fila Padrão",
            respectBusinessHours: "Respeitar Horário Comercial",
            maxConcurrentChats: "Máximo de Chats Simultâneos",
            offlineMessage: "Mensagem Fora do Horário",
            showAgentInfo: "Exibir Informações do Agente",
            allowFileUpload: "Permitir Upload de Arquivos",
            allowedFileTypes: "Tipos de Arquivo Permitidos",
            maxFileSize: "Tamanho Máximo (MB)",
            requireName: "Nome Obrigatório",
            requireEmail: "Email Obrigatório",
            requirePhone: "Telefone Obrigatório",
            enableAssistant: "Habilitar Assistente de IA",
            assistantId: "Assistente de IA",
            companyName: "Nome da Empresa",
            companyUrl: "URL da Empresa",
            companyLogoUrl: "URL do Logo da Empresa",
            createTitle: "Criar WebChat",
            editTitle: "Editar WebChat",
            name: "Nome do WebChat",
            namePlaceholder: "Ex: Site Principal, Landing Page, Blog",
            allowedOrigins: "Origens Permitidas",
            allowedOriginsPlaceholder: "https://seusite.com\nhttps://www.seusite.com\n*.seusite.com",
            allowedOriginsHelp: "Uma URL por linha. Use * para subdomínios. Deixe vazio para permitir todas."
          },
          positions: {
            right: "Direita",
            left: "Esquerda"
          },
          placeholders: {
            widgetColor: "#2563eb",
            widgetTitle: "Atendimento",
            widgetDescription: "Estamos aqui para ajudar!",
            welcomeMessage: "Olá! Como posso ajudá-lo?",
            messagePlaceholder: "Digite sua mensagem...",
            offlineMessage: "Nosso horário de atendimento é de segunda a sexta, das 8h às 18h.",
            allowedFileTypes: "jpg,jpeg,png,pdf,doc,docx",
            customCSS: "/* Adicione seus estilos CSS personalizados aqui */"
          },
          help: {
            allowedFileTypes: "Separe por vírgula (ex: jpg,png,pdf)",
            customCSS: "CSS personalizado para estilizar o widget",
            maxFileSize: "Tamanho máximo em MB",
            noAssistants: "Nenhum assistente ativo encontrado. Configure assistentes em Configurações → IA."
          },
          validation: {
            nameRequired: "Nome é obrigatório",
            invalidOrigins: "Uma ou mais origens possuem formato inválido. Use http://, https:// ou *.",
            required: "Obrigatório",
            colorFormat: "Cor deve estar no formato hexadecimal",
            maxLength: "Máximo {max} caracteres",
            maxValue: "Máximo {max}",
            positive: "Valor deve ser positivo",
            assistantRequired: "Selecione um assistente quando o atendimento por IA estiver ativado"
          },
          messages: {
            createSuccess: "WebChat criado com sucesso!",
            updateSuccess: "WebChat atualizado com sucesso!",
            created: "Criado",
            updated: "Atualizado",
            saveToGetCode: "Salve o WebChat para obter o código de integração",
            success: "Configuração salva com sucesso!",
            noQueue: "Sem fila específica",
            loadingAssistants: "Carregando assistentes...",
            selectAssistant: "Selecione um assistente"
          },
          code: {
            title: "Código de Integração",
            description: "Copie e cole este código no seu site onde deseja que o widget apareça:",
            copyButton: "Copiar Código",
            manualInit: "Ou inicialize manualmente"
          },
          buttons: {
            save: "Salvar Configurações",
            cancel: "Cancelar"
          },
          requiredFields: "Campos Obrigatórios",
          preview: {
            poweredBy: "Desenvolvido por"
          },
          list: {
            title: "WebChats",
            newWebChat: "Novo WebChat",
            name: "Nome",
            status: "Status",
            token: "Token",
            allowedOrigins: "Origens Permitidas",
            actions: "Ações",
            enabled: "Ativo",
            disabled: "Inativo",
            copyToken: "Copiar Token",
            copyCode: "Copiar Código",
            edit: "Editar",
            delete: "Excluir",
            tokenCopied: "Token copiado!",
            codeCopied: "Código copiado!",
            loading: "Carregando...",
            noWebChats: "Nenhum WebChat criado",
            allOrigins: "Todas",
            deleteConfirmTitle: "Excluir WebChat",
            deleteConfirmMessage: "Tem certeza que deseja excluir o WebChat '{name}'?",
            deleteSuccess: "WebChat excluído com sucesso!"
          }
        },
        interface: {
          title: "Configurações de Interface",
          description: "Personalize a aparência da interface de tickets para sua empresa",
          showTabLabels: "Mostrar rótulos das abas",
          showTabLabelsDescription: "Exibe o texto descritivo nas abas de tickets (Abertas, Pendentes, Resolvidas)",
          showTabBadges: "Mostrar contadores nas abas",
          showTabBadgesDescription: "Exibe o número de tickets em cada aba",
          showActionButtons: "Mostrar botões de ação",
          showActionButtonsDescription: "Exibe botões de ação rápida nos tickets",
          enableFiltersSection: "Habilitar seção de filtros",
          enableFiltersSectionDescription: "Exibe a seção de filtros avançados na interface de tickets"
        }
      },
      timeMonitoring: {
        title: "Monitoramento de Tempo de Resposta",
        enabled: "Monitoramento Ativado",
        responseTimeLimit: "Limite de Tempo de Resposta (minutos)",
        timeoutAction: "Ação ao Atingir Timeout",
        timeoutActions: {
          user: "Transferir para usuário específico",
          queue: "Transferir para fila específica"
        },
        targetUser: "Usuário de destino",
        targetQueue: "Fila de destino",
        warning: {
          enabled: "Avisos antes do timeout",
          minutes: "Minutos antes do aviso"
        },
        timer: {
          title: "Tempo de Resposta",
          timeRemaining: "restantes",
          timeLimit: "Limite",
          timeElapsed: "Tempo esgotado!",
          warning: "Aviso",
          minimizeTimer: "Minimizar timer",
          maximizeTimer: "Maximizar timer",
          minutes: "minutos",
          status: {
            timeout: "Tempo esgotado!",
            warning: "{minutes}min restantes",
            normal: "{minutes}min restantes"
          }
        },
        description: "Configure monitoramento de tempo de resposta e limites de tickets por usuário",
        disabled: "Desabilitado",
        updating: "Atualizando...",
        loading: "Carregando configurações...",
        save: "Salvar",
        saving: "Salvando...",
        reset: "Resetar",
        basicSettings: "Configurações Básicas",
        enableMonitoring: "Habilitar monitoramento de tempo",
        enableMonitoringDesc: "Ativar monitoramento automático de tempo de resposta dos atendimentos",
        responseTimeLimitDesc: "Define o tempo máximo de resposta antes de acionar ações automáticas",
        responseLimitHelper: "Tempo máximo para resposta antes da ação automática (entre 1-480 minutos)",
        monitoringScope: "Escopo do monitoramento",
        monitoringScopeDesc: "Defina se o monitoramento será aplicado por empresa ou por fila/conexão",
        scopeCompany: "Por empresa",
        scopeQueue: "Por fila/conexão",
        warningSettings: "Configurações de Aviso",
        enableWarning: "Enviar aviso antes do timeout",
        enableWarningDesc: "Ativar alertas visuais antes do tempo limite ser atingido",
        warningMinutes: "Minutos antes do timeout para aviso",
        warningMinutesDesc: "Tempo de antecedência para exibir avisos antes do timeout",
        warningMinutesHelper: "Avisos serão exibidos X minutos antes do timeout (entre 1-60 minutos)",
        timeoutActionLabel: "Ação quando atingir tempo limite",
        timeoutActionDesc: "Selecione a ação automática a ser executada quando o tempo limite for excedido",
        transferToUser: "Transferir para usuário específico",
        transferToQueue: "Transferir para fila específica",
        targetUserDesc: "Selecione o usuário que receberá os tickets transferidos por timeout",
        selectUser: "Selecione um usuário",
        targetQueueDesc: "Selecione a fila que receberá os tickets transferidos por timeout",
        selectQueue: "Selecione uma fila",
        statistics: "Estatísticas",
        currentStats: "Estatísticas Atuais",
        activeTickets: "Tickets Ativos",
        avgResponseTime: "Tempo Médio de Resposta",
        timeouts: "Timeouts",
        successRate: "Taxa de Sucesso",
        ticketLimits: "Limite de Tickets por Usuário",
        enableTicketLimits: "Habilitar limite de tickets ativos",
        maxActiveTickets: "Máximo de tickets ativos por usuário",
        allowMultipleTickets: "Permitir aceitar múltiplos tickets",
        buttons: {
          save: "Salvar Configurações",
          saving: "Salvando...",
          cancel: "Cancelar"
        },
        messages: {
          saveTitle: "Configurações Salvas",
          saveSuccess: "Configurações salvas com sucesso!",
          loadError: "Erro ao carregar configurações de monitoramento de tempo",
          saveError: "Erro ao salvar configurações",
          ticketLimitReached: "Não é possível aceitar mais tickets",
          ticketLimitWarning: "Limite de tickets ativos atingido"
        },
        errors: {
          title: "Erro",
          loadData: "Erro ao carregar dados auxiliares"
        },
        userStatus: {
          title: "Status Atual",
          activeTickets: "Tickets ativos",
          limitReached: "Limite de tickets ativos atingido"
        },
        dashboard: {
          userActivity: {
            title: "Atividade dos Usuários",
            active: "Ativos",
            inactive: "Inativos",
            offline: "Offline",
            tickets: "Tickets",
            hideDetails: "Ocultar detalhes",
            showDetails: "Ver detalhes",
            inactiveFor: "Inativo há",
            userStatus: {
              active: "Ativo",
              inactive: "Inativo",
              offline: "Offline"
            }
          }
        }
      },
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          disabled:
            "Cadastro de usuários está desabilitado no momento. Por favor, tente novamente mais tarde.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
          accountCreated: "Conta Criada",
          signupError: "Erro no Cadastro",
          emailExists: "Email Já Existe",
          invalidData: "Dados Inválidos",
          signupDisabled: "Cadastro Desabilitado",
          documentValid: "Documento Válido",
          documentInvalid: "Documento Inválido",
          companyFound: "Empresa Encontrada",
          validationError: "Erro Validação",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          company: "Nome da Organização",
          phone: "Whatsapp (DDD + NÚMERO)",
          country: "Pais"
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!"
        },
      },
      ticketInfo: {
        copyPhone: "Copiar telefone",
        quickMessages: "Respostas rápidas",
        phonecopied: "Telefone copiado para área de transferência!",
        noPhone: "Nenhum telefone disponível para copiar",
        copyError: "Erro ao copiar telefone"
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
          button: "Acessar"
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!"
        }
      },
      companies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          folderSize: "Tamanho da pasta ",
          totalFiles: " Total de arquivos",
          lastUpdate: "Ultimo update",
          actions: "Ações",
          viewDetails: "Clique para ver detalhes completos",
          money: "$",
          yes: "Sim",
          no: "Não",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
          generateInvoice: "Gerar Fatura"
        },
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!"
        }
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          chatsTempoReal: "Painel",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          contacts: "Contatos",
          wallets: "Carteiras",
          landingPages: "Landing Pages",
          groups: "Grupos",
          assistants: "Assistentes IA",
          queues: "Filas & Chatbot",
          tags: "Tags",
          administration: "Administração",
          companies: "Empresas",
          users: "Usuários",
          settings: "Configurações",
          files: "Lista de arquivos",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Gerenciar conexões",
          reports: "Relatórios",
          management: "Gerência",
          utm: {
            generator: "Gerador de Links UTM",
            dashboard: "Dashboard UTM"
          }
        },
        search: {
          placeholder: "Buscar menu..."
        },
        mobile: {
          quickActions: "Ações rápidas",
          searchMenu: "Buscar no menu",
          expandSection: "Expandir seção",
          collapseSection: "Recolher seção"
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual"
          },
          language: "Idioma",
          volume: {
            on: "Som ativado",
            off: "Som desativado"
          },
          refresh: "Atualizar"
        },
        layoutSwitcher: {
          title: "Alternar Layout",
          subtitle: "Escolha o estilo de interface que preferir",
          currentLayout: "Layout Atual",
          switching: "Alterando Layout...",
          versions: {
            original: "Versão Original",
            v1_modern_sidebar: "Modern Sidebar",
            v2_top_navigation: "Top Navigation"
          },
          descriptions: {
            original: "Layout padrão do sistema",
            v1_modern_sidebar: "Sidebar moderna com visual atualizado",
            v2_top_navigation: "Navegação superior horizontal"
          },
          loading: "Carregando",
          error: "Erro: Layout não encontrado",
          beta: "BETA",
          new: "NEW"
        }
      },
      auth: {
        toasts: {
          loginSuccess: "Login Realizado",
          logoutSuccess: "Logout Efetuado",
          authError: "Erro de Autenticação",
          sessionExpired: "Sessão Expirada",
          subscriptionExpiring: "Assinatura Expirando",
          success: "Login realizado com sucesso!",
          fail: "Falha na validação de credenciais",
          badCredentials: "Usuário ou senha incorretos",
          suspended: "Usuário suspenso",
          disabled: "Usuário não possui permissão para acessar a plataforma",
          noCompany: "Usuário não está associado a uma empresa",
          connectionLost: "Conexão com o servidor perdida",
          connectionRestored: "Conexão com o servidor restaurada",
          logout: "Logout realizado com sucesso",
          token:
            "Token inválido, por favor entre em contato com o administrador da plataforma.",
        },
                errorBoundary: {
            title: "Ops! Algo deu errado",
            description: "Detectamos um problema com o carregamento dos dados. Isso pode acontecer devido a problemas temporários de conectividade ou dados inválidos retornados do servidor.",
            genericDescription: "Ocorreu um erro inesperado na aplicação. Tente recarregar a página ou fazer login novamente.",
            buttons: {
              reload: "Recarregar",
              login: "Fazer Login",
              showDetails: "Mostrar detalhes técnicos",
              hideDetails: "Ocultar detalhes"
            }
          },
          dueDate: {
            expiration: "Sua assinatura expira em",
            days: "dias!",
            day: "dia!",
            expirationToday: "Sua assinatura expira hoje!"
          },
          token: "Token",
        message: {
          location: "Localização",
          contact: "Contato"
        },
        notRegister: "Nenhum registro",
        refresh: "Atualizar"
      },
      aiSuggestions: {
        title: "Sugestões de IA",
        responseTitle: "Sugestões de Resposta",
        campaignTitle: "Sugestões de Campanha",
        groupSummaryTitle: "Resumo de Conversa",
        buttons: {
          generate: "Gerar Sugestões",
          refresh: "Atualizar",
          use: "Usar",
          copy: "Copiar",
          cancel: "Cancelar",
          close: "Fechar",
          feedback: "Avaliar",
          helpful: "Útil",
          notHelpful: "Não útil",
          used: "Utilizado",
          notUsed: "Não utilizado"
        },
        messages: {
          generating: "Gerando sugestões...",
          noSuggestions: "Nenhuma sugestão disponível",
          error: "Erro ao gerar sugestões",
          configError: "Configurações de IA não encontradas",
          feedbackSuccess: "Feedback registrado com sucesso",
          copied: "Copiado para área de transferência",
          used: "Sugestão aplicada",
          loading: "Carregando...",
          validatingConfig: "Validando configurações...",
          configValid: "Configurações válidas",
          configInvalid: "Configurações inválidas"
        },
        response: {
          contextLabel: "Contexto da conversa",
          suggestionsLabel: "Sugestões de resposta",
          confidence: "Confiança",
          noContext: "Sem contexto de conversa disponível",
          analyzing: "Analisando conversa...",
          selectSuggestion: "Selecione uma sugestão"
        },
        campaign: {
          nameLabel: "Nome da campanha",
          baseMessageLabel: "Mensagem base (opcional)",
          productServiceLabel: "Produto/Serviço",
          targetAudienceLabel: "Público-alvo",
          campaignGoalLabel: "Objetivo da campanha",
          toneLabel: "Tom da mensagem",
          additionalContextLabel: "Contexto adicional (opcional)",
          campaignTypeLabel: "Tipo de campanha",
          messageStyleLabel: "Estilo da mensagem",
          temperatureLabel: "Criatividade",
          maxTokensLabel: "Tamanho máximo",
          maxSuggestionsLabel: "Número de sugestões",
          languageLabel: "Idioma",
          modelLabel: "Modelo de IA",
          templates: {
            promotional: "Promocional",
            informational: "Informativa",
            engagement: "Engajamento",
            retention: "Retenção"
          },
          tones: {
            professional: "Profissional",
            casual: "Casual",
            promotional: "Promocional",
            empathetic: "Empático"
          },
          types: {
            promotional: "Promocional",
            informational: "Informativo",
            engagement: "Engajamento",
            retention: "Retenção"
          },
          styles: {
            persuasive: "Persuasivo",
            educational: "Educativo",
            conversational: "Conversacional",
            empathetic: "Empático"
          }
        },
        groupSummary: {
          groupLabel: "Grupo",
          periodLabel: "Período",
          generateSummary: "Gerar Resumo",
          summary: "Resumo da conversa",
          keyPoints: "Pontos principais",
          participants: "Participantes",
          messageCount: "Total de mensagens",
          timeRange: "Período analisado",
          noMessages: "Nenhuma mensagem encontrada no período selecionado",
          analyzing: "Analisando conversa do grupo..."
        },
        configuration: {
          title: "Configurações de IA",
          apiKey: "Chave da API OpenAI",
          model: "Modelo",
          temperature: "Temperatura",
          maxTokens: "Tokens máximos",
          provider: "Provedor",
          autoShow: "Mostrar sugestões automaticamente",
          enableFeedback: "Habilitar feedback",
          cacheResults: "Cache de resultados",
          validate: "Validar configurações",
          save: "Salvar configurações"
        }
      },
      dashboard: {
        title: "Dashboard",
        subtitle: "Acompanhe os principais indicadores e métricas do seu atendimento",
        sections: {
          indicators: "Indicadores",
          keyMetrics: "Indicadores Principais",
          userActivity: "Status dos Usuários",
          nps: "Pesquisa de Satisfação (NPS)",
          attendanceInfo: "Informações de Atendimento",
          ratingIndex: "Índice de Avaliação",
          attendants: "Atendentes",
          charts: "Análises Gráficas",
          realTime: "Atendimento em Tempo Real",
          performance: "Métricas de Desempenho",
          quality: "Métricas Críticas de Qualidade"
        },
        filters: {
          title: "Filtros",
          queue: "Fila",
          attendant: "Atendente",
          allQueues: "Todas as Filas",
          allAttendants: "Todos os Atendentes"
        },
        filter: "FILTRAR",
        buttons: {
          showFilters: "Filtros",
          hideFilters: "Ocultar Filtros",
          export: "Exportar",
          applying: "Aplicando...",
          loading: "Carregando...",
          filter: "Filtrar"
        },
        comparison: {
          enableComparison: "Comparar com período anterior",
          previous: "Anterior",
          vs: "vs",
          change: "Mudança",
          neutral: "Mudança neutra (< 5%)",
          improved: "Melhorou",
          worsened: "Piorou",
          updatedAgo: "Atualizado há {time}"
        },
        realtime: {
          autoRefresh: "Auto-atualização",
          enabled: "Ativado",
          disabled: "Desativado",
          lastUpdate: "Última atualização",
          secondsAgo: "{seconds}s atrás",
          minutesAgo: "{minutes}min atrás",
          justNow: "Agora mesmo"
        },
        alerts: {
          title: "Alertas do Dashboard",
          noAlerts: "Nenhum alerta ativo",
          viewDetails: "Ver Detalhes",
          severity: {
            high: "Alta",
            medium: "Média",
            low: "Baixa"
          },
          types: {
            abandonmentHigh: "Taxa de Abandono Alta",
            waitTimeHigh: "Tempo de Espera Alto",
            pendingHigh: "Muitos Tickets Pendentes",
            npsLow: "NPS Baixo"
          }
        },
        heatmap: {
          title: "Horários de Pico",
          subtitle: "Volume de tickets por hora e dia da semana",
          days: {
            0: "Domingo",
            1: "Segunda",
            2: "Terça",
            3: "Quarta",
            4: "Quinta",
            5: "Sexta",
            6: "Sábado"
          },
          legend: {
            low: "Baixo",
            medium: "Médio",
            high: "Alto",
            peak: "Pico"
          },
          tooltip: "{count} tickets em {day} às {hour}h"
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes"
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: "
          },
          timeline: "Evolução de Tickets",
          created: "Criados",
          resolved: "Resolvidos",
          pending: "Pendentes",
          date: "Data",
          quantity: "Quantidade",
          status: {
            title: "Distribuição por Status",
            happening: "Em Atendimento",
            pending: "Aguardando",
            finished: "Finalizados",
            tickets: "Tickets"
          },
          nps: {
            title: "NPS Score",
            promoters: "Promotores",
            passive: "Neutros",
            detractors: "Detratores",
            excellent: "Excelente",
            veryGood: "Muito Bom",
            good: "Razoável",
            needsImprovement: "Precisa Melhorar",
            critical: "Crítico"
          },
          channels: {
            title: "Tickets por Canal",
            channel: "Canal",
            quantity: "Quantidade",
            tickets: "Tickets",
            noData: "Sem Dados"
          }
        },
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "T.M. de Atendimento",
          averageWaitingTime: "T.M. de Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
          firstContactResolution: "Resolução no 1º Contato",
          avgFirstResponseTime: "T.M. Primeira Resposta",
          abandonmentRate: "Taxa de Abandono",
          reopenRate: "Taxa de Reabertura"
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuário",
          totalAttendances: "Total de atendimentos"
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final"
        },
        licence: {
          available: "Disponível até"
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de Avaliação",
          score: "Score",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores"
        },
        messages: {
          exportSuccess: "Relatório exportado com sucesso!",
          exportError: "Erro ao exportar relatório",
          loadError: "Erro ao carregar dados do dashboard",
          ticketsError: "Erro ao buscar informações dos tickets"
        },
        toasts: {
          titles: {
            dashboardUpdated: "Dashboard Atualizado",
            dataLoaded: "Dados Carregados",
            dataError: "Erro nos Dados"
          }
        }
      },
      groupSummaryModal: {
        title: {
          configure: "Configurar Resumo de Grupo",
          summary: "Resumo da Conversa"
        },
        subtitle: {
          configure: "Configure os parâmetros para gerar o resumo do grupo:",
          summary: "Resumo gerado com IA •"
        },
        period: {
          title: "Período do Resumo",
          date: "Data",
          customPeriod: "Usar período personalizado",
          startTime: "Horário Inicial",
          endTime: "Horário Final",
          fullDayInfo: "Será analisado o dia inteiro (00:00 às 23:59) da data selecionada."
        },
        autoSend: {
          title: "Envio Automático",
          toggle: "Enviar resumo automaticamente para o grupo",
          description: "A mensagem de resumo será enviada diretamente no grupo do WhatsApp",
          willSendTo: "O resumo será enviado para:"
        },
        advanced: {
          title: "Configurações Avançadas",
          language: "Idioma do Resumo",
          length: "Tamanho do Resumo",
          includeStats: "Incluir estatísticas de participantes"
        },
        languages: {
          portuguese: "Português (Brasil)",
          english: "English (US)",
          spanish: "Español"
        },
        lengths: {
          short: "Curto",
          medium: "Médio",
          long: "Longo"
        },
        validation: {
          validConfig: "✓ Configurações válidas",
          invalidConfig: "✗ Configurações inválidas",
          model: "Modelo:",
          apiKey: "Chave API: Configurada"
        },
        sendStatus: {
          sentSuccess: "Resumo enviado com sucesso!",
          sentTo: "A mensagem foi enviada para o grupo",
          generatedWithError: "Resumo gerado, mas houve erro no envio",
          autoSendEnabled: "Envio automático estava habilitado, mas não foi possível confirmar o status."
        },
        stats: {
          title: "📊 Estatísticas do Período",
          interactions: "interações",
          reactions: "reações",
          participants: "participantes",
          averagePerPerson: "média/pessoa"
        },
        readyMessage: {
          title: "📝 Mensagem Pronta para Envio"
        },
        sections: {
          topParticipants: "🏆 Top Participantes",
          mainTopics: "🔝 Principais Tópicos",
          keyDecisions: "✅ Decisões Tomadas",
          importantQuestions: "❓ Perguntas Importantes",
          nextActions: "🎯 Próximas Ações"
        },
        processingInfo: {
          title: "ℹ️ Informações do Processamento",
          model: "Modelo:",
          period: "Período:",
          time: "Tempo:",
          confidence: "Confiança:",
          sendStatus: "Envio:",
          sent: "✅ Enviado",
          failed: "❌ Falhou"
        },
        buttons: {
          cancel: "Cancelar",
          generate: "Gerar Resumo",
          generating: "Gerando Resumo...",
          back: "Voltar",
          copyFull: "Copiar Resumo Completo",
          copyMessage: "Copiar Mensagem",
          copyAlreadySent: "Copiar (Já Enviado)",
          close: "Fechar"
        },
        errors: {
          noAIConfig: "Configurações de IA não encontradas",
          aiConfigDescription: "Para usar a funcionalidade de resumo de grupos, é necessário que as configurações de IA estejam definidas.",
          invalidTicket: "Ticket inválido",
          invalidTicketDescription: "Este ticket não é válido para geração de resumo de grupo.",
          invalidAIConfig: "Configurações de IA inválidas.",
          invalidAPIKey: "Chave da OpenAI inválida.",
          invalidData: "Dados inválidos para gerar resumo",
          serviceUnavailable: "Serviço de IA temporariamente indisponível.",
          generateError: "Erro ao gerar resumo",
          copyError: "Erro ao copiar"
        },
        toasts: {
          titles: {
            summaryGenerated: "Resumo Gerado",
            summaryError: "Erro no Resumo",
            dataExported: "Dados Exportados"
          },
          messages: {
            generatedAndSent: "Resumo gerado e enviado para o grupo com sucesso!",
            generated: "Resumo gerado com sucesso!",
            generatedWithSendError: "Resumo gerado com sucesso, mas houve erro ao enviar:",
            messageCopied: "Mensagem pronta copiada para área de transferência!",
            fullSummaryCopied: "Resumo completo copiado!"
          }
        }
      },
      reports: {
        title: "Relatório de Pesquisas Realizadas",
        operator: "Operador",
        period: "Período",
        until: "Até",
        date: "Data",
        reportTitle: "Relatórios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "Duracão dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatório",
          back: "Voltar",
          groupServiceReport: "Relatório de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Última Atualização",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento"
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Relatório de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa"
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Duração do Atendimento",
          startService: "Início do atendimento",
          lastUpdated: "Última atualização",
          lastAgent: "Último atendente",
          durationFinished: "Duração após finalizado"
        },
        ticketDuration: {
          title: "Relatório de Duração dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "Duração dos finalizados",
          durationAfterFinished: "Duração após finalizado",
          actions: "Ações"
        },
        ticketReports: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Atendimento"
        },
        exportExcel: {
          title: "Relatórios de Atendimentos",
          startDate: "Data inicial",
          endDate: "Data final",
          notInformed: "Não informado",
          columns: {
            id: "ID",
            connection: "Conexão",
            contact: "Contato",
            user: "Usuário",
            queue: "Fila",
            status: "Status",
            lastMessage: "Última Mensagem",
            openDate: "Data Abertura",
            openTime: "Hora Abertura",
            closeDate: "Data Fechamento",
            closeTime: "Hora Fechamento",
            supportTime: "Tempo de Atendimento",
            nps: "NPS"
          }
        },
        pdf: {
          title: "Relação de Atendimentos Realizados",
          exportTitle: "Relação de Atendimentos em Grupos Realizados"
        }
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas"
      },
      contactImportWpModal: {
        title: "Exportar Contatos para o Excel",
        buttons: {
          downloadModel: "Download modelo do excel para importação",
          closed: "Fechar",
          import: "Selecione o arquivo do excel para importar Contatos"
        }
      },
      connections: {
        title: "Conexões",
        waitConnection: "Aguarde... Suas conexões serão reiniciadas!",
        newConnection: "Nova Conexão",
        restartConnections: "Reiniciar Conexões",
        callSupport: "Chamar Suporte",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
        client: "Cliente",
        connectedConnections: " Conexões conectadas ",
        disconnectedConnections: "Conexões desconectadas ",
        totalConnections: " Total de Conexões",
        total: "Total",
        connections: "Conexões de:",
        toasts: {
          deleted: "Conexão excluída com sucesso!",
          closedimported:
            "Estamos fechando os tickets importados, por favor aguarde uns instantes",
          titles: {
            connectionCreated: "Conexão Criada",
            qrGenerated: "QR Gerado",
            connectionRemoved: "Conexão Removida",
            connectionError: "Erro na Conexão"
          }
        },
        confirmationModal: {
          closedImportedTitle: "Fechar tickets importados",
          closedImportedMessage:
            "Se você confirmar todos os tickets importados serão fechados",
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          closedImported: "Fechar todos os tickets Importados",
          preparing: "Preparando mensagens para importação",
          importing: "Importando Mensagens do WhatsApp",
          processed: "Processado",
          in: "de",
          connecting: "Conectando"
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensagem"
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code"
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão"
          },
          connected: {
            title: "Conexão estabelecida!"
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code"
          }
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          number: "Número do Whatsapp",
          color: "Cor"
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente"
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato já está aguardando atendimento. Veja na aba Aguardando!"
        }
      },
      showTicketLogModal: {
        title: {
          header: "Logs"
        },
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu a fila.",
          closed: "fechou o ticket",
          reopen: "reabriu o ticket",
          redirect: "- redirecionado",
          clientClosed: "Cliente fechou o ticket"
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar Conexão",
          edit: "Editar Conexão"
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "NPS",
          integrations: "Integrações",
          schedules: "Horário de expediente"
        },
        form: {
          importOldMessagesEnable: "Importar mensagens do aparelho",
          importOldMessages: "Data de inicio da importação",
          importRecentMessages: "Data de termino da importação",
          importOldMessagesGroups: "Importar mensagens de grupo",
          closedTicketsPostImported: "Encerrar tickets após importação",
          name: "Nome",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          default: "Padrão",
          group: "Permitir grupos",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          importAlert:
            "ATENÇÃO: Ao salvar, sua conexão será encerrada, será necessário ler novamente o QR Code para importar as mensagens",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          maxUseInactiveTime: "Enviar flow de inatividade x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          timeToReturnQueue: "Tempo para retornar a fila em minutos",
          timeAwaitActiveFlow: "Tempo para aguardar ativação do fluxo",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliação após x minutos",
          maxUseBotQueuesNPS:
            "Quantidade máxima de vezes que a avaliaçao vai ser enviada",
          closeLastMessageOptions1: "Do atendente/Cliente",
          closeLastMessageOptions2: "Do atendente",
          outOfHoursMessage: "Mensagem de fora de expediente",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          lgpdLinkPrivacy: "Link para política de privacidade",
          lgpdMessage: "Mensagem de saudaçao LGPD",
          lgpdDeletedMessages: "Ofuscar mensagem apagada pelo contato",
          lgpdSendMessage: "Sempre solicitar confirmação do contato",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          token: "Token para integração externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensagem de inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          flowInactiveTime:
            "Tempo em minutos para envio do flow de inatividade",
          whenExpiresTicket:
            "Encerrar chats abertos quando última mensagem for",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          prompt: "Prompt",
          promptHelp: "Configure um prompt personalizado para respostas baseadas em IA. Para modos de agente avançados, configure o Assistente de Voz na fila correspondente.",
          collectiveVacationEnd: "Data final",
          collectiveVacationStart: "Data inicial",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          queueIdImportMessages: "Fila para importar as mensagens",
          isOficial: "Oficial",
          phone_number_id: "ID Número de telefone",
          waba_id: "Waba ID",
          send_token: "Token de envio",
          business_id: "ID do negócio",
          phone_number: "Número de telefone",
          triggerIntegrationOnClose: "Disparar Integração ao Encerrar Ticket",
          enableIntegration: "Habilitar Integração"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar"
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
          minutes: "minutos"
        },
        success: "Conexão salvo com sucesso.",
        errorSendQueue:
          "Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS:
          "É obrigado informar um tempo para avaliação quando se utiliza o NPS.",
        errorRatingMessage:
          "É obrigado informar uma mensagem de avaliação quando se utiliza o NPS."
      },
      agentMode: {
        prompt: "Prompt",
        agentDirect: "Agente Direto",
        agentAssistant: "Assistente",
        promptTooltip: "IA funciona de forma autônoma usando prompts",
        agentDirectTooltip: "IA atua como agente direto, pode ser controlada por humanos",
        agentAssistantTooltip: "IA fornece sugestões em tempo real para agentes humanos",
        activeStatus: "IA Ativa",
        inactiveStatus: "IA Inativa",
        takeoverTooltip: "Assumir controle da conversação",
        aiResponding: "IA está respondendo...",
        humanTookOver: "Agente humano assumiu o controle",
        aiTookOver: "IA assumiu o controle",
        transferredToAI: "Ticket transferido para IA",
        transferredToHuman: "Ticket transferido para agente humano",
        takeoverSuccess: "Controle transferido para agente humano com sucesso",
        takeoverButton: "Assumir Atendimento"
      },
      agentSuggestions: {
        title: "Sugestões da IA",
        generating: "Gerando Sugestões...",
        analyzing: "Analisando conversa...",
        noSuggestions: "Nenhuma sugestão disponível no momento",
        accept: "Aceitar sugestão",
        reject: "Rejeitar sugestão",
        sendDirectly: "Enviar diretamente",
        suggestionSent: "Sugestão enviada com sucesso",
        context: "Contexto",
        confidence: {
          high: "Alta",
          medium: "Média",
          low: "Baixa"
        },
        actions: {
          accept: "Aceitar e Inserir",
          reject: "Rejeitar",
          send: "Enviar Diretamente"
        }
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão"
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!"
        },
        searchPlaceholder: "Pesquisar...",
        conversationFlows: " Fluxos de Conversa",
        addFlow: "Adicionar Fluxo",
        editFlow: "Editar Fluxo ",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?"
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato"
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          email: "Email",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          wallet: "Carteira"
        },
        menu: {
          importYourPhone: "Importar do aparelho padrão",
          importToExcel: "Importar / Exportar do Excel",
          importexport: "IMPORTAR / EXPORTAR"
        }
      },
      forwardMessage: {
        text: "Encaminhada"
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar"
        }
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          model: "Modelo",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          max_messages: "Máximo de mensagens no Histórico"
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar Prompt",
          edit: "Editar Prompt"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar"
        }
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          model: "Modelo",
          max_tokens: "Máximo Tokens Resposta",
          status: "Status",
          actions: "Ações",
          noPrompts: "Nenhum prompt cadastrado",
          noQueue: "Sem fila"
        },
        status: {
          active: "Ativo",
          incomplete: "Incompleto"
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!"
        },
        buttons: {
          add: "Adicionar Prompt",
          edit: "Editar",
          delete: "Excluir"
        },
        toasts: {
          titles: {
            promptSaved: "Prompt Salvo",
            promptRemoved: "Prompt Removido",
            promptError: "Erro no Prompt"
          }
        }
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato"
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
          assignWallet: "Carteira de Cliente"
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar"
        },
        success: "Contato salvo com sucesso.",
        walletLinked: "Contato vinculado à sua carteira com sucesso!",
        walletError: "Usuário não possui filas associadas",
        saveFirst: "Contato deve ser salvo primeiro"
      },
      wallets: {
        title: "Carteiras de Contatos",
        searchPlaceholder: "Buscar contatos...",
        filterByUser: "Filtrar por Usuário",
        allUsers: "Todos os usuários",
        contact: "Contato",
        user: "Usuário",
        queue: "Fila",
        phone: "Telefone",
        email: "Email",
        actions: "Ações",
        editWallet: "Editar Carteira",
        selectUser: "Selecionar Usuário",
        selectQueue: "Selecionar Fila",
        selectUserAndQueue: "Selecione um usuário e uma fila",
        cancel: "Cancelar",
        save: "Salvar",
        confirmDeleteTitle: "Confirmar Exclusão",
        confirmDeleteMessage:
          "Tem certeza que deseja remover este contato da carteira?",
        deleteSuccess: "Contato removido da carteira com sucesso!",
        updateSuccess: "Carteira atualizada com sucesso!",
        wallet: "Carteira"
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horários de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opções de integrações serão deletadas."
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          typeRandomMode: "Tipo de rodízio",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          tokenPlaceholder: "Token para autenticação nas requisições n8n",
          integrationId: "Integração",
          fileListId: "Lista de arquivos",
          closeTicket: "Fechar ticket",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar"
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip:
            "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          toolTipMessageTitle:
            "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
          addOptions: "Adicionar opções"
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo"
        }
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar Integração",
          edit: "Editar Integração"
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
          assistantSelection: "Selecionar Agente IA",
          noAssistantSelected: "Nenhum agente selecionado",
          flowSelection: "Selecionar Flow",
          selectFlow: "Selecione um flow"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot"
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso."
        },
      },
      userModal: {
        warning:
          "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem"
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "Conexão Padrão",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultTheme: "Tema Padrão",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
          showContacts: "Ver contatos",
          showCampaign: "Ver campanhas",
          showFlow: "Ver fluxos"
        },
        email: "Email",
        password: "Senha",
        farewellMessage: "Mensagem de despedida",
        profile: "Perfil",
        startWork: "Inicio de trabalho",
        endWork: "Fim de trabalho",
        whatsapp: "Conexão Padrão",
        allTicketEnable: "Habilitado",
        allTicketDisable: "Desabilitado",
        allTicket: "Visualizar chamados sem fila",
        allowGroup: "Permitir Grupos",
        defaultTheme: "Tema Padrão",
        defaultThemeDark: "Escuro",
        defaultThemeLight: "Claro",
        allHistoric: "Ver conversas de outras filas",
        allHistoricEnabled: "Habilitado",
        allHistoricDisabled: "Desabilitado",
        allUserChat: "Ver conversas de outros usuários",
        userClosePendingTicket: "Permitir fechar tickets pendentes",
        allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
        showDashboard: "Ver Dashboard",
        allowRealTime: "Ver Painel de Atendimentos",
        allowConnections: "Permitir ações nas conexões",
        showContacts: "Ver contatos",
        showCampaign: "Ver campanhas",
        showFlow: "Ver fluxos",
      tabs: {
        general: "Geral",
        permissions: "Permissões"
      },
      buttons: {
        okAdd: "Adicionar",
        okEdit: "Salvar",
        cancel: "Cancelar",
        addImage: "Adicionar Imagem",
        editImage: "Editar Imagem"
      },
      success: "Usuário salvo com sucesso.",
    },
    companyModal: {
      title: {
        add: "Adicionar empresa",
        edit: "Editar empresa"
      },
      form: {
        name: "Nome",
        email: "Email",
        passwordDefault: "Senha",
        numberAttendants: "Usuários",
        numberConections: "Conexões"
      },
      buttons: {
        okAdd: "Adicionar",
        okEdit: "Salvar",
        cancel: "Cancelar"
      },
      success: "Empresa salvo com sucesso."
    },
    scheduleModal: {
      title: {
        add: "Novo Agendamento",
        edit: "Editar Agendamento",
        message: "Mensagem"
      },
      form: {
        body: "Mensagem",
        contact: "Contato",
        sendAt: "Data de Agendamento",
        sentAt: "Data de Envio",
        assinar: "Enviar Assinatura"
      },
      buttons: {
        okAdd: "Adicionar",
        okEdit: "Salvar",
        cancel: "Cancelar",
        addSchedule: "Adicionar agendamento",
      },
      success: "Agendamento salvo com sucesso."
    },
    tagModal: {
      title: {
        add: "Nova Tag",
        edit: "Editar Tag",
        addKanban: "Nova Lane",
        editKanban: "Editar Lane"
      },
      form: {
        name: "Nome",
        color: "Cor",
        timeLane: "Tempo em minutos para redirecionar para lane",
        nextLaneId: "Lane",
        greetingMessageLane: "Mensagem de saudação da lane",
        rollbackLaneId: "Voltar para Lane após retomar atendimento"
      },
      buttons: {
        okAdd: "Adicionar",
        okEdit: "Salvar",
        cancel: "Cancelar"
      },
      success: "Tag salva com sucesso.",
      successKanban: "Lane salva com sucesso."
    },
    fileModal: {
      title: {
        add: "Adicionar lista de arquivos",
        edit: "Editar lista de arquivos"
      },
      buttons: {
        okAdd: "Salvar",
        okEdit: "Editar",
        cancel: "Cancelar",
        fileOptions: "Adicionar arquivo"
      },
      form: {
        name: "Nome da lista de arquivos",
        message: "Detalhes da lista",
        fileOptions: "Lista de arquivos",
        extraName: "Mensagem para enviar com arquivo",
        extraValue: "Valor da opção"
      },
      success: "Lista de arquivos salva com sucesso!"
    },
    chat: {
      noTicketMessage: "Selecione um ticket para começar a conversar."
    },
    uploads: {
      titles: {
        titleUploadMsgDragDrop:
          "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
        titleFileList: "Lista de arquivo(s)"
      }
    },
    chatInternal: {
      new: "Criar grupo",
      modal: {
        conversation: "Conversa",
        title: "Nome",
        filterUsers: "Selecione integrantes",
        cancel: "Fechar",
        save: "Salvar"
      },
      modalDelete: {
        title: "Excluir Conversa",
        message: "Esta ação não pode ser revertida, confirmar?"
      }
    },
    ticketsManager: {
      questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
      yes: "SIM",
      not: "NÃO",
      buttons: {
        newTicket: "Novo",
        resolveAll: "Resolver Todos",
        close: "Fechar",
        new: "Novo"
      }
    },
    ticketsQueueSelect: {
      placeholder: "Filas"
    },
    tickets: {
      messageHidden: "Mensagem oculta",
      inbox: {
        closedAllTickets: "Fechar todos os tickets?",
        closedAll: "Fechar Todos",
        newTicket: "Novo Ticket",
        yes: "SIM",
        no: "NÃO",
        open: "Abertos",
        resolverd: "Resolvidos"
      },
      toasts: {
        deleted: "O atendimento que você estava foi deletado."
      },
      notification: {
        message: "Mensagem de",
        messageHidden: "Mensagem oculta"
      },
      tabs: {
        open: { title: "Abertas" },
        closed: { title: "Resolvidos" },
        search: { title: "Busca" }
      },
      search: {
        placeholder: "Buscar atendimento e mensagens",
        filterConections: "Filtro por Conexão",
        filterConectionsOptions: {
          open: "Aberto",
          closed: "Fechado",
          pending: "Pendente"
        },
        filterUsers: "Filtro por Usuarios",
        filterContacts: "Filtro por Contatos",
        ticketsPerPage: "Tickets por página"
      },
      buttons: {
        showAll: "Todos",
        returnQueue: "Devolver a Fila",
        scredule: "Agendamento",
        deleteTicket: "Deletar Ticket"
      },
      aiControl: {
        pauseAI: "Pausar IA",
        resumeAI: "Retomar IA",
        takeOwnership: "Assumir Atendimento",
        returnToAI: "Devolver à IA",
        pauseSuccess: "IA pausada com sucesso",
        resumeSuccess: "IA retomada com sucesso",
        takeOwnershipSuccess: "Atendimento assumido com sucesso",
        returnToAISuccess: "Ticket devolvido à IA com sucesso"
      },
      closedTicket: {
        closedMessage: "Fechar Ticket Com Mensagem de Despedida",
        closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida"
      }
    },
    transferTicketModal: {
      title: "Transferir Ticket",
      fieldLabel: "Digite para buscar usuários",
      fieldQueueLabel: "Transferir para fila",
      fieldQueuePlaceholder: "Selecione uma fila",
      fieldWhatsapp: "Selecione um whatsapp",
      noOptions: "Nenhum usuário encontrado com esse nome",
      msgTransfer: "Observações - mensagem interna, não vai para o cliente",
      buttons: {
        ok: "Transferir",
        cancel: "Cancelar"
      }
    },
    messageInput: {
      agentTakeover: "Assumir Controle",
      aiActive: "IA Ativa",
      aiSuggestion: "Sugestão da IA disponível",
      useAISuggestion: "Usar sugestão da IA",
      placeholderWithAI: "Digite sua mensagem ou use sugestões da IA...",
      placeholderNormal: "Digite uma mensagem",
      tooltip: {
        signature: "Habilitar/Desabilitar Assinatura",
        privateMessage: "Habilitar/Desabilitar Mensagem Privada",
        meet: "Enviar link para videoconferencia",
        triggerFlow: "Disparar Fluxo"
      },
      type: {
        imageVideo: "Fotos e vídeos",
        cam: "Câmera",
        contact: "Contato",
        meet: "Vídeo chamada",
        template: "Template Meta",
        aiSuggestion: "Sugestões de IA"
      }
    },
    ticketsList: {
      called: "Chamado",
      today: "Hoje",
      missedCall: "Chamada de voz/vídeo perdida às",
      contactUnavailable: "Contato indisponível",
      pendingHeader: "Aguardando",
      assignedHeader: "Atendendo",
      aiHeader: "IA",
      aiAssistant: "IA",
      groupingHeader: "Grupos",
      noTicketsTitle: "Nada aqui!",
      noTicketsMessage:
        "Nenhum atendimento encontrado com esse status ou termo pesquisado",
      noQueue: "Sem Fila",
      buttons: {
        accept: "Aceitar",
        cancel: "Cancelar",
        start: "iniciar",
        closed: "Fechar",
        reopen: "Reabrir",
        transfer: "Transferir",
        ignore: "Ignorar",
        exportAsPDF: "Exportar para PDF",
        kanbanActions: "Opções de Kanban"
      },
      acceptModal: {
        title: "Aceitar Chat",
        queue: "Selecionar setor"
      }
    },
    newTicketModal: {
      title: "Criar Ticket",
      fieldLabel: "Digite para pesquisar o contato",
      add: "Adicionar",
      buttons: {
        ok: "Salvar",
        cancel: "Cancelar"
      }
    },
    SendContactModal: {
      title: "Enviar contato",
      fieldLabel: "Digite para pesquisar o contato",
      add: "Adicionar",
      buttons: {
        ok: "Enviar",
        cancel: "Cancelar"
      }
    },
    assistants: {
      title: "Assistentes IA",
      searchPlaceholder: "Pesquisar assistentes...",
      buttons: {
        new: "Novo Assistente",
        help: "Ajuda",
        import: "Importar",
        edit: "Editar",
        delete: "Excluir",
        train: "Treinar",
        addEmpty: "Criar Primeiro Assistente",
        cancel: "Cancelar",
        okAdd: "Adicionar Assistente",
        okEdit: "Salvar Alterações",
        cancelSelection: "Cancelar Seleção",
        deleteSelected: "Excluir Selecionados",
        createSDR: "Criar Assistente SDR",
        createSDRTooltip: "Criar assistente pré-configurado para IA SDR com integração Apollo.io",
        createSDRTooltipManual: "Criar assistente SDR (modo manual - importação CSV). Configure Apollo.io para discovery automática"
      },
      table: {
        name: "Nome",
        model: "Modelo",
        tools: "Ferramentas",
        status: "Status",
        actions: "Ações"
      },
      modal: {
        title: {
          add: "Adicionar Agente",
          edit: "Editar Agente"
        }
      },
      tools: {
        fileSearch: "Busca",
        fileSearchFull: "Busca em Arquivos",
        codeInterpreter: "Código",
        codeInterpreterFull: "Interpretador de Código",
        function: "Função",
        functionFull: "Função Personalizada",
        availableTools: "Ferramentas Disponíveis",
        fileSearchDescription: "Permite buscar informações em documentos",
        codeInterpreterDescription: "Executa código Python para análise de dados",
        functionDescription: "Permite usar funções personalizadas",
        fileSearchConfig: "Configure documentos para pesquisa",
        codeInterpreterConfig: "Configure arquivos para análise",
        functionConfig: "Configure funções personalizadas"
      },
      status: {
        active: "Ativo",
        inactive: "Inativo"
      },
      labels: {
        none: "Nenhum",
        voice: "Voz",
        transcription: "Transcrição",
        global: "Global"
      },
      emptyState: {
        title: "Nenhum assistente encontrado",
        description: "Crie seu primeiro assistente IA para começar a automatizar respostas e melhorar o atendimento ao cliente.",
        noActive: "Nenhum assistente ativo",
        noInactive: "Nenhum assistente inativo",
        tryOtherTerms: "Tente usar outros termos na busca",
        noneInCategory: "Não há assistentes nesta categoria"
      },
      tooltips: {
        voiceEnabled: "Recursos de voz habilitados",
        globalConfig: "Usando configuração global da empresa"
      },
      toasts: {
        loadError: "Erro ao carregar assistentes",
        deleted: "Assistente excluído com sucesso",
        deleteError: "Erro ao excluir assistente",
        success: "Assistente salvo com sucesso",
        saveError: "Erro ao salvar assistente",
        loadAssistantError: "Erro ao carregar assistente",
        loadFilesError: "Erro ao carregar arquivos",
        fileRemoved: "Arquivo removido com sucesso",
        fileRemoveError: "Erro ao remover arquivo",
        fileFormatNotAllowed: "Formato de arquivo não permitido",
        fileSizeExceeded: "Tamanho máximo de arquivo excedido"
      },
      confirmationModal: {
        deleteTitle: "Excluir assistente",
        deleteMessage: "Tem certeza que deseja excluir este assistente? Esta ação não pode ser desfeita."
      },
      training: {
        title: "Treinamento com Contexto de Tickets",
        description: "Configure o treinamento do assistente com base no histórico de tickets da sua empresa para personalizar respostas e melhorar a qualidade do atendimento.",
        maxTickets: "Máximo de Tickets",
        maxTicketsHelp: "Quantidade máxima de tickets para usar no treinamento (1-2000)",
        minMessages: "Mínimo de Mensagens",
        minMessagesHelp: "Número mínimo de mensagens por ticket para considerar no treinamento",
        startDate: "Data Inicial",
        endDate: "Data Final",
        queues: "Filas",
        queuesPlaceholder: "Selecione as filas (deixe vazio para todas)",
        queuesHelp: "Especifique as filas para focar o treinamento em contextos específicos",
        includeClosed: "Incluir Tickets Fechados",
        onlySuccessful: "Apenas Tickets Resolvidos com Sucesso",
        start: "Iniciar Treinamento",
        training: "Treinando...",
        cancel: "Cancelar",
        close: "Fechar",
        progress: "Progresso do Treinamento",
        complete: "completo",
        success: "Treinamento Concluído!",
        successMessage: "O assistente foi treinado com sucesso e está pronto para usar o conhecimento adquirido.",
        ticketsProcessed: "Tickets Processados",
        knowledgeItems: "Itens de Conhecimento",
        satisfaction: "Taxa de Satisfação",
        companyProfile: "Perfil da Empresa",
        sector: "Setor",
        commonTopics: "Tópicos Comuns"
      },
      help: {
        title: "Ajuda sobre Agentes de IA",
        common: {
          capabilities: "Capacidades",
          supportedFormats: "Formatos suportados",
          field: "Campo",
          description: "Descrição",
          close: "Fechar"
        },
        tabs: {
          introduction: "Introdução",
          creation: "Criação",
          tools: "Ferramentas",
          import: "Importação",
          messageTypes: "Tipos de Mensagens",
          apiIntegrations: "Integrações de APIs"
        },
        introduction: {
          description: "Os Agentes de IA são assistentes virtuais baseados em Inteligência Artificial que podem atender automaticamente seus clientes.",
          whatAre: {
            title: "O que são Agentes de IA?",
            description: "Os Agentes de IA usam modelos avançados de linguagem para oferecer atendimento automatizado, mas com respostas naturais e personalizadas para seus clientes.",
            benefits: {
              personalization: "Personalização completa das respostas e comportamento",
              contextMemory: "Memória de contexto para manter conversas coerentes",
              tools: "Utilização de ferramentas avançadas como busca em arquivos e análise de dados",
              integration: "Integração perfeita com o fluxo de atendimento existente"
            }
          },
          page: {
            title: "A página de Agentes",
            description: "Esta página permite gerenciar todos os seus Agentes de IA, desde a criação até o monitoramento e edição.",
            sections: {
              creation: "Criação de Agentes",
              creationDesc: "Crie novos assistentes personalizados para necessidades específicas do seu negócio.",
              import: "Importação",
              importDesc: "Importe agentes já configurados na sua conta da OpenAI para usar aqui.",
              search: "Busca e Filtros",
              searchDesc: "Encontre rapidamente os agentes com filtros por modelo e ferramentas.",
              management: "Gerenciamento",
              managementDesc: "Edite, exclua ou desative agentes conforme necessário."
            }
          },
          models: {
            title: "Modelos Disponíveis",
            description: "Escolha entre diferentes modelos de IA, cada um com características específicas de desempenho, qualidade e custo:",
            gpt4: "O modelo mais avançado, com maior capacidade de compreensão e raciocínio complexo.",
            gpt4turbo: "Versão otimizada do GPT-4, oferecendo bom equilíbrio entre qualidade e velocidade.",
            gpt35: "Modelo rápido e econômico, ideal para tarefas simples e de alto volume.",
            capabilities: {
              contextual: "Compreensão de contexto avançada",
              reasoning: "Raciocínio complexo",
              code: "Geração de código de alta qualidade",
              analysis: "Análise de dados sofisticada",
              speed: "Velocidade otimizada",
              knowledge: "Conhecimento mais recente",
              costBenefit: "Boa relação custo-benefício",
              versatile: "Ideal para a maioria dos casos de uso",
              maxSpeed: "Velocidade máxima",
              lowCost: "Custo reduzido",
              simpleTasks: "Ideal para tarefas simples",
              highScale: "Perfeito para alta escala"
            },
            tip: {
              title: "Dica para escolha do modelo",
              description: "Para a maioria dos casos, o GPT-4 Turbo oferece o melhor equilíbrio entre qualidade e custo. Use o GPT-4 para casos que exigem raciocínio mais sofisticado e o GPT-3.5 para tarefas simples em grande volume."
            }
          }
        },
        creation: {
          title: "Criando um Agente",
          description: "O processo de criação de um agente envolve algumas etapas simples, mas importantes para o bom funcionamento do assistente.",
          stepsTitle: "Passos para criação",
          steps: {
            one: {
              title: "Iniciar o processo",
              description: "Clique no botão 'Adicionar' no topo da página de Agentes para abrir o formulário de criação."
            },
            two: {
              title: "Configurações básicas",
              description: "Preencha as informações essenciais para o funcionamento do agente:",
              fields: {
                apiKey: "Chave da API OpenAI",
                apiKeyDesc: "Sua chave pessoal da API da OpenAI para autenticação dos serviços.",
                name: "Nome",
                nameDesc: "Um nome identificador para o agente, visível apenas para você.",
                instructions: "Instruções",
                instructionsDesc: "Diretrizes detalhadas que definem o comportamento, tom e conhecimentos do agente.",
                model: "Modelo",
                modelDesc: "O modelo de IA a ser usado, que define capacidades e custos do agente."
              }
            },
            three: {
              title: "Ativar ferramentas",
              description: "Escolha as ferramentas que deseja disponibilizar para o seu agente:",
              tools: {
                fileSearch: "Pesquisa de Arquivos",
                codeInterpreter: "Interpretador de Código",
                functions: "Funções Personalizadas"
              },
              note: "Cada ferramenta adiciona capacidades específicas e pode exigir configurações adicionais."
            },
            four: {
              title: "Salvar o agente",
              description: "Clique em 'Adicionar Agente' para finalizar a criação. O agente estará disponível imediatamente para uso."
            }
          },
          tips: {
            title: "Dicas para criar agentes eficazes",
            instructionsQuality: "Forneça instruções detalhadas e claras para obter respostas mais precisas e no tom desejado.",
            specificPurpose: "Crie agentes com propósitos específicos em vez de um único agente genérico para todas as tarefas.",
            testIteratively: "Teste o comportamento do agente regularmente e ajuste as instruções conforme necessário."
          }
        },
        tools: {
          title: "Ferramentas Disponíveis",
          description: "Os agentes podem usar ferramentas especiais que ampliam suas capacidades para além da simples conversa por texto.",
          fileSearch: {
            title: "Pesquisa de Arquivos",
            description: "Permite que o agente busque informações em documentos carregados para responder perguntas com base em seu conteúdo.",
            capabilities: {
              retrieveInfo: "Recupera informações específicas de documentos",
              answerQuestions: "Responde perguntas baseadas no conteúdo dos arquivos",
              summarize: "Cria resumos e sínteses de documentos extensos"
            }
          },
          codeInterpreter: {
            title: "Interpretador de Código",
            description: "Permite que o agente execute código Python para análise de dados, cálculos e geração de visualizações.",
            capabilities: {
              executeCode: "Executa código Python para análise de dados",
              dataAnalysis: "Realiza análises estatísticas e matemáticas",
              visualizations: "Gera gráficos e visualizações de dados"
            }
          },
          functions: {
            title: "Funções Personalizadas",
            description: "Permite que o agente execute ações específicas através de funções definidas, como integração com sistemas externos.",
            capabilities: {
              integration: "Integração com sistemas e APIs externos",
              realTime: "Acesso a dados em tempo real",
              actions: "Execução de ações específicas de negócio"
            }
          },
          configuration: {
            title: "Configuração das Ferramentas",
            description: "Cada ferramenta requer configurações específicas para seu funcionamento adequado:",
            fileSearch: {
              title: "Configurando a Pesquisa de Arquivos",
              step1: "Ative a ferramenta 'Pesquisa de Arquivos' na aba Ferramentas.",
              step2: "Vá para a aba 'Arquivos' e selecione 'Pesquisa de Arquivos' no tipo de ferramenta.",
              step3: "Adicione os arquivos que deseja disponibilizar para consulta pelo agente."
            },
            codeInterpreter: {
              title: "Configurando o Interpretador de Código",
              step1: "Ative a ferramenta 'Interpretador de Código' na aba Ferramentas.",
              step2: "Vá para a aba 'Arquivos' e selecione 'Interpretador de Código' no tipo de ferramenta.",
              libraries: "O ambiente Python inclui bibliotecas populares como pandas, numpy, matplotlib e scikit-learn por padrão."
            },
            functions: {
              title: "Configurando Funções Personalizadas",
              step1: "Ative a ferramenta 'Funções Personalizadas' na aba Ferramentas.",
              step2: "Vá para a aba 'Funções' e adicione as funções que deseja disponibilizar para o agente.",
              parameters: {
                title: "Configuração de Parâmetros",
                name: "Nome",
                nameDesc: "Nome da função que o agente vai chamar",
                description: "Descrição",
                descriptionDesc: "Explicação do que a função faz e quando deve ser usada",
                type: "Tipo",
                typeDesc: "Tipo de dado do parâmetro (string, número, boolean, etc)",
                required: "Obrigatório",
                requiredDesc: "Indica se o parâmetro é obrigatório ou opcional"
              }
            }
          },
          limitations: {
            title: "Limitações",
            description: "As ferramentas têm algumas limitações importantes a considerar: o Interpretador de Código opera em um ambiente isolado sem acesso à internet, a Pesquisa de Arquivos suporta um número limitado de formatos, e as Funções Personalizadas requerem configuração adicional para implementação efetiva."
          }
        },
        import: {
          title: "Importando Agentes",
          description: "Você pode importar agentes existentes da sua conta OpenAI para usar no sistema.",
          processTitle: "Processo de Importação",
          steps: {
            one: {
              title: "Iniciar importação",
              description: "Clique no botão 'Importar' no topo da página de Agentes para abrir o assistente de importação.",
              note: "Você precisará da sua chave de API da OpenAI para concluir este processo."
            },
            two: {
              title: "Selecionar agentes",
              description: "O sistema mostrará todos os agentes disponíveis na sua conta OpenAI. Selecione os que deseja importar."
            },
            three: {
              title: "Concluir importação",
              description: "Clique em 'Importar Selecionados' para finalizar o processo. Os agentes importados aparecerão na sua lista.",
              note: "Alguns elementos como arquivos e funções específicas podem precisar ser reconfigurados após a importação."
            }
          },
          advantages: {
            title: "Vantagens da Importação",
            time: "Economiza tempo ao reutilizar agentes já configurados na OpenAI",
            consistency: "Mantém a consistência entre os agentes usados na plataforma OpenAI e no sistema",
            migration: "Facilita a migração gradual para o nosso sistema integrado"
          },
          limitations: {
            title: "Limitações da Importação",
            description: "Existem algumas limitações importantes a considerar no processo de importação:",
            files: {
              title: "Arquivos",
              description: "Os arquivos associados aos agentes na OpenAI não são importados automaticamente e precisam ser adicionados novamente."
            },
            keys: {
              title: "Chaves API",
              description: "Você precisará fornecer sua chave API novamente para cada agente, mesmo que todos usem a mesma chave."
            },
            functions: {
              title: "Funções",
              description: "As funções personalizadas precisarão ser reconfiguradas manualmente após a importação."
            }
          },
          security: {
            title: "Segurança",
            description: "Sua chave API da OpenAI é usada apenas para o processo de importação e interação com os agentes. Ela é armazenada de forma segura e criptografada em nosso sistema."
          }
        },
        messageTypes: {
          title: "Tipos de Mensagens Suportadas",
          description: "O agente pode enviar vários tipos de mensagens além de texto simples. Veja abaixo os formatos suportados e como usá-los.",
          text: {
            title: "Mensagem de Texto",
            description: "Mensagens de texto simples são enviadas automaticamente. O agente pode responder com parágrafos, listas e formatação básica.",
            example: "Exemplo:",
            exampleText: "Olá! Como posso ajudar você hoje?"
          },
          location: {
            title: "Localização (Mapa)",
            description: "Envie coordenadas geográficas para mostrar uma localização no mapa.",
            example: "Formato:"
          },
          document: {
            title: "Documentos",
            description: "Envie documentos como PDF, DOC, XLS e outros formatos de arquivo.",
            example: "Formato:"
          },
          video: {
            title: "Vídeos",
            description: "Compartilhe vídeos a partir de URLs externas.",
            example: "Formato:"
          },
          contact: {
            title: "Contatos",
            description: "Compartilhe informações de contato que podem ser salvas na agenda do usuário.",
            example: "Formato:"
          },
          audio: {
            title: "Áudios",
            description: "Envie mensagens de voz ou áudio a partir de URLs externas.",
            example: "Formato:"
          },
          image: {
            title: "Imagens",
            description: "Compartilhe imagens a partir de URLs externas ou geradas pelo agente.",
            example: "Formato:"
          },
          tips: {
            title: "Dicas para o uso de mensagens",
            description: "Para usar estes recursos, inclua comandos especiais nas instruções do seu agente. Os comandos devem ser formatados exatamente como mostrado nos exemplos acima. Múltiplos comandos podem ser combinados em uma única resposta."
          }
        },
        apiIntegrations: {
          title: "Integrações de APIs Externas",
          description: "Os assistentes podem consultar APIs externas para enriquecer suas respostas com dados em tempo real. Isso permite que o assistente acesse informações atualizadas de sistemas externos, como vendas, pagamentos, estoque, e muito mais.",
          plugpix: {
            title: "API PlugPix - Pagamentos",
            description: "A integração PlugPix permite que o assistente consulte informações sobre transações de pagamento, calcule taxas e forneça dados de vendas em tempo real.",
            capabilities: {
              title: "Funcionalidades Disponíveis:",
              listTransactions: "Listar transações com paginação e filtros",
              getTransaction: "Consultar detalhes de uma venda específica",
              calculateFees: "Calcular taxas para diferentes formas de pagamento",
              paymentInfo: "Informações sobre cartão, PIX e boleto",
              buyerData: "Dados do comprador e status da transação"
            }
          },
          configuration: {
            title: "Como Configurar",
            description: "Para habilitar a integração com APIs externas, siga os passos abaixo:",
            steps: {
              one: {
                title: "Obter Credenciais da API",
                description: "Entre em contato com o suporte da PlugPix para obter suas credenciais de acesso: Endpoint, Marketplace ID, Seller ID e Token de autenticação.",
                note: "As credenciais são únicas para cada empresa e devem ser mantidas em segurança."
              },
              two: {
                title: "Configurar no Assistente",
                description: "Ao criar ou editar um assistente, vá para a aba 'Configurações de APIs' e preencha os campos da seção PlugPix com suas credenciais."
              },
              three: {
                title: "Ativar Function Calling",
                description: "Na aba 'Ferramentas', ative a opção 'Function Calling' para permitir que o assistente execute funções customizadas."
              },
              four: {
                title: "Adicionar Definições de Funções",
                description: "Na aba 'Funções', adicione as definições das funções PlugPix. Você pode copiar do arquivo de template ou criar manualmente.",
                functions: {
                  title: "Funções Disponíveis:",
                  listTransactions: "plugpix_list_transactions - Lista transações",
                  getTransaction: "plugpix_get_transaction - Detalhes de uma transação",
                  calculateFees: "plugpix_calculate_fees - Calcula taxas de pagamento"
                }
              },
              five: {
                title: "Configurar Instruções",
                description: "Adicione contexto nas instruções do assistente para que ele saiba quando e como usar as funções da API.",
                example: "Você tem acesso à API PlugPix para consultar\ninformações sobre transações e vendas.\n\nQuando o usuário perguntar sobre:\n- Vendas recentes: use plugpix_list_transactions\n- Uma venda específica: use plugpix_get_transaction\n- Taxas ou custos: use plugpix_calculate_fees"
              }
            }
          },
          examples: {
            title: "Exemplos de Uso",
            exampleOne: {
              question: "Pergunta do Usuário:",
              questionText: "Quais foram as últimas 10 vendas?",
              action: "Ação do Assistente:",
              actionText: "Chama automaticamente plugpix_list_transactions com limit=10 e apresenta os resultados de forma clara e organizada."
            },
            exampleTwo: {
              question: "Pergunta do Usuário:",
              questionText: "Quanto fica R$ 150 em 3x no cartão Visa?",
              action: "Ação do Assistente:",
              actionText: "Chama plugpix_calculate_fees e retorna os valores com taxas para cada parcela de forma compreensível."
            }
          },
          security: {
            title: "Segurança das Credenciais",
            storedSecurely: "As credenciais são armazenadas de forma segura no banco de dados",
            separateCredentials: "Cada assistente pode ter suas próprias credenciais",
            tokenProtection: "O token nunca é exposto nas respostas ou logs",
            autoAuth: "Todas as requisições são autenticadas automaticamente"
          },
          tips: {
            title: "Dicas para Melhores Resultados",
            testFirst: "Teste com perguntas simples primeiro para verificar se a integração está funcionando",
            refineInstructions: "Refine as instruções do assistente baseado nos resultados obtidos",
            monitorLogs: "Monitore os logs do backend para acompanhar as chamadas à API",
            addExamples: "Adicione exemplos específicos do seu negócio nas instruções do assistente"
          }
        }
      },
      tabs: {
        basicSettings: "Configurações Básicas",
        tools: "Ferramentas",
        files: "Arquivos",
        functions: "Funções"
      },
      form: {
        name: "Nome",
        instructions: "Instruções",
        model: "Modelo",
        active: "Ativo",
        activeHelp: "Determina se o assistente estará disponível para uso",
        toolType: "Tipo de Ferramenta",
        toolTypeHelp: "Selecione o tipo de ferramenta para os arquivos",
        addFiles: "Adicionar Arquivos",
        newFiles: "Novos Arquivos",
        existingFiles: "Arquivos Existentes",
        noFiles: "Nenhum arquivo encontrado"
      },
      validation: {
        tooShort: "Muito curto",
        tooLong: "Muito longo",
        required: "Campo obrigatório"
      },
      functions: {
        enableFirst: "Ative a ferramenta 'Função' primeiro para configurar funções personalizadas"
      },

    },
    messagesAPI: {
      title: "API",
      toSend: "ENVIAR",
      textMessage: {
        number: "Número",
        body: "Mensagem",
        token: "Token cadastrado",
        userId: "ID do usuário/atendente",
        queueId: "ID da Fila",
      },
      mediaMessage: {
        number: "Número",
        body: "Nome do arquivo",
        media: "Arquivo",
        token: "Token cadastrado",
      },
      API: {
        title: "Documentação para envio de mensagens",
        methods: {
          title: "Métodos de Envío",
          messagesText: "Mensagens de Texto",
          messagesMidia: "Mensagens de Media",
        },
        instructions: {
          title: "Instruções",
          comments: "Observações Importantes",
          comments1:
            "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
          comments2:
            "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
          codeCountry: "Código do País",
          code: "DDD",
          number: "Número",
        },
        text: {
          title: "1. Mensagens de Texto",
          instructions:
            "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
        },
        media: {
          title: "2. Mensagens de Media",
          instructions:
            "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
        },
      },
    },
    notifications: {
      noTickets: "Nenhuma notificação.",
      messageHidden: "Mensagem oculta",
      newMessage: "Nova mensagem de",
    },
    triggerFlowModal: {
      title: "Disparar Fluxo",
      description:
        "Selecione um fluxo para executar neste ticket. O ticket será alterado para status 'chatbot' durante a execução.",
      selectFlow: "Escolha um fluxo",
      selectedFlow: "Fluxo selecionado",
      flowId: "ID do fluxo",
      noFlows: "Nenhum fluxo ativo encontrado",
      cancel: "Cancelar",
      trigger: "Disparar Fluxo",
      triggering: "Disparando...",
      success: "Fluxo disparado com sucesso!",
      error: "Erro ao disparar fluxo",
    },
    quickMessages: {
      title: "Respostas Rápidas",
      searchPlaceholder: "Pesquisar...",
      noAttachment: "Sem anexo",
      confirmationModal: {
        deleteTitle: "Exclusão",
        deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
      },
      selectMessage: "Selecionar Resposta Rápida",
      hasMedia: "Com mídia",
      global: "Global",
      noResultsFound: "Nenhuma resposta rápida encontrada para sua busca",
      noQuickMessages: "Nenhuma resposta rápida disponível",
      buttons: {
        add: "Adicionar",
        attach: "Anexar Arquivo",
        cancel: "Cancelar",
        edit: "Editar",
      },
      toasts: {
        success: "Atalho adicionado com sucesso!",
        deleted: "Atalho removido com sucesso!",
      },
      dialog: {
        title: "Mensagem Rápida",
        shortcode: "Atalho",
        message: "Resposta",
        save: "Salvar",
        cancel: "Cancelar",
        geral: "Permitir editar",
        add: "Adicionar",
        edit: "Editar",
        general: "Geral",
        visao: "Permitir visão",
      },
      table: {
        shortcode: "Atalho",
        message: "Mensagem",
        actions: "Ações",
        mediaName: "Nome do Arquivo",
        status: "Status",
      },
    },
    contactLists: {
      title: "Listas de Contatos",
      table: {
        name: "Nome",
        contacts: "Contatos",
        actions: "Ações",
      },
      buttons: {
        add: "Nova Lista",
      },
      dialog: {
        name: "Nome",
        company: "Empresa",
        okEdit: "Editar",
        okAdd: "Adicionar",
        add: "Adicionar",
        edit: "Editar",
        cancel: "Cancelar",
      },
      confirmationModal: {
        deleteTitle: "Excluir",
        deleteMessage: "Esta ação não pode ser revertida.",
      },
      toasts: {
        deleted: "Registro excluído",
        titles: {
          listCreated: "Lista Criada",
          contactsImported: "Contatos Importados",
          listRemoved: "Lista Removida"
        }
      },
    },
    contactListItems: {
      title: "Contatos",
      searchPlaceholder: "Pesquisa",
      buttons: {
        add: "Novo",
        lists: "Listas",
        import: "Importar"
      },
      dialog: {
        name: "Nome",
        number: "Número",
        whatsapp: "Whatsapp",
        email: "E-mail",
        okEdit: "Editar",
        okAdd: "Adicionar",
        add: "Adicionar",
        edit: "Editar",
        cancel: "Cancelar"
      },
      table: {
        name: "Nome",
        number: "Número",
        whatsapp: "Whatsapp",
        email: "E-mail",
        actions: "Ações"
      },
      confirmationModal: {
        deleteTitle: "Excluir",
        deleteMessage: "Esta ação não pode ser revertida.",
        importMessage: "Deseja importar os contatos desta planilha? ",
        importTitlte: "Importar"
      },
      toasts: {
        deleted: "Registro excluído"
      }
    },
    kanban: {
      title: "Kanban",
      searchPlaceholder: "Pesquisa",
      realTimeUpdates: "Atualizações em Tempo Real",
      addColumns: "Adicionar colunas",
      loading: "Carregando quadro Kanban...",
      noLanes: "Nenhuma coluna encontrada. Crie uma nova coluna para começar.",
      cancel: "Cancelar",
      save: "Salvar",
      saving: "Salvando...",
      hideSubtasks: "Ocultar Subtarefas",
      showSubtasks: "Mostrar Subtarefas",
      tasks: {
        createTask: "Nova Tarefa",
        createBulkTask: "Criar Tarefa para Tickets Selecionados",
        selectedTickets: "Tickets Selecionados",
        taskInfo: "Informações da Tarefa",
        title: "Título",
        titleRequired: "O título da tarefa é obrigatório",
        description: "Descrição",
        ticketTasks: "Tarefas do Ticket",
        noTasks: "Nenhuma tarefa criada",
        noTasksDescription: "Crie a primeira tarefa para começar a organizar o trabalho deste ticket",
        confirmDelete: "Tem certeza que deseja excluir esta tarefa?",
        progress: "Progresso",
        subtask: "Subtarefas",
        createSubtask: "Adicionar subtarefa",
        startTimer: "Iniciar Timer",
        stopTimer: "Parar Timer",
        basicInfo: "Informações Básicas",
        scheduling: "Agendamento",
        updateTask: "Atualizar Tarefa",
        editTask: "Editar Tarefa",
        addTask: "Adicionar Tarefa",
        deleteTask: "Excluir Tarefa",
        taskDetails: "Detalhes da Tarefa",
        taskProgress: "Progresso das Tarefas",
        inProgress: "Em Progresso",
        priority: {
          title: "Prioridade",
          low: "Baixa",
          medium: "Média",
          high: "Alta",
          urgent: "Urgente"
        },
        status: {
          title: "Status",
          todo: "A Fazer",
          in_progress: "Em Progresso",
          done: "Concluído",
          blocked: "Bloqueado",
          open: "Em Atendimento",
          pending: "Pendente",
          closed: "Fechado"
        },
        dueDate: "Data de Vencimento",
        estimatedHours: "Horas Estimadas",
        actualHours: "Horas Reais",
        assignTo: "Atribuir a",
        assignment: "Atribuição",
        assignees: "Atribuídos",
        selectAssignees: "Selecione usuários atribuídos",
        tags: "Etiquetas",
        selectTags: "Selecione etiquetas",
        createTasks: "Criar {{count}} Tarefas",
        bulkCreatedSuccess: "{{count}} tarefas criadas com sucesso!"
      },
      messages: {
        taskCreated: "Tarefa criada com sucesso!",
        errorCreatingTask: "Erro ao criar tarefa",
        errorCreatingTasks: "Erro ao criar tarefas",
        errorFetchingTasks: "Erro ao carregar tarefas",
        errorFetchingTickets: "Erro ao carregar tickets",
        errorFetchingUsers: "Erro ao carregar usuários",
        errorFetchingTags: "Erro ao carregar tags",
        taskUpdated: "Tarefa atualizada com sucesso",
        taskDeleted: "Tarefa excluída com sucesso",
        taskMoved: "Tarefa movida com sucesso",
        errorUpdatingTask: "Erro ao atualizar tarefa",
        errorDeletingTask: "Erro ao excluir tarefa",
        errorMovingTask: "Erro ao mover tarefa",
        bulkUpdateSuccess: "Atualização em lote realizada com sucesso",
        errorBulkUpdate: "Erro na atualização em lote",
        progressUpdated: "Progresso atualizado",
        assignmentChanged: "Responsável alterado",
        errorAssigning: "Erro ao atribuir tarefa",
        errorUnassigning: "Erro ao desatribuir tarefa",
        errorUpdatingProgress: "Erro ao atualizar progresso",
        taskMovedByUser: "Tarefa movida por {user}",
        taskAssignedByUser: "Tarefa atribuída por {user}",
        taskAssignedToYou: "Tarefa '{title}' foi atribuída a você",
        automationTriggered: "Automação '{automation}' foi executada para tarefa {task}",
        userEditingTask: "{user} está editando a tarefa {task}",
        mentionedInComment: "Você foi mencionado em um comentário por {user} na tarefa {task}",
        bulkOperationByUser: "{user} executou '{operation}' em {count} tarefas",
        subtaskCreated: "Subtarefa criada com sucesso",
        subtaskUpdated: "Subtarefa atualizada com sucesso",
        subtaskDeleted: "Subtarefa excluída com sucesso",
        subtaskCompleted: "Subtarefa concluída",
        subtaskReopened: "Subtarefa reaberta",
        errorFetchingSubtasks: "Erro ao carregar subtarefas",
        errorCreatingSubtask: "Erro ao criar subtarefa",
        errorUpdatingSubtask: "Erro ao atualizar subtarefa",
        errorDeletingSubtask: "Erro ao excluir subtarefa",
        errorTogglingSubtask: "Erro ao alterar subtarefa",
        errorFetchingAutomations: "Erro ao carregar automações",
        errorCreatingAutomation: "Erro ao criar automação",
        errorUpdatingAutomation: "Erro ao atualizar automação",
        errorDeletingAutomation: "Erro ao excluir automação",
        errorTogglingAutomation: "Erro ao alternar automação",
        automationEnabled: "Automação ativada",
        automationDisabled: "Automação desativada",
        automationCreated: "Automação criada com sucesso",
        automationUpdated: "Automação atualizada com sucesso",
        automationDeleted: "Automação excluída com sucesso",
        automationTestSuccess: "Teste de automação bem-sucedido",
        errorTestingAutomation: "Erro ao testar automação",
        errorFetchingAnalytics: "Erro ao carregar análises",
        errorFetchingHistory: "Erro ao carregar histórico",
        statusChanged: "Status da tarefa '{title}' alterado para {status}",
        automationFailed: "Automação '{name}' falhou: {error}",
        milestoneReached: "Meta alcançada: {milestone} - {value}",
        deadlineApproaching: "{count} tarefas com prazo se aproximando em {timeframe}",
        productivityAlert: "Alerta de produtividade: redução na taxa de conclusão detectada",
        overdueAlert: "Atenção: {count} tarefas estão atrasadas"
      },
      automation: {
        title: "Automação",
        noAutomations: "Nenhuma automação configurada",
        getStarted: "Configure regras de automação para otimizar seu fluxo de trabalho",
        description: "Configure regras de automação para otimizar seu fluxo de trabalho",
        manage: "Gerenciar Automações",
        createRule: "Criar Regra",
        editRule: "Editar Regra",
        ruleEngine: "Motor de Regras",
        triggers: "Gatilhos",
        actions: "Ações",
        conditions: "Condições",
        automation: "Automação",
        automations: "Automações",
        ruleBuilder: "Construtor de Regras",
        confirmDelete: "Tem certeza que deseja excluir esta automação?",
        when: "Quando",
        then: "Então",
        lastRun: "Última execução",
        neverRun: "Nunca executou",
        basicInfo: "Informações Básicas",
        ruleName: "Nome da Regra",
        activeRule: "Regra Ativa",
        triggerType: "Tipo de Gatilho",
        actionType: "Tipo de Ação",
        preview: "Pré-visualização da Regra",
        conditionType: "Tipo de Condição",
        selectTrigger: "Selecionar Gatilho",
        fromTag: "Da Tag",
        toTag: "Para Tag",
        schedule: "Agendamento",
        cronHelp: "Use formato cron (ex: 0 9 * * 1-5 para todos os dias úteis às 9h)",
        fieldName: "Nome do Campo",
        fromValue: "Valor Anterior",
        toValue: "Valor Novo",
        targetTag: "Tag de Destino",
        userId: "ID do Usuário",
        notificationMessage: "Mensagem de Notificação",
        recipientId: "ID do Destinatário",
        newPriority: "Nova Prioridade",
        daysFromNow: "Dias a partir de hoje",
        daysFromNowHelp: "Número de dias para adicionar à data atual",
        triggerTypes: {
          ticket_moved: "Ticket Movido",
          task_completed: "Tarefa Concluída",
          time_based: "Baseado em Tempo",
          field_changed: "Campo Alterado",
          tag_assigned: "Tag Atribuída",
          user_assigned: "Usuário Atribuído"
        },
        actionTypes: {
          move_ticket: "Mover Ticket",
          assign_user: "Atribuir Usuário",
          send_notification: "Enviar Notificação",
          update_field: "Atualizar Campo",
          create_task: "Criar Tarefa",
          change_priority: "Alterar Prioridade",
          set_due_date: "Definir Data de Vencimento"
        }
      },
      analytics: {
        title: "Análises",
        timeRange: "Período",
        last7Days: "Últimos 7 dias",
        last30Days: "Últimos 30 dias",
        last90Days: "Últimos 90 dias",
        totalTasks: "Total de Tarefas",
        completedTasks: "Tarefas Concluídas",
        completionRate: "Taxa de Conclusão",
        overdueTasks: "Tarefas Atrasadas",
        remainingTasks: "Tarefas Restantes",
        averageTime: "Tempo Médio",
        tasksByStatus: "Tarefas por Status",
        tasksByPriority: "Tarefas por Prioridade",
        burndownChart: "Gráfico de Burndown",
        teamPerformance: "Performance da Equipe",
        recentActivity: "Atividade Recente",
        tasksCompleted: "tarefas concluídas",
        timeTracked: "tempo rastreado",
        noTeamData: "Nenhum dado da equipe disponível",
        recommendations: "Recomendações"
      },
      filters: {
        advancedFilters: "Filtros Avançados",
        priority: "Prioridade",
        assignee: "Responsável",
        dueDate: "Data de Vencimento",
        taskStatus: "Status da Tarefa",
        customFields: "Campos Personalizados",
        dateRange: "Intervalo de Datas",
        startDate: "Data de Início",
        endDate: "Data de Fim",
        search: "Buscar",
        sortBy: "Ordenar por",
        ticketNumber: "Número do Ticket",
        lastMessage: "Última Mensagem",
        valueDesc: "Valor (maior para menor)",
        quickFilters: "Filtros Rápidos",
        unassigned: "Não Atribuídas",
        completed: "Concluídas",
        applyFilters: "Aplicar Filtros",
        clearFilters: "Limpar Filtros",
        activeFiltersCount: "{count} filtros ativos"
      },
      card: {
        viewTicket: "Ver Ticket",
        viewTasks: "Ver Tarefas",
        editValue: "Editar Valor",
        assignValue: "Atribuir Valor",
        value: "Valor",
        assignees: "Responsáveis",
        attachments: "Anexos",
        comments: "Comentários",
        progress: "Progresso",
        overdue: "Vencida",
        dueToday: "Vence Hoje",
        dueSoon: "Vence Em Breve"
      },
      bulk: {
        title: "Ações em Lote",
        tasksSelected: "tarefas selecionadas",
        selectedTasks: "Tarefas Selecionadas",
        selectAll: "Selecionar Todas",
        deselectAll: "Desselecionar Todas",
        moreTasks: "mais tarefas",
        selectAction: "Selecionar Ação",
        actionSettings: "Configurações da Ação",
        confirmAction: "Confirmar Ação",
        execute: "Executar",
        willAffect: "Esta ação afetará {count} tarefas: {action}",
        confirmDangerous: "Tem certeza que deseja executar '{action}' em {count} tarefas? Esta ação não pode ser desfeita.",
        bulkAssign: "Atribuir em Lote",
        assignDescription: "Atribuir todas as tarefas selecionadas a um usuário",
        bulkMove: "Mover em Lote",
        moveDescription: "Mover todas as tarefas selecionadas para uma tag",
        bulkPriority: "Definir Prioridade",
        priorityDescription: "Alterar a prioridade de todas as tarefas selecionadas",
        bulkDueDate: "Definir Data de Vencimento",
        dueDateDescription: "Definir data de vencimento para todas as tarefas selecionadas",
        bulkDelete: "Excluir em Lote",
        deleteDescription: "Excluir permanentemente todas as tarefas selecionadas",
        selectUser: "Selecionar Usuário",
        selectTag: "Selecionar Tag"
      },
      column: {
        addTask: "Adicionar Tarefa",
        addTicket: "Adicionar Ticket",
        settings: "Configurações da Coluna",
        colorChange: "Alterar Cor da Faixa",
        selectColor: "Selecionar Cor",
        itemCount: "item",
        itemsCount: "itens",
        totalValue: "Total"
      },
      lane: {
        addLane: "Adicionar Coluna",
        enterTitle: "Digite o nome da coluna",
        add: "Adicionar",
        cancel: "Cancelar",
        nameRequired: "Nome da coluna é obrigatório",
        created: "Coluna criada com sucesso",
        colorUpdated: "Cor da coluna atualizada",
        createError: "Erro ao criar coluna",
        updateColorError: "Erro ao atualizar cor da coluna"
      },
      tabs: {
        board: "Quadro",
        analytics: "Análises",
        automations: "Automações"
      },
      validation: {
        nameRequired: "Nome da regra é obrigatório",
        triggerRequired: "Tipo de gatilho é obrigatório",
        actionRequired: "Tipo de ação é obrigatório",
        cronRequired: "Agendamento cron é obrigatório",
        fieldRequired: "Nome do campo é obrigatório",
        valueRequired: "Valor é obrigatório",
        targetRequired: "Tag de destino é obrigatória",
        userRequired: "Usuário é obrigatório",
        messageRequired: "Mensagem é obrigatória",
        recipientRequired: "Destinatário é obrigatório",
        daysRequired: "Número de dias é obrigatório"
      },
      recommendations: {
        improveTimeEstimation: "Melhore a precisão das estimativas de tempo",
        addressOverdueTasks: "Trate as tarefas em atraso com prioridade",
        improveThroughput: "Foque em melhorar o fluxo de conclusão de tarefas"
      },
      laneConfig: {
        title: "Configurar Coluna",
        name: "Nome da Coluna",
        nameRequired: "Nome da coluna é obrigatório",
        color: "Cor da Coluna",
        preview: "Prévia",
        save: "Salvar",
        saving: "Salvando...",
        cancel: "Cancelar",
        updated: "Coluna atualizada com sucesso",
        defaultLane: "Coluna Padrão",
        defaultLaneDescription: "Esta é a coluna padrão do sistema e não pode ser editada",
        cannotEditDefault: "A coluna padrão não pode ser modificada"
      },
      collaboration: {
        liveEditing: "Edição ao Vivo",
        userViewing: "{user} está visualizando",
        userEditing: "{user} está editando",
        conflictResolution: "Resolução de Conflitos",
        saveConflict: "Outro usuário fez alterações. Deseja mesclar ou sobrescrever?",
        merge: "Mesclar",
        overwrite: "Sobrescrever",
        reload: "Recarregar"
      }
    },
    campaigns: {
      title: "Campanhas",
      searchPlaceholder: "Pesquisa",
      subMenus: {
        list: "Listagem",
        listContacts: "Lista de contatos",
        settings: "Configurações"
      },
      settings: {
        randomInterval: "Intervalo Randômico de Disparo",
        noBreak: "Sem Intervalo",
        intervalGapAfter: "Intervalo maior após",
        undefined: "Não definido",
        messages: "mensagens",
        laggerTriggerRange: "Intervalo de disparo maior",
        addVar: "Adicionar variável",
        save: "Salvar",
        close: "Fechar",
        add: "Adicionar",
        shortcut: "Atalho",
        content: "Conteúdo"
      },
      buttons: {
        add: "Nova Campanha",
        contactLists: "Listas de Contatos"
      },
      table: {
        name: "Nome",
        whatsapp: "Conexão",
        contactList: "Lista de Contatos",
        option: "Nenhuma",
        disabled: "Desabilitada",
        enabled: "Habilitada",
        status: "Status",
        scheduledAt: "Agendamento",
        completedAt: "Concluída",
        confirmation: "Confirmação",
        actions: "Ações"
      },
      dialog: {
        new: "Nova Campanha",
        update: "Editar Campanha",
        readonly: "Apenas Visualização",
        help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
        form: {
          name: "Nome",
          message1: "Mensagem 1",
          message2: "Mensagem 2",
          message3: "Mensagem 3",
          message4: "Mensagem 4",
          message5: "Mensagem 5",
          confirmationMessage1: "Mensagem de Confirmação 1",
          confirmationMessage2: "Mensagem de Confirmação 2",
          confirmationMessage3: "Mensagem de Confirmação 3",
          confirmationMessage4: "Mensagem de Confirmação 4",
          confirmationMessage5: "Mensagem de Confirmação 5",
          messagePlaceholder: "Conteúdo da mensagem",
          whatsapp: "Conexão",
          status: "Status",
          scheduledAt: "Agendamento",
          confirmation: "Confirmação",
          contactList: "Lista de Contato",
          tagList: "Tags",
          statusTicket: "Status do Ticket",
          openTicketStatus: "Aberto",
          pendingTicketStatus: "Pendente",
          closedTicketStatus: "Fechado",
          enabledOpenTicket: "Habilitado",
          disabledOpenTicket: "Desabilitado",
          openTicket: "Abrir ticket"
        },
        buttons: {
          add: "Adicionar",
          edit: "Atualizar",
          okadd: "Ok",
          cancel: "Cancelar Disparos",
          restart: "Reiniciar Disparos",
          close: "Fechar",
          attach: "Anexar Arquivo"
        }
      },
      confirmationModal: {
        deleteTitle: "Excluir",
        deleteMessage: "Esta ação não pode ser revertida."
      },
      toasts: {
        success: "Operação realizada com sucesso",
        cancel: "Campanha cancelada",
        restart: "Campanha reiniciada",
        deleted: "Registro excluído"
      },
      status: {
        scheduled: "Programada",
        running: "Em Andamento",
        finished: "Finalizada",
        cancelled: "Cancelada"
      },
      monitor: {
        title: "Monitor de Campanha",
        loading: "Carregando estatísticas...",
        noData: "Nenhum dado disponível",
        refresh: "Atualizar",
        autoRefreshOn: "Auto-atualizar: Ligado",
        autoRefreshOff: "Auto-atualizar: Desligado",
        totalMessages: "Total de Mensagens",
        delivered: "Entregues",
        failed: "Falhadas",
        pending: "Pendentes",
        confirmed: "Confirmadas",
        progress: "Progresso da Campanha",
        successRate: "Taxa de Sucesso",
        performance: "Performance",
        queueWaiting: "Aguardando na Fila",
        queueActive: "Em Processamento",
        queueDelayed: "Agendadas",
        retryStats: "Estatísticas de Retry",
        retrying: "Em Retry"
      }
    },
    campaignReport: {
      title: "Relatório de",
      inactive: "Inativa",
      scheduled: "Programada",
      process: "Em Andamento",
      cancelled: "Cancelada",
      finished: "Finalizada",
      campaign: "Campanha",
      validContacts: "Contatos Válidos",
      confirmationsRequested: "Confirmações Solicitadas",
      confirmations: "Confirmações",
      deliver: "Entregues",
      connection: "Conexão",
      contactLists: "Lista de Contatos",
      schedule: "Agendamento",
      conclusion: "Conclusão"
    },
    announcements: {
      title: "Informativos",
      searchPlaceholder: "Pesquisa",
      active: "Ativo",
      inactive: "Inativo",
      buttons: {
        add: "Novo Informativo",
        contactLists: "Listas de Informativos"
      },
      table: {
        priority: "Prioridade",
        title: "Title",
        text: "Texto",
        mediaName: "Arquivo",
        status: "Status",
        actions: "Ações"
      },
      dialog: {
        edit: "Edição de Informativo",
        add: "Novo Informativo",
        update: "Editar Informativo",
        readonly: "Apenas Visualização",
        form: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaPath: "Arquivo",
          status: "Status",
          high: "Alta",
          medium: "Média",
          low: "Baixa",
          active: "Ativo",
          inactive: "Inativo"
        },
        buttons: {
          add: "Adicionar",
          edit: "Atualizar",
          okadd: "Ok",
          cancel: "Cancelar",
          close: "Fechar",
          attach: "Anexar Arquivo"
        }
      },
      confirmationModal: {
        deleteTitle: "Excluir",
        deleteMessage: "Esta ação não pode ser revertida."
      },
      toasts: {
        success: "Operação realizada com sucesso",
        deleted: "Registro excluído",
        titles: {
          cardCreated: "Card Criado",
          cardMoved: "Card Movido",
          kanbanError: "Erro no Kanban"
        }
      }
    },
    campaignsConfig: {
      title: "Configurações de Campanhas"
    },
    queues: {
      title: "Filas & Chatbot",
      table: {
        name: "Nome",
        color: "Cor",
        greeting: "Mensagem de saudação",
        orderQueue: "Ordenação da fila (bot)",
        actions: "Ações",
        ID: "ID"
      },
      buttons: {
        add: "Adicionar fila"
      },
      toasts: {
        success: "Fila salva com sucesso",
        deleted: "Fila exclu[ida com sucesso",
        titles: {
          queueCreated: "Fila Criada",
          queueUpdated: "Fila Atualizada",
          queueRemoved: "Fila Removida",
          queueError: "Erro na Fila"
        }
      },
      confirmationModal: {
        deleteTitle: "Excluir",
        deleteMessage:
          "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
      }
    },
    queue: {
      queueData: "Dados"
    },
    queueSelect: {
      inputLabel: "Filas",
      inputLabelRO: "Filas somente leitura",
      withoutQueue: "Sem fila"
    },
    reports: {
      title: "Relatórios de Atendimentos",
      startDate: "Data Inicial",
      endDate: "Data final",
      table: {
        id: "Ticket",
        user: "Usuário",
        dateOpen: "Data Abertura",
        dateClose: "Data Fechamento",
        NPS: "NPS",
        status: "Status",
        whatsapp: "Conexão",
        queue: "Fila",
        actions: "Ações",
        lastMessage: "Últ. Mensagem",
        contact: "Cliente",
        supportTime: "Tempo de Atendimento",
        tags: "Tags"
      },
      buttons: {
        filter: "Aplicar Filtro",
        onlyRated: "Apenas Avaliados"
      },
      searchPlaceholder: "Pesquisar...",
      exportExcel: {
        title: "Relatórios de Atendimentos",
        startDate: "Data inicial",
        endDate: "Data final",
        notInformed: "Não informado",
        columns: {
          id: "ID",
          connection: "Conexão",
          contact: "Contato",
          user: "Usuário",
          queue: "Fila",
          status: "Status",
          lastMessage: "Última Mensagem",
          openDate: "Data Abertura",
          openTime: "Hora Abertura",
          closeDate: "Data Fechamento",
          closeTime: "Hora Fechamento",
          supportTime: "Tempo de Atendimento",
          nps: "NPS",
          valorVenda: "Valor da Venda",
          motivoNaoVenda: "Motivo da Não Venda",
          finalizadoComVenda: "Finalizado com Venda",
          tags: "Tags"
        }
      }
    },
    queueIntegration: {
      title: "Integrações",
      table: {
        id: "ID",
        type: "Tipo",
        name: "Nome",
        projectName: "Nome do Projeto",
        language: "Linguagem",
        lastUpdate: "Ultima atualização",
        actions: "Ações"
      },
      buttons: {
        add: "Adicionar Projeto"
      },
      searchPlaceholder: "Pesquisar...",
      confirmationModal: {
        deleteTitle: "Excluir",
        deleteMessage:
          "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas"
      },
      toasts: {
        titles: {
          integrationSaved: "Integração Salva",
          integrationError: "Erro na Integração",
          integrationRemoved: "Integração Removida",
          webhookConfigured: "Webhook Configurado"
        }
      }
    },
    flowBuilder: {
      title: "Construtor de Fluxo",
      toasts: {
        titles: {
          flowSaved: "Fluxo Salvo",
          nodeAdded: "Nó Adicionado",
          flowError: "Erro no Fluxo",
          flowRemoved: "Fluxo Removido",
          requestTested: "Requisição Testada",
          requestError: "Erro na Requisição",
          connectionEstablished: "Conexão Estabelecida",
          flowCreated: "Fluxo Criado",
          flowUpdated: "Fluxo Atualizado",
          mediaAttached: "Mídia Anexada",
          nodeError: "Erro no Nó",
          menuCreated: "Menu Criado",
          optionsSaved: "Opções Salvas",
          menuError: "Erro no Menu",
          conditionCreated: "Condição Criada",
          ruleAdded: "Regra Adicionada",
          conditionError: "Erro na Condição",
          intervalDefined: "Intervalo Definido",
          timerConfigured: "Timer Configurado",
          intervalError: "Erro no Intervalo",
          randomizationConfigured: "Randomização Configurada",
          drawCreated: "Sorteio Criado",
          randomizerError: "Erro no Randomizador",
          tagRemoved: "Tag Removida",
          filterApplied: "Filtro Aplicado",
          removalError: "Erro na Remoção"
        }
      }
    },
    users: {
      title: "Usuários",
      table: {
        status: "Status",
        name: "Nome",
        email: "Email",
        profile: "Perfil",
        startWork: "Inicio de trabalho",
        endWork: "Fim de trabalho",
        actions: "Ações",
        ID: "ID"
      },
      buttons: {
        add: "Adicionar usuário"
      },
      toasts: {
        deleted: "Usuário excluído com sucesso."
      },
      confirmationModal: {
        deleteTitle: "Excluir",
        deleteMessage:
          "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila."
      }
    },
    compaies: {
      title: "Empresas",
      table: {
        ID: "ID",
        status: "Ativo",
        name: "Nome",
        email: "Email",
        password: "Senha",
        phone: "Telefone",
        plan: "Plano",
        active: "Ativo",
        numberAttendants: "Atendentes",
        numberConections: "Conexões",
        value: "Valor",
        namePlan: "Nome Plano",
        numberQueues: "Filas",
        useCampaigns: "Campanhas",
        useExternalApi: "Rest API",
        useFacebook: "Facebook",
        useInstagram: "Instagram",
        useWhatsapp: "Whatsapp",
        useInternalChat: "Chat Interno",
        useSchedules: "Agendamento",
        createdAt: "Criada Em",
        dueDate: "Vencimento",
        lastLogin: "Ult. Login",
        folderSize: "Tamanho da pasta ",
        totalFiles: " Total de arquivos",
        lastUpdate: "Ultimo update",
        actions: "Ações",
        viewDetails: "Clique para ver detalhes completos",
        money: "$",
        yes: "Sim",
        no: "Não",
        document: "CNPJ/CPF",
        recurrence: "Recorrência",
        monthly: "Mensal",
        bimonthly: "Bimestral",
        quarterly: "Trimestral",
        semester: "Semestral",
        yearly: "Anual",
        clear: "Limpar",
        delete: "Excluir",
        user: "Usuário",
        save: "Salvar",
        generateInvoice: "Gerar Fatura"
      },
      buttons: {
        add: "Adicionar empresa"
      },
      toasts: {
        deleted: "Empresa excluído com sucesso."
      },
      confirmationModal: {
        deleteTitle: "Excluir",
        deleteMessage:
          "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila."
      }
    },
    helps: {
      title: "Central de Ajuda",
      settings: {
        codeVideo: "Código do Video",
        description: "Descrição",
        clear: "Limpar",
        delete: "Excluir",
        save: "Salvar"
      }
    },
    schedules: {
      title: "Agendamentos",
      date: "Data",
      time: "Hora",
      event: "Evento",
      allDay: "Dia Todo",
      week: "Semana",
      work_week: "Agendamentos",
      day: "Dia",
      month: "Mês",
      previous: "Anterior",
      next: "Próximo",
      yesterday: "Ontem",
      tomorrow: "Amanhã",
      today: "Hoje",
      agenda: "Agenda",
      noEventsInRange: "Não há agendamentos no período.",
      confirmationModal: {
        deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
        deleteMessage: "Esta ação não pode ser revertida."
      },
      table: {
        contact: "Contato",
        body: "Mensagem",
        sendAt: "Data de Agendamento",
        sentAt: "Data de Envio",
        status: "Status",
        actions: "Ações"
      },
      buttons: {
        add: "Novo Agendamento"
      },
      toasts: {
        deleted: "Agendamento excluído com sucesso.",
        titles: {
          scheduleSaved: "Agendamento Salvo",
          timeSet: "Horário Definido",
          scheduleError: "Erro no Agendamento",
          scheduleRemoved: "Agendamento Removido"
        }
      }
    },
    tags: {
      title: "Tags",
      addColumns: "+ ADICIONAR COLUNAS",
      search: "BUSCAR",
      seeTicket: "VER TICKET",
      confirmationModal: {
        deleteTitle: "Você tem certeza que quer excluir esta Tag?",
        deleteMessage: "Esta ação não pode ser revertida."
      },
      table: {
        id: "ID",
        name: "Nome",
        kanban: "Kanban",
        color: "Cor",
        tickets: "Registros Tags",
        contacts: "Contatos",
        actions: "Ações"
      },
      buttons: {
        add: "Nova Tag"
      },
      toasts: {
        deleted: "Tag excluído com sucesso.",
        titles: {
          tagCreated: "Tag Criada",
          tagRemoved: "Tag Removida",
          tagError: "Erro na Tag"
        }
      }
    },
    tagsKanban: {
      title: "Lanes",
      laneDefault: "Em aberto",
      backToKanban: "VOLTAR PARA O KANBAN",
      confirmationModal: {
        deleteTitle: "Você tem certeza que quer excluir esta Lane?",
        deleteMessage: "Esta ação não pode ser revertida."
      },
      table: {
        name: "Nome",
        color: "Cor",
        tickets: "Tickets",
        actions: "Ações"
      },
      buttons: {
        add: "Nova Lane"
      },
      toasts: {
        deleted: "Lane excluída com sucesso."
      }
    },
    files: {
      title: "Lista de arquivos",
      table: {
        name: "Nome",
        contacts: "Contatos",
        actions: "Ação"
      },
      toasts: {
        deleted: "Lista excluída com sucesso!",
        deletedAll: "Todas as listas foram excluídas com sucesso!"
      },
      buttons: {
        add: "Adicionar",
        deleteAll: "Deletar Todos"
      },
      confirmationModal: {
        deleteTitle: "Deletar",
        deleteAllTitle: "Deletar Todos",
        deleteMessage: "Tem certeza que deseja deletar esta lista?",
        deleteAllMessage: "Tem certeza que deseja deletar todas as listas?"
      }
    },
    messagesList: {
      toasts: {
        messageSent: "Mensagem Enviada",
        loadingError: "Erro no Carregamento",
        fileDownloaded: "Arquivo Baixado",
        mediaError: "Erro de Mídia",
        connectionError: "Erro de Conexão"
      },
      header: {
        assignedTo: "Atribuído à:",
        dialogRatingTitle:
          "Deseja deixar uma avaliação de atendimento para o cliente?",
        dialogClosingTitle: "Finalizando o atendimento com o cliente!",
        dialogRatingCancel: "Resolver COM Mensagem de Despedida",
        dialogRatingSuccess: "Resolver e Enviar Avaliação",
        dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
        ratingTitle: "Escolha um menu de avaliação",
        notMessage: "Nenhuma mensagem selecionada",
        amount: "Valor de prospecção",
        buttons: {
          return: "Retornar",
          resolve: "Resolver",
          reopen: "Reabrir",
          accept: "Aceitar",
          rating: "Enviar Avaliação",
          enableIntegration: "Habilitar integração",
          disableIntegration: "Desabilitar integração",
          logTicket: "Logs do Ticket",
          requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
          greetingAcceptedMessage:
            "Você deve configurar uma mensagem de saudação ao aceitar o ticket."
        }
      }
    },
    messagesInput: {
      placeholderPrivateMessage:
        "Digite uma mensagem ou aperte / para respostas rápidas",
      placeholderOpen:
        "Digite uma mensagem ou aperte / para respostas rápidas",
      placeholderClosed:
        "Reabra ou aceite esse ticket para enviar uma mensagem.",
      signMessage: "Assinar",
      privateMessage: "Mensagem Privada"
    },
    productSelection: {
      title: "Selecionar Produto",
      searchPlaceholder: "Buscar produtos...",
      categoryFilter: "Categoria",
      allCategories: "Todas",
      featuredProducts: "Produtos em Destaque",
      allProducts: "Todos os Produtos",
      noProducts: "Nenhum produto encontrado",
      noProductsDescription: "Tente ajustar os filtros de busca",
      sendProduct: "Enviar Produto",
      sendCatalog: "Enviar Catálogo",
      cancel: "Cancelar",
      featured: "Destaque"
    },
    contactDrawer: {
      header: "Dados do contato",
      buttons: {
        edit: "Editar contato",
        block: "Bloquear",
        unblock: "Desbloquear"
      },
      extraInfo: "Outras informações",
      groupUsers: "Usuários do Grupo",
      groupWithUsers: "Para que as mensagens de grupo funcione como ticket e entre em aguardando, é necessário remover todos os membros desta lista de usuários.",
      groupWithoutUsers: "Ao adicionar membros, as mensagens de atendimento entrarão diretamente na aba atendendo e todos os usuários selecionados serão notificados.",
      saveUsers: "Salvar Usuários",
      saving: "Salvando...",
      usersUpdatedSuccess: "Usuários do grupo atualizados com sucesso!"
    },
    messageVariablesPicker: {
      label: "Variavéis disponíveis",
      vars: {
        contactFirstName: "Primeiro Nome",
        contactName: "Nome",
        user: "Atendente",
        greeting: "Saudação",
        protocolNumber: "Protocolo",
        date: "Data",
        hour: "Hora",
        ticket_id: "Nº do Chamado",
        queue: "Setor",
        connection: "Conexão"
      }
    },
    ticketOptionsMenu: {
      schedule: "Agendamento",
      delete: "Deletar",
      transfer: "Transferir",
      registerAppointment: "Observações do Contato",
      resolveWithNoFarewell: "Finalizar sem despedida",
      acceptAudioMessage: "Aceitar áudios do contato?",
      appointmentsModal: {
        title: "Observações do Ticket",
        textarea: "Observação",
        placeholder: "Insira aqui a informação que deseja registrar"
      },
      confirmationModal: {
        title: "Deletar o ticket do contato",
        titleFrom: "do contato ",
        message:
          "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas."
      },
      buttons: {
        delete: "Excluir",
        cancel: "Cancelar"
      },
    },
    confirmationModal: {
      buttons: {
        confirm: "Ok",
        cancel: "Cancelar"
      }
    },
    messageOptionsMenu: {
      delete: "Deletar",
      reply: "Responder",
      edit: "Editar",
      forward: "Encaminhar",
      toForward: "Encaminhar",
      talkTo: "Conversar Com",
      addReaction: "Adicionar reação",
      removeReaction: "Remover reação",
      reactions: {
        addReaction: "Adicionar reação",
        removeReaction: "Remover reação",
        reactionsCount: "reação(ões)"
      },
      confirmationModal: {
        title: "Apagar mensagem?",
        message: "Esta ação não pode ser revertida."
      }
    },
    invoices: {
      table: {
        invoices: "Faturas",
        details: "Detalhes",
        users: "Usuários",
        connections: "Conexões",
        queue: "Filas",
        value: "Valor",
        expirationDate: "Data Venc.",
        action: "Ação"
      },
    },
    landingPages: {
      title: "Landing Pages",
      newLandingPage: "Nova Landing Page",
      searchPlaceholder: "Buscar landing pages...",
      createNewLandingPage: "Criar nova Landing Page",
      all: "Todas",
      active: "Ativas",
      inactive: "Inativas",
      viewAsGrid: "Visualizar em grade",
      viewAsList: "Visualizar em lista",
      noLandingPagesFound: "Nenhuma landing page encontrada",
      noLandingPagesCreated: "Nenhuma landing page criada",
      adjustSearch: "Tente ajustar sua pesquisa",
      createFirstLandingPage: "Crie sua primeira landing page para divulgar seu negócio ou coletar leads.",
      editor: {
        loading: "Carregando...",
        editing: "Editando Landing Page",
        saving: "Salvando...",
        published: "Publicada",
        back: "Voltar",
        preview: "Visualizar",
        save: "Salvar",
        close: "Fechar",
        previewTitle: "Pré-visualização",
        invalidId: "ID da landing page inválido",
        titleRequired: "O título da página é obrigatório",
        saveSuccess: "Landing page criada com sucesso!",
        updateSuccess: "Landing page atualizada com sucesso!",
        saveError: "Erro ao salvar: {message}",
        loadError: "Erro ao carregar landing page: {message}",
        draftModeAlert: "Esta landing page está em modo rascunho. Ative-a na aba 'Básico' para torná-la pública.",
        saveReminderAlert: "Lembre-se de salvar suas alterações antes de sair da página.",
        defaultContent: "Digite o conteúdo da sua landing page aqui...",
        defaultFormTitle: "Formulário de Cadastro",
        defaultButtonText: "Enviar",
        defaultFormDescription: "Formulário para coleta de leads",
        defaultMessageTemplate: "Olá! Uma nova inscrição foi realizada na landing page {landing_page}:\\n\\nNome: {name}\\nE-mail: {email}\\nData: {date}",
        defaultConfirmationMessage: "Obrigado por se cadastrar! Seu formulário foi recebido com sucesso.",
        defaultWhatsAppMessage: "Olá! Gostaria de saber mais sobre {landing_page}"
      },
      tabs: {
        basic: "Básico",
        content: "Conteúdo",
        form: "Formulário",
        appearance: "Aparência",
        notifications: "Notificações",
        affiliates: "Afiliados",
        advanced: "Avançado"
      },
      basic: {
        title: "Informações Básicas",
        loadQueuesError: "Erro ao carregar filas",
        pageTitle: "Título da Página",
        pageTitlePlaceholder: "Ex: Webinar de Marketing Digital",
        pageTitleHelperText: "O título será exibido na aba do navegador e em compartilhamentos",
        pageSlug: "URL da Página (Slug)",
        slugTaken: "Esta URL já está em uso. Por favor, escolha outra.",
        slugHelperText: "A URL amigável que será usada para acessar sua página",
        autoGenerateSlug: "Gerar URL automaticamente a partir do título",
        fullUrl: "URL completa da sua landing page:",
        defineUrl: "(definir-url)",
        pageActive: "Página ativa",
        pageInactive: "Página inativa",
        pageActiveDescription: "Sua página está publicada e acessível ao público.",
        pageInactiveDescription: "Sua página está em modo rascunho e só ficará visível após ativação.",
        published: "Publicada",
        draft: "Rascunho",
        pageCreated: "Esta página foi criada em {createdDate}",
        pageUpdated: "e atualizada pela última vez em {updatedDate}"
      },
      fields: {
        name: "Nome",
        email: "E-mail",
        phone: "Telefone",
        namePlaceholder: "Digite seu nome",
        emailPlaceholder: "Digite seu e-mail",
        phonePlaceholder: "Digite seu telefone"
      },
      affiliates: {
        title: "Gerenciar Afiliados",
        newAffiliate: "Novo Afiliado",
        createFirst: "Criar Primeiro Afiliado",
        noAffiliatesTitle: "Nenhum afiliado cadastrado",
        noAffiliatesMessage: "Crie afiliados para esta landing page e gere links personalizados para rastreamento.",
        name: "Nome",
        email: "E-mail",
        phone: "Telefone",
        commissionRate: "Taxa de Comissão (%)",
        active: "Ativo",
        inactive: "Inativo",
        activeLabel: "Afiliado ativo",
        status: "Status",
        actions: "Ações",
        uniqueLink: "Link Único",
        qrCode: "QR Code",
        qr: "QR",
        stats: "Stats",
        statistics: "Estatísticas",
        code: "Código",
        clicks: "Clicks",
        conversions: "Conversões",
        rate: "Taxa",
        copyLink: "Copiar Link",
        generateQR: "Gerar QR Code",
        viewStats: "Ver Estatísticas",
        edit: "Editar",
        delete: "Excluir",
        close: "Fechar",
        confirmDelete: "Tem certeza que deseja excluir este afiliado?",
        createSuccess: "Afiliado criado com sucesso!",
        updateSuccess: "Afiliado atualizado com sucesso!",
        deleteSuccess: "Afiliado excluído com sucesso!",
        createError: "Erro ao criar afiliado",
        updateError: "Erro ao atualizar afiliado",
        deleteError: "Erro ao excluir afiliado",
        loadError: "Erro ao carregar afiliados",
        linkCopied: "Link copiado para a área de transferência!",
        linkCopyError: "Erro ao copiar link",
        qrTitle: "QR Code - {name}",
        downloadQR: "Baixar QR Code",
        saveQR: "Salvar QR",
        modalTitle: "Gerenciar Afiliado",
        modalCreate: "Novo Afiliado",
        modalEdit: "Editar Afiliado",
        cancel: "Cancelar",
        create: "Criar",
        update: "Atualizar"
      },
      table: {
        title: "Título",
        url: "URL",
        status: "Status",
        qrCode: "QR Code",
        actions: "Ações"
      },
      actions: {
        copyUrl: "Copiar URL",
        activate: "Clique para ativar",
        deactivate: "Clique para desativar",
        viewQrCode: "Ver QR Code",
        edit: "Editar",
        delete: "Excluir"
      },
      status: {
        title: "Status:",
        active: "Ativa",
        inactive: "Inativa"
      },
      pagination: {
        itemsPerPage: "Itens por página:",
        showing: "{showing} de {total} landing pages"
      },
      modals: {
        deleteTitle: "Excluir Landing Page",
        deleteMessage: "Tem certeza que deseja excluir esta landing page? Esta ação não pode ser desfeita."
      },
      messages: {
        companyIdNotFound: "Company ID não encontrado",
        urlCopied: "URL copiada com sucesso!",
        urlCopyError: "Erro ao copiar URL",
        deleteSuccess: "Landing page excluída com sucesso!",
        deleteError: "Erro ao excluir landing page",
        statusChangeSuccess: "Landing page {status} com sucesso!",
        statusChangeError: "Erro ao alterar status da landing page",
        activated: "ativada",
        deactivated: "desativada",
        loadError: "Erro ao carregar landing pages"
      },
      form: {
        submitSuccess: "Formulário enviado com sucesso!",
        submitError: "Erro ao enviar formulário. Tente novamente.",
        validationError: "Por favor, corrija os campos destacados.",
        phoneValidation: {
          checking: "Verificando número...",
          valid: "Número válido no WhatsApp",
          invalid: "Número não encontrado no WhatsApp",
          error: "Erro ao verificar número"
        }
      },
      queue: {
        label: "Fila de Atendimento",
        none: "Nenhuma fila (contatos ficam sem fila)",
        helperText: "Selecione a fila onde os contatos desta landing page serão direcionados",
        loading: "Carregando filas..."
      }
    },
    groups: {
      title: "Gerenciamento de Grupos",
      newGroup: "Novo Grupo",
      searchPlaceholder: "Pesquisar grupos...",
      noGroupsFound: "Nenhum grupo encontrado",
      noGroupName: "Grupo sem nome",
      selectGroupToSeeRequests: "Selecione um grupo para ver as solicitações de entrada",
      groupDeleted: "Grupo removido com sucesso",
      groupForceDeleted: "Grupo removido do sistema com sucesso",
      deleteConfirmTitle: "Confirmar Saída do Grupo",
      deleteConfirmMessage: "Tem certeza que deseja sair do grupo '{name}'? Você não receberá mais mensagens deste grupo.",
      forceDeleteConfirmTitle: "Confirmar Remoção do Sistema",
      forceDeleteConfirmMessage: "Tem certeza que deseja remover o grupo '{name}' do sistema?",
      forceDeleteWarning: "⚠️ Atenção: Esta ação removerá o grupo permanentemente do sistema, incluindo histórico de mensagens e tickets.",
      forceDelete: "Remover do Sistema",
      table: {
        name: "Grupo",
        participants: "Participantes",
        permission: "Permissão",
        createdAt: "Criado em"
      },
      tabs: {
        list: "Lista de Grupos",
        requests: "Solicitações",
        automaticSeries: "Séries Automáticas",
        dashboard: "Dashboard",
        extractContacts: "Extrair Contatos",
        importContacts: "Importar Contatos"
      },
      dashboard: {
        title: "Dashboard de Grupos",
        subtitle: "Monitore métricas e desempenho dos grupos em tempo real",
        metrics: {
          totalGroups: "Total de Grupos",
          managedGroups: "Grupos Gerenciados",
          activeGroups: "Grupos Ativos",
          totalParticipants: "Total de Participantes",
          averageOccupancy: "Ocupação Média",
          activeSeries: "Séries Ativas",
          groupsCreatedToday: "Grupos Criados Hoje",
          nearCapacity: "Próximos da Capacidade",
          totalConnections: "Conexões Ativas",
          systemHealth: "Saúde do Sistema"
        },
        charts: {
          occupancyDistribution: "Distribuição de Ocupação",
          groupsOverTime: "Grupos ao Longo do Tempo",
          participantsGrowth: "Crescimento de Participantes",
          seriesPerformance: "Performance das Séries"
        },
        recentActivity: {
          title: "Atividades Recentes",
          groupCreated: "Grupo criado automaticamente",
          groupFull: "Grupo atingiu capacidade máxima",
          seriesActivated: "Série ativada",
          participantJoined: "Participante adicionado",
          thresholdReached: "Limite de ocupação atingido",
          monitoringRun: "Verificação automática executada"
        },
        alerts: {
          groupsNearCapacity: "grupos próximos da capacidade",
          seriesNeedAttention: "séries precisam de atenção",
          connectionsDown: "conexões offline"
        },
        status: {
          healthy: "Saudável",
          warning: "Atenção",
          critical: "Crítico",
          lastCheck: "Última Verificação",
          performance: "Performance do Sistema"
        },
        actions: {
          refresh: "Atualizar",
          runMonitoring: "Executar Monitoramento",
          viewDetails: "Ver Detalhes",
          exportReport: "Exportar Relatório"
        }
      },
      permissions: {
        admin: "Administrador",
        participant: "Participante",
        unknown: "Desconhecido"
      },
      actions: {
        view: "Visualizar",
        edit: "Editar",
        extract: "Extrair Contatos",
        requests: "Solicitações",
        leaveGroup: "Sair do Grupo",
        removeFromSystem: "Remover do Sistema",
        sync: "Sincronizar",
        joinGroup: "Entrar em Grupo"
      },
      alerts: {
        syncTitle: "Sincronizar Grupos do WhatsApp",
        syncMessage: "Encontramos {count} conexão(ões) WhatsApp ativa(s). Sincronize para importar todos os grupos existentes e criar tickets automáticos.",
        noWhatsAppTitle: "Nenhuma conexão WhatsApp encontrada",
        noWhatsAppMessage: "Para gerenciar grupos, você precisa ter pelo menos uma conexão WhatsApp ativa. Configure uma conexão WhatsApp primeiro.",
        ticketsCreatedTitle: "Tickets de Grupos Criados",
        ticketsCreatedMessage: "{count} ticket(s) de grupo(s) foram criados durante a sincronização. Verifique sua lista de atendimentos."
      },
      emptyStates: {
        noGroups: {
          title: "Nenhum grupo encontrado",
          description: "Sincronize seus grupos do WhatsApp para começar a gerenciá-los e criar tickets automáticos",
          actionLabel: "Sincronizar Grupos"
        },
        requests: {
          title: "Solicitações de Entrada",
          description: "Selecione um grupo para ver as solicitações de entrada"
        }
      },
      stats: {
        admin: "Admin",
        participant: "Participante",
        automatic: "Automático",
        series: "Séries"
      },
      toasts: {
        syncComplete: "Sincronização concluída! {ticketsCreated} ticket(s) criado(s) e {ticketsUpdated} ticket(s) reaberto(s). Verifique sua lista de atendimentos.",
        newGroupCreated: "Novo grupo criado automaticamente: {groupName}",
        viewTickets: "Ver Tickets",
        titles: {
          dashboardUpdated: "Dashboard Atualizado",
          dataLoaded: "Dados Carregados",
          dashboardError: "Erro no Dashboard",
          summaryGenerated: "Resumo Gerado",
          dataExported: "Dados Exportados",
          summaryError: "Erro no Resumo",
          statusUpdated: "Status Atualizado",
          seriesActivated: "Série Ativada",
          statusError: "Erro no Status",
          notificationSent: "Notificação Enviada",
          alertConfigured: "Alerta Configurado",
          notificationError: "Erro na Notificação",
          groupJoined: "Grupo Ingressado",
          inviteAccepted: "Convite Aceito",
          joinError: "Erro no Ingresso",
          contactsImported: "Contatos Importados",
          importCompleted: "Importação Concluída",
          importError: "Erro na Importação",
          seriesCreated: "Série Criada",
          configurationSaved: "Configuração Salva",
          seriesError: "Erro na Série",
          informationSaved: "Informações Salvas",
          dataUpdated: "Dados Atualizados",
          informationError: "Erro nas Informações",
          adjustmentsApplied: "Ajustes Aplicados",
          configurationError: "Erro na Configuração",
          requestApproved: "Solicitação Aprovada",
          requestRejected: "Pedido Rejeitado",
          requestError: "Erro na Solicitação",
          contactsExtracted: "Contatos Extraídos",
          fileGenerated: "Arquivo Gerado",
          extractionError: "Erro na Extração",
          extractionCompleted: "Extração Concluída",
          listCreated: "Lista Criada",
          creationError: "Erro na Criação",
          groupCreated: "Grupo Criado"
        }
      }
    },
    servicePanel: {
      allowRealTime: "Painel de Atendimentos"
    },
    financial: {
      invoices: "Faturas",
      details: "Detalhes",
      users: "Usuários",
      connections: "Conexões",
      queues: "Filas",
      value: "Valor",
      expirationDate: "Data Venc.",
      status: "Status",
      action: "Ação"
    },
    statusFilter: {
      statusFilter: "Filtro por Status"
    },
    momentsUser: {
      services: "Atendimentos:",
      pending: "Pendentes",
      noqueue: "SEM FILA"
    },
    campaignsPhrase: {
      campaignsFlow: "Fluxo de Campanhas",
      campaigns: "Campanhas",
      name: "Nome",
      status: "Status",
      newCampaignWithFlowByPhrase: "Nova campanha com fluxo por frase",
      editCampaignWithFlowByPhrase: "Editar campanha com fluxo por frase",
      phraseTriggerName: "Nome do disparo por frase",
      chooseAStream: "Escolha um fluxo",
      whichPhraseTriggersTheFlow: " Qual frase dispara o fluxo?",
      selectAConnection: " Selecione uma Conexão",
      cancel: "CANCELAR",
      createCampaign: "CRIAR CAMPANHA",
      saveCampaign: "Salvar Campanha"
    },
    whatsappModalRel: {
      form: {
        isOficial: "Relatório do Atendimento",
        ticketId: "ID do Ticket",
        client: "Cliente",
        number: "Número",
        agent: "Atendente",
        date: "Data",
        lastMessage: "Última Mensagem",
        fullReport: "O relatório completo foi anexado acima",
        resolveAndTriggerIntegration: "Resolver e Disparar Integração",
        elementNotFoundForExport: "Elemento não encontrado para exportar.",
        reportFilename: "relatório_atendimento"
      }
    },
    chatList: {
      noMessages: "Nenhuma mensagem",
      admin: "Administrador",
      member: "Membro",
      searchChat: "Procurar chat...",
      createNewChat: "Criar novo chat",
      searchUser: "Procurar usuário...",
      noUserFound: "Nenhum usuário encontrado",
      noUserAvailable: "Nenhum usuário disponível",
      cancel: "Cancelar",
      details: "Detalhes",
      deleteChat: "Excluir Conversa",
      deleteChatConfirm: "Esta ação não pode ser revertida, confirmar?",
      detailsTitle: "Detalhes",
      edit: "Editar",
      delete: "Excluir",
      now: "agora",
      minutesAgo: "{{count}}m atrás",
      hoursAgo: "{{count}}h atrás",
    },
    chatMessages: {
      deleted: "Esta mensagem foi apagada",
      deletedAdmin: "Mensagem apagada - visível apenas para administradores",
      reply: "Responder",
      edit: "Editar",
      delete: "Excluir",
      forward: "Encaminhar",
      editMessage: "Editar Mensagem",
      save: "Salvar",
      cancel: "Cancelar",
      deleteMessage: "Deletar Mensagem",
      deleteMessageConfirm: "Tem certeza que deseja deletar esta mensagem?",
      forwardMessage: "Encaminhar Mensagem",
      selectChat: "Selecione o chat",
      doubleClickToReply: "Clique duas vezes para responder",
      edited: "(editada)",
      forwarded: "(encaminhada)",
      typeMessage: "Digite uma mensagem...",
      send: "Enviar",
      noMessages: "Nenhuma mensagem",
      loading: "Carregando...",
      replyingTo: "Respondendo a",
      clickToGoToOriginal: "Clique para ir até a mensagem original",
      interactiveButtons: {
        quickReply: "Resposta rápida",
        url: "Abrir link",
        call: "Fazer ligação",
        listItem: "Selecionar opção"
      }
    },
    chatPopover: {
      reply: "Responder",
      edit: "Editar",
      delete: "Excluir",
      forward: "Encaminhar",
      cancel: "Cancelar",
      confirmDelete: "Confirmar Exclusão",
      confirm: "Confirmar",
      deleteMessage: "Tem certeza que deseja excluir esta mensagem?",
      editMessage: "Editar Mensagem",
      save: "Salvar",
      forwardMessage: "Encaminhar Mensagem",
      selectChat: "Selecione o chat",
      noChats: "Nenhum chat disponível"
    },
    chatIndex: {
      chats: "Chats",
      groups: "Grupos",
      new: "Novo",
      messages: "Mensagens",
      search: "Buscar...",
      noChats: "Nenhum chat encontrado",
      noGroups: "Nenhum grupo encontrado",
      noMessages: "Nenhuma mensagem",
      loading: "Carregando...",
      error: "Erro ao carregar dados",
      addGroupPhoto: "Adicionar Foto do Grupo",
      changeGroupPhoto: "Alterar Foto do Grupo",
      groupName: "Nome do Grupo",
      groupDescription: "Descrição do Grupo",
      save: "Salvar",
      cancel: "Cancelar",
      createGroup: "Criar Grupo",
      editGroup: "Editar Grupo",
      deleteGroup: "Deletar Grupo",
      deleteGroupConfirm: "Tem certeza que deseja deletar este grupo?",
      edit: "Editar",
      delete: "Excluir",
      details: "Detalhes",
      groupDetails: "Detalhes do Grupo",
      title: "Título",
      description: "Descrição",
      modal: {
        title: "Criar grupo",
        name: "Nome do grupo",
        description: "Descrição do grupo",
        create: "Criar",
        cancel: "Cancelar",
        save: "Salvar",
        edit: "Editar",
        editTitle: "Editar Grupo"
      }
    },
    whitelabel: {
      primaryColorLight: "Cor Primária (Tema Claro)",
      primaryColorDark: "Cor Primária (Tema Escuro)",
      appName: "Nome da Aplicação",
      logoLight: "Logo (Tema Claro)",
      logoDark: "Logo (Tema Escuro)",
      favicon: "Favicon",
      backgroundLight: "Imagem de Fundo (Tema Claro)",
      backgroundDark: "Imagem de Fundo (Tema Escuro)",
      backgroundColorLight: "Cor de Fundo (Tema Claro)",
      backgroundColorDark: "Cor de Fundo (Tema Escuro)",
      backgroundColors: "Cores de Fundo",
      backgroundColorHelp: "Cores de fundo são usadas quando nenhuma imagem de fundo é definida",
      chooseColor: "Escolher Cor",
      preview: "Visualizar",
      delete: "Excluir",
      upload: "Enviar",
      availableLanguages: "Idiomas Disponíveis",
      atLeastOneLanguage: "Pelo menos um idioma deve estar habilitado",
      showTabLabels: "Exibir rótulos nas abas",
      showTabLabelsDescription: "Quando desabilitado, as abas dos tickets exibirão apenas ícones sem texto",
      showTabBadges: "Exibir contadores nas abas",
      showTabBadgesDescription: "Controla a visibilidade dos badges com números nas abas de tickets",
      showActionButtons: "Exibir botões de ação",
      showActionButtonsDescription: "Controla a visibilidade dos botões de ação (todos, novo ticket, fechar todos, etc.)",
      enableFiltersSection: "Habilitar seção de filtros",
      enableFiltersSectionDescription: "Permite ativar/desativar a funcionalidade de filtros de tickets",
      sections: {
        general: "Configurações Gerais",
        generalDescription: "Configure o nome e informações básicas da aplicação",
        colors: "Cores e Temas",
        colorsDescription: "Personalize as cores primárias para temas claro e escuro",
        logos: "Logos e Imagens",
        logosDescription: "Carregue os logos e imagens de fundo da aplicação",
        interface: "Interface do Sistema",
        interfaceDescription: "Configure opções de exibição e comportamento da interface",
        languages: "Idiomas Disponíveis",
        languagesDescription: "Selecione quais idiomas estarão disponíveis no sistema"
      }
    },
    talkAi: {
      title: "Talk.Ai",
      selection: {
        title: "O que você gostaria de criar?",
        subtitle: "Escolha entre criar um prompt personalizado ou configurar um assistente de IA",
        createPrompt: "Criar Prompt",
        createPromptDescription: "Crie prompts personalizados para respostas automatizadas",
        createAssistant: "Criar Assistente",
        createAssistantDescription: "Configure assistentes de IA para atendimento inteligente"
      },
      assistantType: {
        title: "Tipo de Assistente",
        subtitle: "Escolha o tipo de assistente que deseja criar",
        voiceAssistant: "Assistente de Voz",
        voiceDescription: "Assistente com capacidades de voz para conversas por áudio",
        textAssistant: "Assistente de Texto",
        textDescription: "Assistente focado em conversas por texto"
      },
      assistants: {
        title: "Assistentes de IA",
        addButton: "Novo Assistente",
        table: {
          name: "Nome",
          type: "Tipo",
          queue: "Fila",
          status: "Status",
          actions: "Ações",
          active: "Ativo",
          inactive: "Inativo"
        },
        form: {
          title: "Criar Assistente",
          editTitle: "Editar Assistente",
          basicInfo: "Informações Básicas",
          name: "Nome do Assistente",
          description: "Descrição",
          aiConfiguration: "Configuração da IA",
          openaiApiKey: "Chave da API OpenAI",
          openaiAssistantId: "ID do Assistente OpenAI (opcional)",
          model: "Modelo da IA",
          maxTokens: "Máximo de Tokens",
          temperature: "Temperatura",
          prompt: "Instruções do Sistema",
          tools: "Ferramentas Disponíveis",
          toolsDescription: "Selecione as ferramentas que o assistente pode usar",
          voiceSettings: "Configurações de Voz",
          voiceEnabled: "Habilitar Voz",
          ttsVoice: "Voz TTS",
          ttsModel: "Modelo TTS",
          autoTranscribeVoice: "Auto Transcrever Voz",
          autoGenerateVoice: "Auto Gerar Áudio",
          advancedSettings: "Configurações Avançadas",
          maxConversationMessages: "Máximo de Mensagens no Contexto",
          isActive: "Assistente Ativo",
          agentMode: "Modo de Agente",
          agentModeDescription: "Configure como o assistente interage com clientes e agentes humanos",
          agentModeType: "Tipo de Modo",
          allowHumanTakeover: "Permitir transferência para humano",
          transferKeywords: "Palavras-chave para transferência",
          transferKeywordsHelp: "Palavras separadas por vírgula que acionam transferência para agente humano (ex: atendente, humano, transferir)",
          enableWebSocketSuggestions: "Habilitar sugestões em tempo real",
          suggestionDelay: "Delay das sugestões (segundos)",
          suggestionDelayHelp: "Tempo em segundos antes de mostrar sugestões para o agente",
          suggestContextualResponses: "Sugerir respostas contextuais",
          suggestCustomerInsights: "Sugerir insights do cliente",
          files: "Arquivos",
          filesDescription: "Gerencie arquivos para o assistente usar como base de conhecimento",
          uploadFile: "Enviar Arquivo",
          uploading: "Enviando...",
          noFiles: "Nenhum arquivo enviado",
          save: "Salvar",
          cancel: "Cancelar"
        },
        models: {
          "gpt-4": "GPT-4 - Melhor qualidade",
          "gpt-4-turbo-preview": "GPT-4 Turbo - Otimizado",
          "gpt-3.5-turbo": "GPT-3.5 Turbo - Rápido e econômico"
        },
        ttsModels: {
          "tts-1": "TTS-1 - Padrão (rápido)",
          "tts-1-hd": "TTS-1 HD - Alta qualidade"
        },
        messages: {
          created: "Assistente criado com sucesso!",
          updated: "Assistente atualizado com sucesso!",
          deleted: "Assistente deletado com sucesso!",
          fileUploaded: "Arquivo enviado com sucesso!",
          fileDeleted: "Arquivo removido com sucesso!"
        },
        deleteDialog: {
          title: "Deletar Assistente",
          message: "Tem certeza que deseja deletar este assistente? Esta ação não pode ser desfeita."
        },
        agentModes: {
          prompt: "Modo Prompt - Resposta baseada em instruções fixas",
          agentDirect: "Agente Direto - IA responde diretamente ao cliente",
          agentAssistant: "Assistente de Agente - IA auxilia agentes humanos com sugestões"
        }
      },
      buttons: {
        back: "Voltar",
        startVoiceAssistant: "Iniciar Assistente de Voz",
        voiceAssistantActive: "Assistente de voz ativo - Clique para abrir interface",
        voiceAssistantConnected: "Assistente de voz conectado - Clique para ativar",
        loadingAssistant: "Carregando assistente de voz...",
        noAssistantAvailable: "Nenhum assistente de voz disponível para esta fila",
        configureAssistants: "Configure assistentes de voz para esta fila no painel Talk.AI"
      }
    },
      voiceAssistants: {
        title: "Assistentes de Voz",
        subtitle: "Configure assistentes de voz com IA para atendimento automatizado",
        addButton: "Novo Assistente",
        searchPlaceholder: "Buscar assistentes...",
        noAssistants: "Nenhum assistente configurado",
        loading: "Carregando assistentes...",
        table: {
          name: "Nome",
          description: "Descrição",
          queue: "Fila",
          model: "Modelo",
          voice: "Voz TTS",
          status: "Status",
          actions: "Ações",
          active: "Ativo",
          inactive: "Inativo"
        },
        form: {
          title: "Assistente de Voz",
          editTitle: "Editar Assistente",
          name: "Nome",
          namePlaceholder: "Nome do assistente",
          description: "Descrição",
          descriptionPlaceholder: "Descrição do assistente",
          prompt: "Prompt do Sistema",
          promptPlaceholder: "Instruções para o assistente de IA...",
          openaiApiKey: "Chave da API OpenAI",
          openaiApiKeyPlaceholder: "sk-...",
          openaiAssistantId: "ID do Assistente OpenAI",
          openaiAssistantIdPlaceholder: "asst_...",
          model: "Modelo OpenAI",
          maxTokens: "Máximo de Tokens",
          temperature: "Temperatura",
          queue: "Fila Associada",
          voiceSettings: "Configurações de Voz",
          voiceEnabled: "Habilitar Voz",
          ttsVoice: "Voz TTS",
          ttsModel: "Modelo TTS",
          whisperModel: "Modelo Whisper",
          maxConversationMessages: "Máximo de Mensagens no Contexto",
          autoTranscribeVoice: "Auto Transcrever Voz",
          autoGenerateVoice: "Auto Gerar Resposta em Voz",
          isActive: "Assistente Ativo",
          testConnection: "Testar Conexão",
          save: "Salvar",
          cancel: "Cancelar"
        },
        voices: {
          alloy: "Alloy - Voz neutra e clara",
          echo: "Echo - Voz masculina",
          fable: "Fable - Voz feminina suave",
          onyx: "Onyx - Voz masculina profunda",
          nova: "Nova - Voz feminina jovem",
          shimmer: "Shimmer - Voz feminina brilhante"
        },
        models: {
          "gpt-4": "GPT-4 - Melhor qualidade",
          "gpt-4-turbo-preview": "GPT-4 Turbo - Versão otimizada",
          "gpt-3.5-turbo": "GPT-3.5 Turbo - Rápido e econômico"
        },
        ttsModels: {
          "tts-1": "TTS-1 - Qualidade padrão, mais rápido",
          "tts-1-hd": "TTS-1 HD - Alta qualidade, mais lento"
        },
        messages: {
          created: "Assistente criado com sucesso!",
          updated: "Assistente atualizado com sucesso!",
          deleted: "Assistente deletado com sucesso!",
          connectionSuccess: "Conexão com OpenAI estabelecida com sucesso!",
          connectionError: "Erro na conexão com OpenAI",
          processVoiceSuccess: "Mensagem de voz processada com sucesso!",
          processVoiceError: "Erro ao processar mensagem de voz"
        },
        deleteDialog: {
          title: "Deletar Assistente",
          message: "Tem certeza que deseja deletar este assistente? Esta ação não pode ser desfeita.",
          confirm: "Deletar",
          cancel: "Cancelar"
        },
        processing: {
          title: "Processamento de Voz",
          transcribing: "Transcrevendo áudio...",
          generatingResponse: "Gerando resposta...",
          generatingTts: "Gerando áudio TTS...",
          completed: "Processamento concluído",
          error: "Erro no processamento"
        },
        streaming: {
          startSession: "Iniciar Sessão de Voz",
          endSession: "Finalizar Sessão",
          recording: "Gravando...",
          processing: "Processando...",
          speaking: "Falando...",
          sessionActive: "Sessão de voz ativa",
          sessionEnded: "Sessão finalizada",
          microphonePermission: "Permissão do microfone necessária",
          audioNotSupported: "Áudio não suportado neste navegador",
          connecting: "Conectando...",
          connected: "Conectado",
          disconnected: "Desconectado",
          connectionError: "Erro de conexão",
          listening: "Ouvindo...",
          startRecording: "Clique para falar",
          stopRecording: "Clique para parar",
          voiceSettings: "Configurações de Voz",
          enableVoiceAssistant: "Habilitar Assistente de Voz",
          disableVoiceAssistant: "Desabilitar Assistente de Voz",
          voiceActivated: "Assistente de voz ativado",
          voiceDeactivated: "Assistente de voz desativado"
        },
        voiceInterface: {
          title: "Assistente de Voz",
          subtitle: "Conversação por voz em tempo real",
          startConversation: "Iniciar Conversa",
          endConversation: "Finalizar Conversa",
          speakNow: "Fale agora",
          tapToSpeak: "Toque para falar",
          releaseToSend: "Solte para enviar",
          holdToTalk: "Segure para falar",
          voiceMessage: "Mensagem de voz",
          transcription: "Transcrição",
          aiResponse: "Resposta da IA",
          playback: "Reproduzir",
          pause: "Pausar",
          stop: "Parar",
          download: "Baixar",
          waveform: "Forma de onda",
          duration: "Duração",
          timestamp: "Timestamp"
        },
        ttsSettings: {
          title: "Configurações de TTS",
          selectVoice: "Selecionar Voz",
          voicePreview: "Prévia da Voz",
          playPreview: "Reproduzir Prévia",
          voice: {
            alloy: "Alloy - Voz neutra e equilibrada",
            echo: "Echo - Voz masculina clara",
            fable: "Fable - Voz feminina suave",
            onyx: "Onyx - Voz masculina profunda",
            nova: "Nova - Voz feminina jovem",
            shimmer: "Shimmer - Voz feminina elegante"
          },
          speed: "Velocidade",
          pitch: "Tom",
          volume: "Volume",
          testText: "Texto de teste",
          defaultTestText: "Olá, esta é uma prévia da voz selecionada.",
          applySettings: "Aplicar Configurações",
          resetSettings: "Redefinir"
        },
        audioControls: {
          play: "Reproduzir",
          pause: "Pausar",
          stop: "Parar",
          mute: "Silenciar",
          unmute: "Ativar som",
          volumeUp: "Aumentar volume",
          volumeDown: "Diminuir volume",
          seekForward: "Avançar",
          seekBackward: "Retroceder",
          playbackSpeed: "Velocidade de reprodução",
          loading: "Carregando áudio...",
          error: "Erro ao carregar áudio",
          duration: "Duração: {duration}",
          currentTime: "Tempo atual: {time}"
        },
        connectionStatus: {
          connecting: "Conectando ao servidor de voz...",
          connected: "Conectado - Pronto para conversar",
          disconnected: "Desconectado - Reconectando...",
          error: "Erro de conexão - Tente novamente",
          reconnecting: "Reconectando...",
          timeout: "Timeout de conexão",
          networkError: "Erro de rede",
          serverError: "Erro do servidor"
        }
      },
    messagesAPIInstructions: {
      endpoint: "Endpoint:",
      method: "Método:",
      post: "POST",
      headers: "Headers:",
      headerAuthorization:
        "Authorization Bearer (token registrado) e Content-Type (application/json)",
      body: "Body:",
      fieldNumber: '"number": "558599999999"',
      fieldBody: '"body": "Mensagem"',
      fieldUserId: '"userId": ID do usuário ou ""',
      fieldQueueId: '"queueId": ID da Fila ou ""',
      fieldSendSignature: '"sendSignature": Assinar mensagem - true/false',
      fieldCloseTicket: '"closeTicket": Encerrar o ticket - true/false',
      singMessage: "Assinar mensagem - true/false",
      closeTicket: "Encerrar o ticket - true/false",
      testSend: "Teste de envio"
    },
    recurrenceSection: {
      title: "Recorrência",
      description:
        "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma única vez, não altere nada nesta seção.",
      labelInterval: "Intervalo",
      intervalFilterValue: "Valor do Intervalo",
      sendAsManyTimes: " Enviar quantas vezes",
      shipNormallyOnNonbusinessDays: " Enviar normalmente em dias não úteis",
      sendOneBusinessDayBefore: "Enviar um dia útil antes",
      sendOneBusinessDayLater: "Enviar um dia útil depois",
      options: {
        days: "Dias",
        weeks: "Semanas",
        months: "Meses",
        minutes: "Minutos"
      }
    },
          birthday: {
        title: "Aniversários",
        modal: {
          title: "🎉 Aniversariantes de Hoje! 🎂",
          users: "Usuários:",
          contacts: "Contatos:",
          noData: "Nenhum aniversariante hoje",
          close: "Fechar",
          userAge: "{{age}} anos",
          contactAge: "{{age}} anos",
          congratulations: "Parabéns!"
        },
        settings: {
          title: "Configurações de Aniversário",
          userBirthdayEnabled: "Ativar aniversários de usuários",
          contactBirthdayEnabled: "Ativar aniversários de contatos",
          userBirthdayMessage: "Mensagem para usuários",
          contactBirthdayMessage: "Mensagem para contatos",
          sendBirthdayTime: "Horário de envio",
          createAnnouncementForUsers: "Criar informativos para usuários",
          save: "Salvar",
          success: "Configurações salvas com sucesso!",
          placeholders: {
            userMessage: "Parabéns pelo seu aniversário, {nome}!",
            contactMessage: "Parabéns pelo seu aniversário, {nome}! Desejamos muitas felicidades!",
            sendTime: "09:00:00"
          }
        },
        toast: {
          userBirthday: "🎉 Hoje é aniversário de {{name}}!",
          contactBirthday: "🎂 O contato {{name}} faz aniversário hoje!",
          messageSent: "Mensagem de aniversário enviada com sucesso!",
          messageError: "Erro ao enviar mensagem de aniversário"
        }
      },
      notificationManager: {
        title: "Notificações Push",
        browserNotSupported: "Seu navegador não suporta notificações push. Atualize para uma versão mais recente ou use Chrome, Firefox, Safari ou Edge.",
        activeDescription: "Você receberá notificações em tempo real sobre novos tickets e mensagens.",
        inactiveDescription: "Ative as notificações para receber alertas em tempo real sobre novos tickets e mensagens.",
        enabled: "Notificações ativadas",
        disabled: "Notificações desativadas",
        sendTest: "Enviar Teste",
        refreshList: "Atualizar Lista",
        activeDevices: "Dispositivos Ativos ({{count}})",
        unknownDevice: "Dispositivo desconhecido",
        unknownBrowser: "Navegador desconhecido",
        registeredAgo: "Registrado {{time}}",
        active: "Ativo",
        inactive: "Inativo",
        permissionDenied: "As notificações estão bloqueadas pelo navegador. Para ativá-las, clique no ícone de cadeado na barra de endereços e permita notificações para este site."
      },
      toasts: {
        ticket: {
          updated: "Ticket Atualizado",
          error: "Erro no Ticket",
          statusChanged: "Status Alterado",
          assignmentChanged: "Atribuição Alterada",
          quickMessageError: "Erro Resposta"
        },
        messageInput: {
          sent: "Mensagem enviada com sucesso",
          error: "Erro ao enviar mensagem",
          fileAttached: "Arquivo anexado com sucesso",
          invalidFormat: "Formato de arquivo inválido",
          aiError: "Erro ao processar solicitação de IA"
        },
        campaigns: {
          created: "Campanha criada com sucesso",
          started: "Disparo iniciado com sucesso",
          paused: "Campanha pausada com sucesso",
          removed: "Campanha removida com sucesso",
          error: "Erro no processamento da campanha",
          accessDenied: "Acesso negado para esta funcionalidade",
          recurrenceStopped: "Recorrência interrompida com sucesso"
        },
        contacts: {
          saved: "Contato salvo com sucesso",
          updated: "Dados atualizados com sucesso",
          removed: "Contato removido com sucesso",
          validationError: "Erro de validação nos dados",
          duplicateError: "Contato já existe no sistema"
        },
        users: {
          created: "Usuário criado com sucesso",
          updated: "Usuário atualizado com sucesso",
          removed: "Usuário removido com sucesso",
          passwordChanged: "Senha alterada com sucesso",
          permissionError: "Erro de permissão",
          chatCreated: "Chat criado com sucesso",
          chatsGenerated: "Chats gerados com sucesso"
        },
        queues: {
          created: "Fila criada com sucesso",
          updated: "Fila atualizada com sucesso",
          removed: "Fila removida com sucesso",
          configSaved: "Configuração salva com sucesso",
          error: "Erro ao processar fila"
        },
        general: {
          success: "Operação realizada com sucesso",
          error: "Erro ao processar solicitação",
          loading: "Processando...",
          saved: "Dados salvos com sucesso",
          updated: "Atualizado com sucesso",
          removed: "Removido com sucesso"
        }
      },
      fiscal: {
        title: "Configuração Fiscal",
        subtitle: "Configure dados fiscais e certificado digital para emissão de NFe",
        description: "Preencha os dados fiscais da sua empresa e faça upload do certificado digital para habilitar a emissão de Notas Fiscais Eletrônicas (NFe).",
        status: {
          incomplete: "Configuração Fiscal Incompleta",
          missingFields: "Campos obrigatórios pendentes:"
        },
        validation: {
          title: "Status da Configuração Fiscal",
          ready: "Configuração Fiscal Completa",
          readyDesc: "Sua empresa está pronta para emitir NFe",
          incomplete: "Configuração Fiscal Incompleta",
          incompleteDesc: "campo(s) obrigatório(s) pendente(s)",
          missingFields: "Campos obrigatórios pendentes:",
          warnings: "Avisos:"
        },
        company: {
          title: "Dados da Empresa",
          cnpj: "CNPJ",
          stateRegistration: "Inscrição Estadual",
          municipalRegistration: "Inscrição Municipal",
          fiscalRegime: "Regime Fiscal",
          regimes: {
            SIMPLES_NACIONAL: "Simples Nacional",
            LUCRO_PRESUMIDO: "Lucro Presumido",
            LUCRO_REAL: "Lucro Real",
            MEI: "MEI"
          }
        },
        address: {
          title: "Endereço Fiscal",
          zipCode: "CEP",
          street: "Rua",
          number: "Número",
          complement: "Complemento",
          neighborhood: "Bairro",
          city: "Cidade",
          state: "Estado",
          cityCode: "Código IBGE da Cidade",
          stateCode: "Código IBGE do Estado"
        },
        nfe: {
          title: "Configurações NFe",
          environment: "Ambiente NFe",
          environments: {
            HOMOLOGACAO: "Homologação (Testes)",
            PRODUCAO: "Produção"
          },
          series: "Série NFe",
          emailFrom: "Email para NFe",
          observations: "Observações Fiscais Padrão",
          observationsPlaceholder: "Observações que aparecerão em todas as NFes...",
          autoGenerate: "Gerar NFe automaticamente quando pedido for faturado",
          autoEmail: "Enviar NFe por email automaticamente",
          autoNapp: "Enviar dados fiscais para NAPP automaticamente"
        },
        certificate: {
          title: "Certificado Digital",
          info: "Certificado A1 necessário: Faça upload do arquivo .p12 ou .pfx do seu certificado digital.",
          selectFile: "Selecionar Certificado",
          password: "Senha do Certificado",
          validity: "Validade do Certificado:",
          expired: "Certificado digital expirado",
          valid: "Certificado válido até"
        },
        actions: {
          save: "Salvar Configuração",
          saving: "Salvando...",
          testConnection: "Testar Conexão",
          testing: "Testando..."
        },
        messages: {
          saveSuccess: "Configuração fiscal salva com sucesso!",
          saveError: "Erro ao salvar configuração fiscal",
          testSuccess: "Teste de conexão realizado com sucesso!",
          testError: "Erro no teste de conexão",
          loadError: "Erro ao carregar configuração fiscal"
        }
      },
      napp: {
        notConfigured: {
          orders: {
            title: "Pedidos E-commerce Não Configurados",
            subtitle: "Para visualizar e gerenciar seus pedidos de e-commerce, você precisa configurar a integração com a NAPP Solutions."
          },
          analytics: {
            title: "Analytics de Pedidos Não Disponível",
            subtitle: "Para acessar as análises avançadas e métricas de performance dos seus pedidos, configure primeiro a integração NAPP."
          },
          sales: {
            title: "Central de Vendas Não Configurada",
            subtitle: "Para acessar o dashboard executivo e análises avançadas de vendas, você precisa configurar a integração com a NAPP Solutions."
          },
          general: {
            title: "Integração NAPP Não Configurada",
            subtitle: "Para acessar os recursos de e-commerce, você precisa configurar a integração com a NAPP Solutions."
          },
          info: {
            title: "Como Configurar",
            description: "A integração NAPP Solutions permite sincronizar pedidos de marketplaces como iFood, Americanas, Magazine Luiza e outros. Você receberá uma chave de API da NAPP para configurar a conexão."
          },
          configureButton: "Configurar Integração NAPP",
          support: "Precisa de ajuda? Entre em contato com o suporte da NAPP Solutions"
        },
        features: {
          orders: {
            title: "Gestão de Pedidos",
            description: "Sincronize e gerencie pedidos de todas as suas plataformas de e-commerce em um só lugar."
          },
          analytics: {
            title: "Analytics Avançado",
            description: "Acompanhe métricas detalhadas, KPIs e performance de vendas com dashboards interativos."
          },
          sales: {
            title: "Central de Vendas",
            description: "Dashboard executivo com análise comparativa entre plataformas e relatórios avançados."
          }
        },
        title: "Configuração NAPP E-commerce",
        subtitle: "Configure a integração com a NAPP Solutions para gerenciar pedidos de e-commerce",
        sections: {
          basicConfiguration: "Configuração Básica",
          notifications: "Notificações"
        },
        tabs: {
          connection: "Conexão",
          notifications: "Notificações",
          templates: "Templates"
        },
        connection: {
          title: "Configurações de Conexão",
          apiKey: "Chave da API",
          apiKeyHelper: "Chave de acesso fornecida pela NAPP Solutions",
          environment: "Ambiente",
          environments: {
            production: "Produção",
            sandbox: "Sandbox",
            staging: "Staging"
          },
          syncInterval: "Intervalo de Sincronização",
          intervals: {
            5: "5 minutos",
            10: "10 minutos",
            15: "15 minutos",
            30: "30 minutos",
            60: "1 hora"
          },
          feedLimit: "Limite de Itens por Sincronização",
          webhookUrl: "URL do Webhook",
          webhookHelper: "📝 Esta é a URL que você deve configurar no painel da NAPP para receber atualizações automáticas de pedidos",
          testConnection: "Testar Conexão",
          saveConfig: "Salvar Configuração"
        },
        notifications: {
          title: "Configurações de Notificações",
          autoCreateContacts: "Criar Contatos Automaticamente",
          autoCreateContactsHelper: "Criar contatos automaticamente a partir dos dados do cliente no pedido",
          enableNotifications: "Habilitar Notificações WhatsApp",
          enableNotificationsHelper: "Enviar notificações automáticas via WhatsApp para clientes",
          statusNotifications: "Status que Acionam Notificações",
          createTickets: "Criar Tickets Automaticamente",
          createTicketsHelper: "Criar tickets automaticamente para determinados status de pedido",
          statusTickets: "Status que Criam Tickets"
        },
        templates: {
          title: "Templates de Notificação",
          description: "📝 Habilite as notificações WhatsApp para configurar os templates de mensagem",
          status: {
            PAYMENT_APPROVED: "Pagamento Aprovado",
            SHIPMENT: "Produto Enviado",
            DELIVERED: "Produto Entregue",
            CANCELLED: "Pedido Cancelado",
            PAYMENT_PENDING: "Pagamento Pendente",
            IN_PREPARATION: "Em Preparação",
            READY_FOR_PICKUP: "Pronto para Retirada"
          }
        },
        buttons: {
          save: "Salvar",
          cancel: "Cancelar",
          test: "Testar",
          sync: "Sincronizar Agora"
        },
        messages: {
          saveSuccess: "Configuração NAPP salva com sucesso!",
          saveError: "Erro ao salvar configuração NAPP",
          testSuccess: "Conexão testada com sucesso!",
          testError: "Erro ao testar conexão",
          syncSuccess: "Sincronização iniciada com sucesso!",
          syncError: "Erro ao iniciar sincronização",
          loadError: "Erro ao carregar configurações NAPP"
        },
        validation: {
          apiKeyRequired: "Chave da API é obrigatória",
          environmentRequired: "Ambiente é obrigatório",
          intervalRequired: "Intervalo de sincronização é obrigatório"
        }
      },
      orders: {
        title: "Pedidos E-commerce",
        subtitle: "Gerenciamento de pedidos sincronizados da NAPP Solutions",
        table: {
          code: "Código",
          customer: "Cliente",
          platform: "Plataforma",
          status: "Status",
          total: "Total",
          date: "Data",
          actions: "Ações"
        },
        status: {
          PAYMENT_PENDING: "Pagamento Pendente",
          PAYMENT_APPROVED: "Pagamento Aprovado",
          IN_PREPARATION: "Em Preparação",
          READY_FOR_PICKUP: "Pronto para Retirada",
          SHIPMENT: "Enviado",
          DELIVERED: "Entregue",
          CANCELLED: "Cancelado",
          REFUNDED: "Reembolsado"
        },
        filters: {
          title: "Filtros",
          status: "Status",
          platform: "Plataforma",
          customer: "Cliente",
          dateRange: "Período",
          search: "Buscar",
          clear: "Limpar"
        },
        details: {
          title: "Detalhes do Pedido",
          orderInfo: "Informações do Pedido",
          customerInfo: "Dados do Cliente",
          items: "Itens",
          timeline: "Histórico",
          notifications: "Notificações"
        },
        buttons: {
          viewDetails: "Ver Detalhes",
          updateStatus: "Atualizar Status",
          resendNotification: "Reenviar Notificação",
          close: "Fechar"
        },
        messages: {
          loadError: "Erro ao carregar pedidos",
          updateSuccess: "Status do pedido atualizado com sucesso!",
          updateError: "Erro ao atualizar status do pedido",
          notificationSuccess: "Notificação reenviada com sucesso!",
          notificationError: "Erro ao reenviar notificação"
        }
      },
      orderAnalytics: {
        title: "Analytics de Pedidos",
        subtitle: "Métricas e relatórios de performance dos pedidos e-commerce",
        tabs: {
          overview: "Visão Geral",
          platforms: "Plataformas",
          performance: "Performance",
          reports: "Relatórios"
        },
        kpis: {
          totalOrders: "Total de Pedidos",
          totalRevenue: "Receita Total",
          averageValue: "Ticket Médio",
          conversionRate: "Taxa de Conversão",
          completedOrders: "Pedidos Concluídos",
          pendingOrders: "Pedidos Pendentes",
          cancelledOrders: "Pedidos Cancelados"
        },
        charts: {
          ordersOverTime: "Pedidos ao Longo do Tempo",
          revenueOverTime: "Receita ao Longo do Tempo",
          statusDistribution: "Distribuição por Status",
          platformComparison: "Comparação por Plataforma",
          topProducts: "Produtos Mais Vendidos"
        },
        periods: {
          today: "Hoje",
          yesterday: "Ontem",
          last7days: "Últimos 7 dias",
          last30days: "Últimos 30 dias",
          thisMonth: "Este mês",
          lastMonth: "Mês anterior",
          custom: "Período personalizado"
        },
        buttons: {
          export: "Exportar",
          refresh: "Atualizar",
          viewReport: "Ver Relatório"
        },
        messages: {
          loadError: "Erro ao carregar analytics",
          exportSuccess: "Relatório exportado com sucesso!",
          exportError: "Erro ao exportar relatório",
          noData: "Nenhum dado disponível para o período selecionado"
        }
      },
      sales: {
        management: {
          title: "Central de Vendas",
          subtitle: "Gestão Avançada de Performance de Vendas",
          tab: "Vendas"
        },
        kpis: {
          totalRevenue: "Receita Total",
          totalOrders: "Total de Pedidos",
          averageOrderValue: "Ticket Médio",
          conversionRate: "Taxa de Conversão",
          newCustomers: "Novos Clientes",
          growth: "Crescimento"
        },
        charts: {
          salesTrends: "Tendências de Vendas",
          platformPerformance: "Performance por Plataforma",
          platformComparison: "Análise Comparativa de Plataformas",
          topPerformer: "Top Performer"
        },
        filters: {
          period: "Período",
          last7days: "Últimos 7 dias",
          last30days: "Últimos 30 dias",
          last90days: "Últimos 90 dias",
          lastYear: "Último ano",
          platform: "Plataforma",
          allPlatforms: "Todas",
          grouping: "Agrupamento",
          daily: "Diário",
          weekly: "Semanal",
          monthly: "Mensal"
        },
        platformMetrics: {
          orders: "Pedidos",
          revenue: "Receita",
          averageValue: "Ticket Médio",
          conversion: "Conversão",
          growth: "vs período anterior"
        },
        export: {
          json: "JSON",
          csv: "CSV",
          success: "Relatório exportado com sucesso",
          error: "Erro ao exportar relatório"
        },
        buttons: {
          refresh: "Atualizar dados",
          export: "Exportar",
          viewDetails: "Ver Detalhes"
        },
        messages: {
          loadError: "Erro ao carregar dados de vendas",
          refreshSuccess: "Dados atualizados com sucesso",
          noData: "Nenhum dado disponível para o período selecionado"
        }
      },
      logistics: {
        title: "Sistema de Logística",
        description: "Gerencie rastreamento, entregas e acompanhe toda a jornada logística dos seus pedidos",
        tracking: {
          title: "Rastreamento",
          code: "Código de Rastreamento",
          url: "URL de Rastreamento",
          provider: "Provedor",
          carrier: "Transportadora",
          estimatedDelivery: "Previsão de Entrega",
          status: "Status",
          lastUpdate: "Última Atualização",
          noTracking: "Nenhuma informação de rastreamento disponível",
          updateTracking: "Atualizar Rastreamento",
          syncExternal: "Sincronizar com Provedor",
          updateSuccess: "Rastreamento atualizado com sucesso!",
          updateError: "Erro ao atualizar rastreamento",
          fetchError: "Erro ao consultar rastreamento",
          timeline: "Timeline de Eventos",
          addEvent: "Adicionar Evento"
        },
        delivery: {
          title: "Entrega",
          status: "Status de Entrega",
          deliveredAt: "Data de Entrega",
          recipientName: "Nome do Recebedor",
          location: "Local",
          updateDelivery: "Atualizar Entrega",
          markAsDelivered: "Marcar como Entregue",
          deliveryFailed: "Entrega Falhada",
          updateSuccess: "Status de entrega atualizado com sucesso!",
          updateError: "Erro ao atualizar status de entrega"
        },
        events: {
          ORDER_CREATED: "Pedido Criado",
          PAYMENT_CONFIRMED: "Pagamento Confirmado",
          IN_PREPARATION: "Em Preparação",
          READY_FOR_PICKUP: "Pronto para Retirada",
          SHIPPED: "Enviado",
          OUT_FOR_DELIVERY: "Saiu para Entrega",
          DELIVERED: "Entregue",
          DELIVERY_FAILED: "Falha na Entrega",
          RETURNED: "Devolvido",
          CANCELLED: "Cancelado",
          CUSTOMS_CLEARANCE: "Liberação Alfandegária",
          SORTING_CENTER: "Centro de Distribuição",
          TRANSFER: "Em Trânsito",
          VEHICLE_LOADED: "Carregado no Veículo",
          DELIVERY_ATTEMPTED: "Tentativa de Entrega"
        },
        providers: {
          NAPP: "NAPP Solutions",
          CORREIOS: "Correios",
          LOGGI: "Loggi",
          JADLOG: "Jadlog",
          TOTAL_EXPRESS: "Total Express",
          AZUL_CARGO: "Azul Cargo",
          MERCADO_ENVIOS: "Mercado Envios",
          IFOOD: "iFood Delivery",
          UBER_DIRECT: "Uber Direct",
          other: "Outro"
        },
        sync: {
          title: "Sincronização",
          external: "Sincronização Externa",
          selectProvider: "Selecionar Provedor",
          syncNow: "Sincronizar Agora",
          autoSync: "Sincronização Automática",
          success: "Sincronização realizada com sucesso!",
          error: "Erro na sincronização",
          lastSync: "Última Sincronização"
        },
        stats: {
          title: "Estatísticas de Logística",
          totalOrders: "Total de Pedidos",
          ordersWithTracking: "Com Rastreamento",
          delivered: "Entregues",
          inTransit: "Em Trânsito",
          pending: "Pendentes",
          averageDeliveryTime: "Tempo Médio de Entrega",
          deliveryPerformance: "Performance de Entrega",
          onTime: "No Prazo",
          delayed: "Atrasados",
          failed: "Falharam",
          byProvider: "Por Provedor",
          fetchError: "Erro ao carregar estatísticas",
          days: "dias",
          percentage: "%"
        },
        validation: {
          codeRequired: "Código de rastreamento é obrigatório",
          codeLength: "Código deve ter entre 3 e 50 caracteres",
          correiosFormat: "Formato inválido. Use: AA123456789BR",
          providerRequired: "Provedor é obrigatório",
          statusRequired: "Status é obrigatório"
        },
        buttons: {
          save: "Salvar",
          cancel: "Cancelar",
          update: "Atualizar",
          sync: "Sincronizar",
          track: "Rastrear",
          viewDetails: "Ver Detalhes",
          addTracking: "Adicionar Rastreamento",
          editTracking: "Editar Rastreamento"
        },
        messages: {
          noEvents: "Nenhum evento de rastreamento encontrado",
          trackingAdded: "Código de rastreamento adicionado!",
          eventAdded: "Evento adicionado à timeline",
          syncStarted: "Sincronização iniciada...",
          dataUpdated: "Dados atualizados com sucesso"
        },
        modal: {
          addTracking: {
            title: "Adicionar Rastreamento",
            description: "Informe os dados de rastreamento do pedido"
          },
          updateDelivery: {
            title: "Atualizar Entrega",
            description: "Atualize o status de entrega do pedido"
          },
          trackingDetails: {
            title: "Detalhes do Rastreamento",
            description: "Timeline completa do rastreamento"
          }
        }
      },
      messageReactions: {
        reaction: "reação",
        reactions: "reações",
        youReacted: "você reagiu"
      },
      birthdaySettings: {
        title: "Configurações de Aniversário",
        description: "Configure notificações automáticas de aniversário para usuários e contatos",
        enabled: "Habilitado",
        disabled: "Desabilitado",
        loading: "Carregando configurações...",
        saving: "Salvando...",
        save: "Salvar Configurações",
        refresh: "Atualizar",
        sections: {
          userBirthdays: "Aniversários de Usuários",
          contactBirthdays: "Aniversários de Contatos",
          generalSettings: "Configurações Gerais"
        },
        userBirthdayEnabled: {
          title: "Habilitar aniversários de usuários",
          description: "Enviar notificações automáticas nos aniversários dos usuários do sistema"
        },
        contactBirthdayEnabled: {
          title: "Habilitar aniversários de contatos",
          description: "Enviar notificações automáticas nos aniversários dos contatos"
        },
        createAnnouncementForUsers: {
          title: "Criar anúncios para usuários",
          description: "Criar anúncios automáticos nos aniversários dos usuários"
        },
        userBirthdayMessage: {
          title: "Mensagem de aniversário do usuário",
          description: "Personalize a mensagem enviada nos aniversários dos usuários"
        },
        contactBirthdayMessage: {
          title: "Mensagem de aniversário do contato",
          description: "Personalize a mensagem enviada nos aniversários dos contatos"
        },
        sendBirthdayTime: {
          title: "Horário de envio",
          description: "Defina o horário para envio das notificações de aniversário"
        },
        defaultMessages: {
          userBirthday: "🎉 Feliz aniversário! Desejamos muito sucesso e felicidade!",
          contactBirthday: "🎂 Feliz aniversário! Que este novo ano seja repleto de alegrias!"
        },
        messages: {
          saveSuccess: "Configurações salvas com sucesso!",
          saveSuccessDesc: "As configurações de aniversário foram atualizadas",
          saveError: "Erro ao salvar configurações"
        },
        errors: {
          title: "Erro nas Configurações",
          loadFailed: "Falha ao carregar configurações",
          routeNotFound: "Rota de configurações não encontrada",
          unauthorized: "Sem permissão para acessar configurações",
          serverError: "Erro interno do servidor",
          networkError: "Erro de conexão",
          generic: "Erro inesperado"
        },
        debug: {
          title: "Informações de Debug",
          toggle: "Alternar Debug",
          fetchingSettings: "Buscando configurações...",
          userInfo: "Usuário: {{name}} (ID: {{id}}, Empresa: {{companyId}})",
          responseReceived: "Resposta recebida",
          settingsLoaded: "Configurações carregadas com sucesso",
          requestError: "Erro na requisição",
          fetchCompleted: "Busca finalizada",
          componentMounted: "Componente montado",
          settingChanged: "Configuração alterada: {{field}} = {{value}}",
          saving: "Salvando configurações...",
          saveSuccess: "Configurações salvas com sucesso",
          saveError: "Erro ao salvar configurações"
        }
      },
      finalizationSettings: {
        title: "Finalização de Atendimento",
        description: "Configure motivos de finalização e opções de valor de venda",
        sections: {
          generalSettings: "Configurações Gerais",
          finalizationReasons: "Motivos de Finalização"
        },
        salesValue: {
          label: "Informar valor da venda ao finalizar atendimento",
          description: "Quando habilitado, o campo de valor da venda aparecerá no modal de finalização"
        },
        addReason: "Adicionar Motivo",
        table: {
          name: "Nome",
          description: "Descrição",
          actions: "Ações",
          noDescription: "Sem descrição"
        },
        actions: {
          edit: "Editar",
          delete: "Excluir"
        },
        noReasons: "Nenhum motivo cadastrado. Clique em 'Adicionar Motivo' para começar.",
        confirmDelete: "Tem certeza que deseja excluir este motivo?",
        modal: {
          addTitle: "Adicionar Motivo",
          editTitle: "Editar Motivo",
          nameLabel: "Nome do Motivo",
          nameRequired: "Nome é obrigatório",
          descriptionLabel: "Descrição (opcional)",
          descriptionPlaceholder: "Descreva o motivo da finalização",
          cancel: "Cancelar",
          add: "Adicionar",
          update: "Atualizar",
          saving: "Salvando..."
        },
        messages: {
          success: "Configurações Salvas",
          reasonCreated: "Motivo criado com sucesso!",
          reasonUpdated: "Motivo atualizado com sucesso!",
          reasonDeleted: "Motivo excluído com sucesso!",
          settingUpdated: "Configuração atualizada com sucesso!"
        },
        errors: {
          title: "Erro na Configuração",
          fetchFailed: "Erro ao buscar motivos",
          nameRequired: "Nome do motivo é obrigatório",
          saveReason: "Erro ao salvar motivo",
          deleteReason: "Erro ao excluir motivo",
          updateSetting: "Erro ao atualizar configuração"
        }
      },
      uploaderCert: {
        title: "Certificado Digital",
        description: "Upload e gerenciamento de certificados digitais para API PIX",
        sections: {
          uploadCertificate: "Upload de Certificado"
        },
        status: {
          fileSelected: "Arquivo Selecionado",
          noFile: "Nenhum Arquivo",
          p12Format: "Formato P12",
          uploaded: "Enviado"
        },
        form: {
          selectOption: "Escolha uma opção",
          efiCertificate: "Certificado Efí p12 API PIX",
          uploadTitle: "Clique ou arraste o certificado aqui",
          uploadDescription: "Suporte para arquivos .p12 (máximo 10MB)",
          selectedFile: "Arquivo selecionado",
          uploadButton: "Enviar Certificado",
          uploading: "Enviando..."
        },
        messages: {
          fileSelected: "Arquivo Selecionado",
          success: "Arquivo Carregado",
          uploadSuccess: "Arquivo enviado com sucesso!"
        },
        warnings: {
          title: "Upload Pendente",
          selectFile: "Escolha um arquivo!",
          selectOption: "Escolha um destino!"
        },
        errors: {
          title: "Erro na Configuração",
          noPermission: "Sem permissão para acessar!",
          invalidFormat: "Use somente arquivos em formato p12!",
          uploadFailed: "Erro ao enviar arquivo"
        }
      },
      performanceMonitor: {
        title: "Monitor de Performance",
        description: "Monitoramento em tempo real do cache de configurações e detecção de loops",
        sections: {
          metrics: "Métricas de Performance",
          systemStatus: "Status do Sistema"
        },
        status: {
          healthy: "Saudável",
          loopsDetected: "Loops Detectados",
          hitRate: "Taxa de Acerto",
          requests: "Requisições",
          excellent: "Excelente",
          warning: "Atenção",
          critical: "Crítico",
          unknown: "Desconhecido"
        },
        metrics: {
          hitRate: "Hit Rate",
          hitRateDesc: "Taxa de acerto do cache",
          requests: "Requisições",
          requestsDesc: "Total de requisições",
          response: "Resposta",
          responseDesc: "Tempo médio de resposta",
          cache: "Cache",
          cacheDesc: "Hits / Misses"
        },
        system: {
          loopDetection: "Detecção de Loops Infinitos",
          loopsDetected: "loops detectados nos últimos 30 minutos",
          noLoops: "Nenhum loop infinito detectado recentemente",
          cacheEfficiency: "Eficiência do Cache",
          hits: "de acertos",
          requestsPerHour: "Requisições por Hora",
          requestsLastHour: "requisições na última hora"
        },
        actions: {
          refresh: "Atualizar",
          resetMetrics: "Reset Métricas"
        },
        lastUpdate: "Última atualização",
        lastReset: "Última reset"
      },
      asterisk: {
        phone: "Telefone",
        call: "Chamada",
        calling: "Chamando...",
        ringing: "Tocando...",
        answered: "Atendida",
        hangup: "Desligar",
        answer: "Atender",
        hold: "Reter",
        transfer: "Transferir",
        record: "Gravar",
        mute: "Silenciar",
        unmute: "Ativar som",
        bridge: "Conferência",
        settings: "Configurações Asterisk",
        testConnection: "Testar Conexão",
        newConnection: "Nova Conexão",
        editConnection: "Editar Conexão",
        deleteConnection: "Deletar Conexão",
        connectionName: "Nome da Conexão",
        host: "Host/IP",
        port: "Porta",
        username: "Usuário",
        password: "Senha",
        secure: "Conexão Segura (HTTPS/WSS)",
        status: "Status",
        connected: "Conectado",
        disconnected: "Desconectado",
        connecting: "Conectando...",
        error: "Erro",
        connect: "Conectar",
        disconnect: "Desconectar",
        actions: "Ações",
        duration: "Duração",
        direction: "Direção",
        inbound: "Entrada",
        outbound: "Saída",
        callerNumber: "Número Chamador",
        calleeNumber: "Número Chamado",
        startTime: "Hora Início",
        endTime: "Hora Fim",
        failed: "Falhou",
        busy: "Ocupado",
        noAnswer: "Não Atendida",
        recording: "Gravação",
        contact: "Contato",
        ticket: "Ticket",
        user: "Usuário",
        idle: "Inativo",
        incoming: "Recebendo",
        reject: "Recusar",
        resume: "Retomar",
        activeCall: "Chamada Ativa",
        incomingCall: "Chamada Recebida",
        enterPhoneNumber: "Digite o número do telefone",
        selectConnection: "Selecione uma conexão",
        connection: "Conexão",
        close: "Fechar",
        backspace: "Voltar",
        clear: "Limpar",
        noCallHistory: "Nenhum histórico de chamadas",
        createTicket: "Criar Ticket",
        initiateCall: "Iniciar Chamada",
        enterNumber: "Digite o número",
        callInitiated: "Chamada iniciada com sucesso",
        callAnswered: "Chamada atendida",
        callEnded: "Chamada finalizada",
        connectionTested: "Conexão testada com sucesso",
        connectionError: "Erro na conexão",
        noActiveConnections: "Nenhuma conexão ativa encontrada",
        notifications: {
          callIncoming: "Chamada recebida de {{number}}",
          callAnswered: "Chamada atendida",
          callHangup: "Chamada finalizada",
          connectionConnected: "Conexão {{name}} estabelecida",
          connectionDisconnected: "Conexão {{name}} perdida",
          connectionError: "Erro na conexão {{name}}: {{error}}"
        },
        dialpad: {
          title: "Discador",
          placeholder: "Digite o número..."
        },
        callModal: {
          title: "Chamada Ativa",
          callTo: "Ligando para",
          callFrom: "Recebendo de",
          timer: "Duração"
        },
        forms: {
          validation: {
            nameRequired: "Nome é obrigatório",
            hostRequired: "Host é obrigatório",
            usernameRequired: "Usuário é obrigatório",
            passwordRequired: "Senha é obrigatória",
            portRange: "Porta deve estar entre 1 e 65535",
            numberRequired: "Número é obrigatório",
            connectionExists: "Já existe uma conexão com este nome"
          }
        },
        toasts: {
          connectionCreated: "Conexão criada com sucesso",
          connectionUpdated: "Conexão atualizada com sucesso",
          connectionDeleted: "Conexão deletada com sucesso",
          connectionTested: "Conexão testada com sucesso",
          connectionConnected: "Conectado com sucesso",
          connectionDisconnected: "Desconectado com sucesso",
          callInitiated: "Chamada iniciada",
          callAnswered: "Chamada atendida",
          callHangup: "Chamada finalizada",
          callEnded: "Chamada finalizada",
          callMuted: "Chamada silenciada",
          callUnmuted: "Som da chamada ativado",
          callOnHold: "Chamada em espera",
          callResumed: "Chamada retomada",
          connectionTestFailed: "Falha no teste de conexão",
          callHistoryDeleted: "Histórico de chamada excluído com sucesso",
          callHistoryExported: "Histórico de chamadas exportado com sucesso",
          endpointCreated: "Endpoint criado com sucesso",
          endpointUpdated: "Endpoint atualizado com sucesso",
          endpointDeleted: "Endpoint excluído com sucesso",
          error: "Erro na operação"
        },
        missed: "Perdida",
        unknownCaller: "Desconhecido",
        rejectCall: "Recusar Chamada",
        answerCall: "Atender Chamada",
        hangupCall: "Desligar Chamada",
        callTo: "Ligar para",
        makeCall: "Fazer Chamada",
        maximize: "Maximizar",
        minimize: "Minimizar",
        history: "Histórico",
        conference: "Conferência",
        callConnected: "Chamada Conectada",
        callRinging: "Tocando",
        callMissed: "Chamada Perdida",
        sendMessage: "Enviar Mensagem",
        callBack: "Retornar Chamada",
        unknwon: "Desconhecido",
        transferCall: "Transferir Chamada",
        transferType: "Tipo de Transferência",
        blindTransfer: "Transferência Direta",
        attendedTransfer: "Transferência Assistida",
        immediate: "Imediato",
        consultFirst: "Consultar Primeiro",
        transferDestination: "Destino da Transferência",
        enterNumberOrExtension: "Digite número ou ramal",
        searchContacts: "Buscar Contatos",
        searchByNameOrNumber: "Buscar por nome ou número",
        noContactsFound: "Nenhum contato encontrado",
        transferSummary: "Resumo da Transferência",
        from: "De",
        to: "Para",
        type: "Tipo",
        notSelected: "Não selecionado",
        cancel: "Cancelar",
        startConsult: "Iniciar Consulta",
        transferNow: "Transferir Agora",
        completeTransfer: "Completar Transferência",
        consultCallActive: "Chamada de Consulta Ativa",
        cancelConsult: "Cancelar Consulta",
        conferenceCall: "Chamada em Conferência",
        participants: "Participantes",
        activeParticipants: "Participantes Ativos",
        totalParticipants: "Total de Participantes",
        bridgeId: "ID da Ponte",
        noParticipants: "Nenhum Participante",
        addParticipantsToStart: "Adicione participantes para começar",
        addParticipant: "Adicionar Participante",
        phoneNumber: "Número de Telefone",
        add: "Adicionar",
        muted: "Silenciado",
        speaking: "Falando",
        removeParticipant: "Remover Participante",
        conferenceSettings: "Configurações da Conferência",
        recordConference: "Gravar Conferência",
        muteOnJoin: "Silenciar ao Entrar",
        waitForHost: "Aguardar Moderador",
        maxParticipants: "Máximo de Participantes",
        updateSettings: "Atualizar Configurações",
        muteAll: "Silenciar Todos",
        endConference: "Encerrar Conferência",
        unhold: "Retirar de Espera",
        stopRecording: "Parar Gravação",
        startRecording: "Iniciar Gravação",
        callRecording: "Gravação de Chamada",
        recordingSettings: "Configurações de Gravação",
        recordingInProgress: "Gravação em Andamento",
        recordingReady: "Pronto para Gravar",
        nowPlaying: "Reproduzindo",
        audioFormat: "Formato de Áudio",
        recordQuality: "Qualidade da Gravação",
        low: "Baixa",
        medium: "Média",
        high: "Alta",
        autoSaveRecordings: "Salvar Gravações Automaticamente",
        cloudSync: "Sincronização na Nuvem",
        saveSettings: "Salvar Configurações",
        savedRecordings: "Gravações Salvas",
        noRecordings: "Nenhuma Gravação",
        recordingsWillAppearHere: "As gravações aparecerão aqui",
        playRecording: "Reproduzir Gravação",
        downloadRecording: "Baixar Gravação",
        deleteRecording: "Excluir Gravação",
        confirmDeleteRecording: "Tem certeza que deseja excluir esta gravação?",
        storageUsage: "Uso de Armazenamento",
        dateTime: "Data/Hora",
        rowsPerPage: "Linhas por página",
        of: "de",
        deleteRecord: "Excluir Registro",
        callHistoryWillAppearHere: "O histórico de chamadas aparecerá aqui",
        unknown: "Desconhecido",
        connectionInfo: "Informações da Conexão",
        authentication: "Autenticação",
        advancedSettings: "Configurações Avançadas",
        connectionNameHelp: "Nome identificador para esta conexão",
        hostHelp: "IP ou hostname do servidor Asterisk",
        portHelp: "Porta do serviço ARI (padrão: 8088)",
        secureHelp: "Use HTTPS/WSS para conexão segura",
        usernameHelp: "Usuário configurado no Asterisk para ARI",
        passwordHelp: "Senha do usuário ARI",
        applicationNameHelp: "Nome da aplicação registrada no Asterisk",
        reconnectAttemptsHelp: "Número de tentativas de reconexão",
        reconnectIntervalHelp: "Intervalo entre tentativas em milissegundos",
        timeoutHelp: "Timeout de conexão em milissegundos",
        isActiveHelp: "Conexão ativa e disponível para uso",
        testing: "Testando...",
        saving: "Salvando...",
        previous: "Anterior",
        next: "Próximo",
        updateConnection: "Atualizar Conexão",
        createConnection: "Criar Conexão",
        saveConnectionFailed: "Falha ao salvar conexão",
        testConnectionHelp: "Teste a conectividade e funcionalidade desta conexão",
        userAssignment: "Atribuição de Usuário",
        selectUser: "Selecione um usuário para este endpoint",
        noUsersAvailable: "Nenhum usuário disponível para endpoint",
        selectedUser: "Usuário Selecionado",
        basicConfiguration: "Configuração Básica",
        endpointName: "Nome do Endpoint",
        endpointNameHelp: "Nome identificador do endpoint",
        endpointIdentifier: "Identificador do Endpoint",
        endpointIdentifierHelp: "Identificador único no Asterisk",
        contextHelp: "Contexto de discagem no dialplan",
        codecHelp: "Codecs suportados separados por vírgula",
        dtmfMode: "Modo DTMF",
        directMedia: "Mídia Direta",
        directMediaHelp: "Permitir mídia direta entre endpoints",
        mailboxHelp: "Caixa postal associada (opcional)",
        configurationPreview: "Visualização da Configuração",
        testEndpoint: "Testar Endpoint",
        testEndpointHelp: "Teste a configuração do endpoint",
        updateEndpoint: "Atualizar Endpoint",
        createEndpoint: "Criar Endpoint",
        saveEndpointFailed: "Falha ao salvar endpoint",
        endpointTestFailed: "Falha no teste do endpoint",
        confirmDeleteConnection: "Tem certeza que deseja excluir esta conexão?",
        confirmDeleteEndpoint: "Tem certeza que deseja excluir este endpoint?",
        userNotFound: "Usuário não encontrado",
        networkConnectivity: "Conectividade de Rede",
        networkConnectivityDesc: "Verificar conectividade básica com o servidor",
        authenticationDesc: "Verificar credenciais de autenticação",
        asteriskConnection: "Conexão Asterisk",
        asteriskConnectionDesc: "Estabelecer conexão ARI com Asterisk",
        performanceTest: "Teste de Performance",
        performanceTestDesc: "Medir latência e throughput",
        functionalTest: "Teste Funcional",
        functionalTestDesc: "Verificar funcionalidades básicas",
        startingTest: "Iniciando teste para",
        testingNetworkConnectivity: "Testando conectividade de rede...",
        testingAuthentication: "Testando autenticação...",
        testingAsteriskConnection: "Testando conexão Asterisk...",
        testingPerformance: "Testando performance...",
        testingFunctionality: "Testando funcionalidades...",
        testCompletedWithErrors: "Teste concluído com erros",
        testCompletedWithWarnings: "Teste concluído com avisos",
        testCompletedSuccessfully: "Teste concluído com sucesso",
        testFailed: "Teste falhou",
        testProgress: "Progresso do Teste",
        networkConnectivitySuccess: "Conectividade de rede OK",
        networkConnectivityFailed: "Falha na conectividade de rede",
        slowNetworkResponse: "Resposta de rede lenta",
        slowResponse: "Resposta lenta",
        networkConnected: "Rede conectada",
        networkError: "Erro de rede",
        authenticationSuccess: "Autenticação bem-sucedida",
        authenticationFailed: "Falha na autenticação",
        authenticationSuccessful: "Autenticação realizada com sucesso",
        authenticationError: "Erro de autenticação",
        asteriskConnectionSuccess: "Conexão Asterisk estabelecida",
        asteriskConnectionFailed: "Falha na conexão Asterisk",
        ariConnectionEstablished: "Conexão ARI estabelecida",
        ariConnectionError: "Erro na conexão ARI",
        performanceTestSuccess: "Teste de performance OK",
        performanceTestFailed: "Falha no teste de performance",
        highLatencyDetected: "Alta latência detectada",
        highLatency: "Alta latência",
        performanceGood: "Performance boa",
        performanceError: "Erro de performance",
        functionalTestSuccess: "Teste funcional OK",
        functionalTestFailed: "Falha no teste funcional",
        allFunctionsWorking: "Todas as funções funcionando",
        functionalError: "Erro funcional",
        passed: "Passou",
        warning: "Aviso",
        pending: "Pendente",
        running: "Executando",
        startTest: "Iniciar Teste",
        retryTest: "Repetir Teste",
        testSummary: "Resumo do Teste",
        connectionMetrics: "Métricas de Conexão",
        testLogs: "Logs do Teste",
        metric: "Métrica",
        value: "Valor",
        connectionManagement: "Gerenciamento de Conexões",
        endpointManagement: "Gerenciamento de Endpoints",
        noConnections: "Nenhuma Conexão",
        noConnectionsDescription: "Você ainda não configurou nenhuma conexão Asterisk",
        noEndpoints: "Nenhum Endpoint",
        noEndpointsDescription: "Você ainda não configurou nenhum endpoint",
        noConnectionsForEndpoints: "Configure uma conexão Asterisk antes de criar endpoints",
        name: "Nome",
        active: "Ativo",
        inactive: "Inativo",
        edit: "Editar",
        test: "Testar",
        delete: "Excluir",
        refresh: "Atualizar",
        editEndpoint: "Editar Endpoint",
        newEndpoint: "Novo Endpoint",
        connections: {
          title: "Conexões Asterisk",
          addConnection: "Adicionar Conexão",
          searchPlaceholder: "Pesquisar conexões...",
          lastActivity: "Última Atividade",
          stats: {
            total: "Total de Conexões",
            connected: "Conectadas",
            disconnected: "Desconectadas",
            inactive: "Inativas"
          },
          selectedCount: "{{count}} conexões selecionadas",
          noFilterResults: "Nenhuma conexão encontrada com os filtros aplicados",
          noConnections: "Nenhuma conexão configurada",
          deleteTitle: "Excluir Conexão",
          deleteMultipleTitle: "Excluir Múltiplas Conexões",
          deleteConfirm: "Tem certeza que deseja excluir a conexão '{{name}}'?",
          deleteMultipleConfirm: "Tem certeza que deseja excluir {{count}} conexões selecionadas?",
          bulkConnect: "Conectar Selecionadas",
          bulkDisconnect: "Desconectar Selecionadas"
        },
        endpoints: {
          title: "Endpoints Asterisk",
          addEndpoint: "Adicionar Endpoint",
          searchPlaceholder: "Pesquisar endpoints...",
          technology: "Tecnologia",
          callerid: "Caller ID",
          registered: "Registrado",
          unregistered: "Não Registrado",
          noUser: "Sem Usuário",
          noConnection: "Sem Conexão",
          selectedCount: "{{count}} endpoints selecionados",
          noFilterResults: "Nenhum endpoint encontrado com os filtros aplicados",
          noEndpoints: "Nenhum endpoint configurado",
          deleteTitle: "Excluir Endpoint",
          deleteMultipleTitle: "Excluir Múltiplos Endpoints",
          deleteConfirm: "Tem certeza que deseja excluir o endpoint '{{name}}'?",
          deleteMultipleConfirm: "Tem certeza que deseja excluir {{count}} endpoints selecionados?",
          stats: {
            total: "Total de Endpoints",
            registered: "Registrados",
            unregistered: "Não Registrados",
            sipEndpoints: "Endpoints SIP"
          }
        },
        callHistory: {
          title: "Histórico de Chamadas",
          export: "Exportar",
          searchPlaceholder: "Pesquisar chamadas...",
          filters: {
            today: "Hoje",
            yesterday: "Ontem",
            week: "Esta Semana",
            month: "Este Mês",
            custom: "Personalizado"
          },
          startDate: "Data Início",
          endDate: "Data Fim",
          caller: "Chamador",
          callee: "Chamado",
          endpoint: "Endpoint",
          internal: "Interna",
          recording: "Gravação",
          playRecording: "Reproduzir Gravação",
          downloadRecording: "Baixar Gravação",
          noRecording: "Sem Gravação",
          details: "Detalhes",
          selectedCount: "{{count}} chamadas selecionadas",
          noFilterResults: "Nenhuma chamada encontrada com os filtros aplicados",
          noCalls: "Nenhuma chamada no período selecionado",
          deleteTitle: "Excluir Chamada",
          deleteMultipleTitle: "Excluir Múltiplas Chamadas",
          deleteConfirm: "Tem certeza que deseja excluir esta chamada?",
          deleteMultipleConfirm: "Tem certeza que deseja excluir {{count}} chamadas selecionadas?",
          callDetails: "Detalhes da Chamada",
          basicInfo: "Informações Básicas",
          participants: "Participantes",
          callId: "ID da Chamada",
          audioNotSupported: "Seu navegador não suporta reprodução de áudio",
          exportTitle: "Exportar Histórico",
          exportDescription: "Selecione o formato para exportar o histórico de chamadas",
          callback: "Retornar Chamada",
          stats: {
            totalCalls: "Total de Chamadas",
            inbound: "Recebidas",
            missed: "Perdidas",
            avgDuration: "Duração Média",
            totalTime: "Tempo Total",
            today: "hoje",
            ofTotal: "do total"
          },
          emptyState: {
            title: "Nenhuma Conexão Asterisk Configurada",
            description: "Para visualizar o histórico de chamadas, você precisa configurar pelo menos uma conexão Asterisk.",
            action: "Configurar Conexão"
          }
        },
        reports: {
          title: "Relatórios Asterisk",
          export: "Exportar",
          refreshChart: "Atualizar Gráfico",
          filters: {
            today: "Hoje",
            yesterday: "Ontem",
            thisWeek: "Esta Semana",
            lastWeek: "Semana Passada",
            thisMonth: "Este Mês",
            lastMonth: "Mês Passado",
            custom: "Personalizado"
          },
          startDate: "Data Início",
          endDate: "Data Fim",
          reportType: "Tipo de Relatório",
          types: {
            overview: "Visão Geral",
            performance: "Performance",
            usage: "Uso",
            quality: "Qualidade"
          },
          groupBy: "Agrupar Por",
          groupByOptions: {
            hour: "Hora",
            day: "Dia",
            week: "Semana",
            month: "Mês"
          },
          format: "Formato",
          exportTitle: "Exportar Relatório",
          exportOptionsLabel: "Opções de Exportação",
          exportOptions: {
            includeSummary: "Incluir Resumo",
            includeCharts: "Incluir Gráficos",
            includeDetails: "Incluir Detalhes",
            includeKPIs: "Incluir KPIs"
          },
          kpis: {
            totalCalls: "Total de Chamadas",
            answerRate: "Taxa de Atendimento",
            avgDuration: "Duração Média",
            missedCalls: "Chamadas Perdidas",
            target: "Meta",
            total: "total",
            ofTotal: "do total"
          },
          charts: {
            callTrends: "Tendência de Chamadas",
            callDistribution: "Distribuição de Chamadas",
            callsByEndpoint: "Chamadas por Endpoint",
            callsByHour: "Chamadas por Hora"
          },
          topPerformers: "Top Performers",
          calls: "chamadas",
          alerts: "Alertas",
          noAlerts: "Nenhum alerta no momento"
        },
      },
      helpCenter: {
        title: "Central de Ajuda",
        welcome: "Como podemos ajudar?",
        subtitle: "Encontre guias, tutoriais e documentação completa do sistema",
        sidebarSubtitle: "Encontre respostas para suas dúvidas",
        search: "Buscar artigos...",
        searchPlaceholder: "Buscar na documentação...",
        noCategories: "Nenhuma categoria disponível",
        article: "artigo",
        articles: "artigos",
        articlesAvailable: "artigos disponíveis",
        views: "visualizações",
        wasHelpful: "Este artigo foi útil?",
        yes: "Sim",
        no: "Não",
        thanksFeedback: "Obrigado pelo seu feedback!",
        helpful: "acharam útil",
        notHelpful: "não acharam útil",
        articleNotFound: "Artigo não encontrado",
        categoryNotFound: "Categoria não encontrada",
        relatedArticles: "Artigos Relacionados",
        lastUpdated: "Última atualização",
        subcategories: "Subcategorias",
        noContentYet: "Ainda não há conteúdo aqui",
        contentComingSoon: "O conteúdo será adicionado em breve",
        categories: {
          gettingStarted: "Primeiros Passos",
          service: "Atendimento",
          automation: "Automações",
          sales: "Vendas",
          reports: "Relatórios",
          settings: "Configurações",
          integrations: "Integrações",
          administration: "Administração"
        }
      },
      helpAdmin: {
        title: "Gerenciar Artigos de Ajuda",
        newArticle: "Novo Artigo",
        editArticle: "Editar Artigo",
        searchPlaceholder: "Buscar artigos...",
        articleCreated: "Artigo criado com sucesso!",
        articleUpdated: "Artigo atualizado com sucesso!",
        articleDeleted: "Artigo excluído com sucesso!",
        confirmDeleteTitle: "Excluir Artigo",
        confirmDeleteMessage: "Tem certeza que deseja excluir este artigo? Esta ação não pode ser desfeita.",
        table: {
          title: "Título",
          category: "Categoria",
          status: "Status",
          views: "Visualizações",
          actions: "Ações"
        },
        buttons: {
          edit: "Editar",
          delete: "Excluir",
          save: "Salvar"
        },
        form: {
          category: "Categoria",
          slug: "Slug (URL)",
          status: "Status",
          order: "Ordem"
        }
      },
      sdr: {
        title: "IA SDR",
        searchPlaceholder: "Buscar campanhas...",
        downloadTemplate: "Baixar Template",
        uploadLeads: "Importar Leads",
        qualified: "qualif.",
        meetings: "reuniões",
        conversion: "conv.",
        viewLeads: "Ver Leads",
        leads: {
          title: "Leads da Campanha",
          searchPlaceholder: "Buscar leads...",
          total: "Total",
          qualified: "Qualificados",
          contacted: "Contatados",
          linkedin: "LinkedIn",
          noLeads: "Nenhum lead encontrado",
          tabs: {
            all: "Todos",
            qualified: "Qualificados",
            contacted: "Contatados",
            responded: "Respondidos",
            disqualified: "Desqualificados"
          },
          table: {
            name: "Nome",
            company: "Empresa",
            title: "Cargo",
            contact: "Contato",
            score: "Score",
            status: "Status",
            lastContact: "Último Contato",
            actions: "Ações"
          },
          status: {
            pending: "Pendente",
            qualified: "Qualificado",
            contacted: "Contatado",
            responded: "Respondeu",
            disqualified: "Desqualificado",
            meeting_scheduled: "Reunião Agendada"
          },
          actions: {
            requalify: "Requalificar",
            contact: "Entrar em Contato",
            schedule: "Agendar Reunião"
          },
          toasts: {
            requalified: "Lead requalificado com sucesso!",
            deleted: "Lead removido com sucesso!"
          }
        },
        tabs: {
          campaigns: "Campanhas",
          analytics: "Analytics"
        },
        stats: {
          totalCampaigns: "Total de Campanhas",
          totalLeads: "Total de Leads",
          qualifiedLeads: "Leads Qualificados",
          meetingsScheduled: "Reuniões Agendadas"
        },
        campaignStatus: {
          draft: "Rascunho",
          active: "Ativa",
          paused: "Pausada",
          completed: "Concluída",
          archived: "Arquivada"
        },
        table: {
          name: "Nome",
          status: "Status",
          leads: "Leads",
          qualified: "Qualificados",
          meetings: "Reuniões",
          actions: "Ações"
        },
        analytics: {
          coming: "Analytics em Desenvolvimento",
          description: "Relatórios detalhados de performance das campanhas estarão disponíveis em breve."
        },
        modal: {
          createTitle: "Nova Campanha SDR",
          editTitle: "Editar Campanha SDR",
          basicInfo: "Informações Básicas",
          name: "Nome da Campanha",
          description: "Descrição",
          status: "Status",
          assistant: "Assistente IA",
          noAssistant: "Nenhum assistente",
          targetCriteria: "Critérios de Segmentação",
          location: "Localização",
          maxResults: "Máximo de Resultados",
          keywords: "Palavras-chave",
          addJobTitle: "Adicionar Cargo",
          addIndustry: "Adicionar Indústria",
          messageSequence: "Sequência de Mensagens",
          messageType: "Tipo de Mensagem",
          delayDays: "Delay (dias)",
          messageSubject: "Assunto",
          messageContent: "Conteúdo",
          addMessage: "Adicionar Mensagem",
          validation: {
            nameRequired: "Nome da campanha é obrigatório"
          }
        },
        messageTypes: {
          initial_contact: "Contato Inicial",
          follow_up: "Follow-up",
          meeting_request: "Solicitação de Reunião"
        },
        upload: {
          title: "Importar Leads",
          selectCampaign: "Selecionar Campanha",
          dropFileHere: "Clique ou arraste o arquivo aqui",
          supportedFormats: "Formatos suportados: CSV, XLS, XLSX",
          maxFileSize: "Tamanho máximo: 10MB",
          options: "Opções de Importação",
          skipDuplicates: "Pular leads duplicados",
          validateEmails: "Validar emails",
          processing: "Processando arquivo...",
          results: "Resultados da Importação",
          imported: "importados",
          skipped: "ignorados",
          duplicates: "duplicatas",
          errors: "erros",
          errorDetails: "Detalhes dos Erros",
          row: "Linha",
          moreErrors: "E mais {{count}} erros...",
          upload: "Importar",
          invalidFileType: "Tipo de arquivo não suportado. Use CSV, XLS ou XLSX.",
          fileTooLarge: "Arquivo muito grande. Máximo 10MB.",
          validation: {
            missingFields: "Selecione uma campanha e um arquivo para continuar."
          }
        },
        toasts: {
          campaignCreated: "Campanha criada com sucesso!",
          campaignUpdated: "Campanha atualizada com sucesso!",
          campaignDeleted: "Campanha removida com sucesso!",
          templateDownloaded: "Template baixado com sucesso!"
        },
        confirmationModal: {
          deleteCampaign: {
            title: "Confirmar Exclusão",
            message: "Tem certeza que deseja excluir a campanha '{{name}}'? Esta ação não pode ser desfeita."
          }
        },
        campaigns: {
          title: "Campanhas SDR",
          searchPlaceholder: "Buscar campanhas...",
          buttons: {
            add: "Nova Campanha",
            upload: "Importar Leads",
            viewLeads: "Ver Leads"
          },
          table: {
            name: "Nome",
            status: "Status",
            totalProspects: "Total Leads",
            qualified: "Qualificados",
            contacted: "Contatados",
            startDate: "Data Início",
            actions: "Ações"
          },
          status: {
            active: "Ativa",
            paused: "Pausada",
            completed: "Concluída",
            draft: "Rascunho"
          },
          toasts: {
            deleted: "Campanha removida com sucesso!",
            deletedTitle: "Campanha Removida"
          },
          confirmationModal: {
            deleteTitle: "Excluir campanha",
            deleteMessage: "Tem certeza que deseja excluir esta campanha? Esta ação não pode ser desfeita."
          }
        }
      },
      nappSettings: {
        sections: {
          basicConfig: "Configuração Básica",
          automation: "Automação",
          notifications: "Notificações",
          ticketCreation: "Criação de Tickets"
        },
        fields: {
          integrationToken: "Token de Integração",
          syncInterval: "Intervalo de Sincronização",
          feedLimit: "Limite de Pedidos",
          active: "Ativo",
          enableNotifications: "Habilitar Notificações",
          autoCreateContacts: "Criar Contatos Automaticamente",
          autoCreateTickets: "Criar Tickets Automaticamente"
        },
        help: {
          integrationToken: "Token fornecido pela NAPP Solutions para integração",
          syncInterval: "Intervalo em minutos para sincronização automática de pedidos",
          feedLimit: "Número máximo de pedidos para buscar em cada sincronização",
          notificationStatuses: "Selecione os status de pedido que devem gerar notificações",
          ticketStatuses: "Selecione os status de pedido que devem criar tickets automaticamente"
        },
        status: {
          invalidConfig: "Configuração Inválida",
          notConfigured: "Não Configurado",
          testingConnection: "Testando conexão com NAPP..."
        },
        errors: {
          testFailed: "Falha no teste de conexão",
          fetchFailed: "Falha ao buscar dados"
        },
        actions: {
          saveConfig: "Salvar Configuração",
          testConnection: "Testar Conexão"
        }
      },
      utm: {
        filters: {
          source: "Fonte UTM",
          campaign: "Campanha UTM",
          loading: "Carregando...",
          noSources: "Nenhuma fonte encontrada",
          noCampaigns: "Nenhuma campanha encontrada"
        },
        generator: {
          title: "Gerador de Links UTM",
          recipientData: "Dados do Destinatário",
          phoneNumber: "Número do WhatsApp",
          phoneHelper: "Formato: 5511999999999 (código do país + DDD + número)",
          message: "Mensagem (Opcional)",
          messageHelper: "Mensagem pré-preenchida no WhatsApp",
          messagePlaceholder: "Olá! Vim através do link...",
          requiredParams: "Parâmetros UTM Obrigatórios",
          source: "Fonte (utm_source)",
          sourceHelper: "Origem do tráfego (ex: facebook, google, instagram)",
          campaign: "Campanha (utm_campaign)",
          campaignHelper: "Nome da campanha (ex: promo_blackfriday, lancamento_produto)",
          optionalParams: "Parâmetros UTM Opcionais",
          medium: "Meio (utm_medium)",
          mediumHelper: "Tipo de mídia (ex: cpc, banner, email)",
          term: "Termo (utm_term)",
          termHelper: "Palavras-chave de pesquisa paga",
          content: "Conteúdo (utm_content)",
          contentHelper: "Diferenciar anúncios (ex: variacao_a, botao_azul)",
          generateLink: "Gerar Link",
          generatedLink: "Link Gerado",
          copyLink: "Copiar Link",
          openWhatsApp: "Abrir no WhatsApp",
          linkCopied: "Link copiado para a área de transferência!",
          createdLinks: "Links Criados",
          noLinks: "Nenhum link criado ainda",
          validation: {
            phoneRequired: "Número do WhatsApp é obrigatório",
            sourceRequired: "Fonte (utm_source) é obrigatória",
            campaignRequired: "Campanha (utm_campaign) é obrigatória",
            fillRequired: "Preencha todos os campos obrigatórios"
          }
        },
        dashboard: {
          title: "Dashboard UTM",
          period: "Período de Análise",
          dateStart: "Data Inicial",
          dateEnd: "Data Final",
          loadReport: "Carregar Relatório",
          cards: {
            totalContacts: "Total de Contatos",
            totalTickets: "Total de Tickets",
            totalSources: "Fontes Únicas",
            totalCampaigns: "Campanhas Únicas"
          },
          metricsTable: "Métricas Detalhadas",
          export: "Exportar CSV",
          noData: "Nenhum dado encontrado para o período selecionado",
          noDataToExport: "Não há dados para exportar",
          exportSuccess: "Relatório exportado com sucesso!",
          table: {
            source: "Fonte",
            campaign: "Campanha",
            contacts: "Contatos",
            tickets: "Tickets",
            open: "Abertos",
            closed: "Fechados",
            firstContact: "Primeiro Contato",
            lastContact: "Último Contato"
          }
        }
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_NO_WHATSAPP_CONNECTION:
          "Nenhuma conexão de WhatsApp ativa encontrada. Para salvar contatos, é necessário ter pelo menos uma conexão de WhatsApp ativa na empresa.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
        ERR_COMPANY_NOT_FOUND: "Empresa não encontrada.",
        ERR_COMPANY_NO_PLAN: "Empresa não possui plano associado.",
        ERR_CATALOG_NOT_ALLOWED_IN_PLAN: "O catálogo de produtos não está disponível no seu plano atual.",
        ERR_NO_DEFAULT_WHATSAPP_FOUND: "Nenhuma conexão WhatsApp padrão foi encontrada. Configure uma conexão padrão em Conexões."
      }
    }
  }
};

export { messages };
